// Generated file - do not modify.
// Generated from DevPortal.resjson

import { Culture } from "./Culture";

export class Resources {
    private static _currentCultureName;
    private static _currentResources: { [key: string]: string };

    static get unsupportedBrowser_Azure(): string { return this._getResourceString("unsupportedBrowser_Azure"); }
    static get unsupportedBrowser(): string { return this._getResourceString("unsupportedBrowser"); }
    static get botKindRegistration(): string { return this._getResourceString("botKindRegistration"); }
    static get botKindSdk(): string { return this._getResourceString("botKindSdk"); }
    static get botKindFunctions(): string { return this._getResourceString("botKindFunctions"); }
    static get botKindConversationDesigner(): string { return this._getResourceString("botKindConversationDesigner"); }
    static get loggingIn(): string { return this._getResourceString("loggingIn"); }
    static get loadingBot(): string { return this._getResourceString("loadingBot"); }
    static get botIsNotReady(): string { return this._getResourceString("botIsNotReady"); }
    static get analyticsNotReady(): string { return this._getResourceString("analyticsNotReady"); }
    static get authorizingWebChat(): string { return this._getResourceString("authorizingWebChat"); }
    static get signInFailure(): string { return this._getResourceString("signInFailure"); }
    static get getChatTokenFailure(): string { return this._getResourceString("getChatTokenFailure"); }
    static get refreshSignInFailure(): string { return this._getResourceString("refreshSignInFailure"); }
    static get xhrResponse_400(): string { return this._getResourceString("xhrResponse_400"); }
    static get xhrResponse_403(): string { return this._getResourceString("xhrResponse_403"); }
    static get xhrResponse_404(): string { return this._getResourceString("xhrResponse_404"); }
    static get xhrResponse_500(): string { return this._getResourceString("xhrResponse_500"); }
    static get xhrResponse_501(): string { return this._getResourceString("xhrResponse_501"); }
    static get xhrResponse_Message(): string { return this._getResourceString("xhrResponse_Message"); }
    static get xhrResponse_Unknown(): string { return this._getResourceString("xhrResponse_Unknown"); }
    static get AddAFeaturedChannelTitle(): string { return this._getResourceString("AddAFeaturedChannelTitle"); }
    static get ConnectToChannelsTitle(): string { return this._getResourceString("ConnectToChannelsTitle"); }
    static get NoChannelsConfigured(): string { return this._getResourceString("NoChannelsConfigured"); }
    static get MoreChannelsTitle(): string { return this._getResourceString("MoreChannelsTitle"); }
    static get test(): string { return this._getResourceString("test"); }
    static get startOver(): string { return this._getResourceString("startOver"); }
    static get retentionTitle(): string { return this._getResourceString("retentionTitle"); }
    static get retentionDescription(): string { return this._getResourceString("retentionDescription"); }
    static get retentionHeader(): string { return this._getResourceString("retentionHeader"); }
    static get retentionDate(): string { return this._getResourceString("retentionDate"); }
    static get retentionUsers(): string { return this._getResourceString("retentionUsers"); }
    static get undetermined(): string { return this._getResourceString("undetermined"); }
    static get loading(): string { return this._getResourceString("loading"); }
    static get noAnalyticsData(): string { return this._getResourceString("noAnalyticsData"); }
    static get timespanLastHour(): string { return this._getResourceString("timespanLastHour"); }
    static get timespanLastDay(): string { return this._getResourceString("timespanLastDay"); }
    static get timespanLastWeek(): string { return this._getResourceString("timespanLastWeek"); }
    static get timespanLastMonth(): string { return this._getResourceString("timespanLastMonth"); }
    static get timespanLast90Days(): string { return this._getResourceString("timespanLast90Days"); }
    static get timespanUnknown(): string { return this._getResourceString("timespanUnknown"); }
    static get timelineCardUsersTitle(): string { return this._getResourceString("timelineCardUsersTitle"); }
    static get timelineCardMessagesTitle(): string { return this._getResourceString("timelineCardMessagesTitle"); }
    static get totalsCardTitle(): string { return this._getResourceString("totalsCardTitle"); }
    static get analyticsNotConfigured(): string { return this._getResourceString("analyticsNotConfigured"); }
    static get analyticsNotConfiguredAction(): string { return this._getResourceString("analyticsNotConfiguredAction"); }
    static get analyticsNotConfiguredActionIbiza(): string { return this._getResourceString("analyticsNotConfiguredActionIbiza"); }
    static get learnMore(): string { return this._getResourceString("learnMore"); }
    static get cardTitleLoading(): string { return this._getResourceString("cardTitleLoading"); }
    static get cardTitleError(): string { return this._getResourceString("cardTitleError"); }
    static get timelineTableLabel(): string { return this._getResourceString("timelineTableLabel"); }
    static get timelineChartLabel(): string { return this._getResourceString("timelineChartLabel"); }
    static get published(): string { return this._getResourceString("published"); }
    static get health(): string { return this._getResourceString("health"); }
    static get actions(): string { return this._getResourceString("actions"); }
    static get channelname(): string { return this._getResourceString("channelname"); }
    static get edit(): string { return this._getResourceString("edit"); }
    static get running(): string { return this._getResourceString("running"); }
    static get issuesTemplate(): string { return this._getResourceString("issuesTemplate"); }
    static get warningTemplate(): string { return this._getResourceString("warningTemplate"); }
    static get channelPublished(): string { return this._getResourceString("channelPublished"); }
    static get tryOnCortana(): string { return this._getResourceString("tryOnCortana"); }
    static get tryOnChannel(): string { return this._getResourceString("tryOnChannel"); }
    static get manageInCortana(): string { return this._getResourceString("manageInCortana"); }
    static get channelRejected(): string { return this._getResourceString("channelRejected"); }
    static get channelMoreDetails(): string { return this._getResourceString("channelMoreDetails"); }
    static get channelResubmit(): string { return this._getResourceString("channelResubmit"); }
    static get channelGetEmbedCodes(): string { return this._getResourceString("channelGetEmbedCodes"); }
    static get channelConfigDeleteMessage(): string { return this._getResourceString("channelConfigDeleteMessage"); }
    static get channelConfigDeleteHeader(): string { return this._getResourceString("channelConfigDeleteHeader"); }
    static get channelConfigDeleteOk(): string { return this._getResourceString("channelConfigDeleteOk"); }
    static get channelConfigDeleteCancel(): string { return this._getResourceString("channelConfigDeleteCancel"); }
    static get channelConfigLeaveMessage(): string { return this._getResourceString("channelConfigLeaveMessage"); }
    static get channelConfigLeaveHeader(): string { return this._getResourceString("channelConfigLeaveHeader"); }
    static get channelConfigLeaveOk(): string { return this._getResourceString("channelConfigLeaveOk"); }
    static get channelConfigLeaveCancel(): string { return this._getResourceString("channelConfigLeaveCancel"); }
    static get channelEdit(): string { return this._getResourceString("channelEdit"); }
    static get dialogPleaseWait(): string { return this._getResourceString("dialogPleaseWait"); }
    static get embedPanelTitle(): string { return this._getResourceString("embedPanelTitle"); }
    static get embedPanelDescription(): string { return this._getResourceString("embedPanelDescription"); }
    static get embedPanelFacebookFooter(): string { return this._getResourceString("embedPanelFacebookFooter"); }
    static get embedPanelLearnMore(): string { return this._getResourceString("embedPanelLearnMore"); }
    static get embedPanelChannelMovedHeader(): string { return this._getResourceString("embedPanelChannelMovedHeader"); }
    static get embedPanelChannelMovedInstructions(): string { return this._getResourceString("embedPanelChannelMovedInstructions"); }
    static get embedPanelEmbedcodeForChannelLabel(): string { return this._getResourceString("embedPanelEmbedcodeForChannelLabel"); }
    static get embedPanelGettingCodes(): string { return this._getResourceString("embedPanelGettingCodes"); }
    static get embedPanelNoCodeAvailable(): string { return this._getResourceString("embedPanelNoCodeAvailable"); }
    static get channelIssuesPanelSubtitle(): string { return this._getResourceString("channelIssuesPanelSubtitle"); }
    static get channelIssuesPanelClearall(): string { return this._getResourceString("channelIssuesPanelClearall"); }
    static get channelIssuesPanelTimeColumnLabel(): string { return this._getResourceString("channelIssuesPanelTimeColumnLabel"); }
    static get channelIssuesPanelMessageColumnLabel(): string { return this._getResourceString("channelIssuesPanelMessageColumnLabel"); }
    static get channelIssuesPanelCorrelationIdColumnLabel(): string { return this._getResourceString("channelIssuesPanelCorrelationIdColumnLabel"); }
    static get unsavedChangesWillBeLost(): string { return this._getResourceString("unsavedChangesWillBeLost"); }
    static get altImageChannel(): string { return this._getResourceString("altImageChannel"); }
    static get Bing(): string { return this._getResourceString("Bing"); }
    static get Cortana(): string { return this._getResourceString("Cortana"); }
    static get MicrosoftSearch(): string { return this._getResourceString("MicrosoftSearch"); }
    static get DirectLine(): string { return this._getResourceString("DirectLine"); }
    static get Email(): string { return this._getResourceString("Email"); }
    static get FacebookMessenger(): string { return this._getResourceString("FacebookMessenger"); }
    static get GroupMe(): string { return this._getResourceString("GroupMe"); }
    static get Kaizala(): string { return this._getResourceString("Kaizala"); }
    static get Kik(): string { return this._getResourceString("Kik"); }
    static get MicrosoftTeams(): string { return this._getResourceString("MicrosoftTeams"); }
    static get Skype(): string { return this._getResourceString("Skype"); }
    static get SkypeforBusiness(): string { return this._getResourceString("SkypeforBusiness"); }
    static get _SkypeforBusiness(): string { return this._getResourceString("_SkypeforBusiness"); }
    static get Slack(): string { return this._getResourceString("Slack"); }
    static get Telegram(): string { return this._getResourceString("Telegram"); }
    static get Twilio(): string { return this._getResourceString("Twilio"); }
    static get migrationBannerCTAMigrateBot(): string { return this._getResourceString("migrationBannerCTAMigrateBot"); }
    static get migrationBannerCTAStartMigrating(): string { return this._getResourceString("migrationBannerCTAStartMigrating"); }
    static get migrationBannerBlurb1(): string { return this._getResourceString("migrationBannerBlurb1"); }
    static get migrationBannerBlurb2(): string { return this._getResourceString("migrationBannerBlurb2"); }
    static get migrationBannerSuggestedBlurb(): string { return this._getResourceString("migrationBannerSuggestedBlurb"); }
    static get migrationBannerPostDeadlineBlurb(): string { return this._getResourceString("migrationBannerPostDeadlineBlurb"); }
    static get migrationBannerBlockedBlurb(): string { return this._getResourceString("migrationBannerBlockedBlurb"); }
    static get migrationWillBeRequiredDialogMessage(): string { return this._getResourceString("migrationWillBeRequiredDialogMessage"); }
    static get channelRequiresMigrationDialogMessage(): string { return this._getResourceString("channelRequiresMigrationDialogMessage"); }
    static get channelRequiresABSBot(): string { return this._getResourceString("channelRequiresABSBot"); }
    static get botRequiresMigrationDialogHeader(): string { return this._getResourceString("botRequiresMigrationDialogHeader"); }
    static get botRequiresMigrationDialogMessage(): string { return this._getResourceString("botRequiresMigrationDialogMessage"); }
    static get yesMigrateThisBot(): string { return this._getResourceString("yesMigrateThisBot"); }
    static get myBotsMigrationStatusMigrated(): string { return this._getResourceString("myBotsMigrationStatusMigrated"); }
    static get myBotsMigrationStatusNotMigrated(): string { return this._getResourceString("myBotsMigrationStatusNotMigrated"); }
    static get myBotsMigrationStatusOptionalMigration(): string { return this._getResourceString("myBotsMigrationStatusOptionalMigration"); }
    static get myBotsMigrationButtonMigrate(): string { return this._getResourceString("myBotsMigrationButtonMigrate"); }
    static get myBotsMigrationButtonRollback(): string { return this._getResourceString("myBotsMigrationButtonRollback"); }
    static get deleteBotDialogDeleteButtonText(): string { return this._getResourceString("deleteBotDialogDeleteButtonText"); }
    static get cancelButtonText(): string { return this._getResourceString("cancelButtonText"); }
    static get deleteBotDialogTitleText(): string { return this._getResourceString("deleteBotDialogTitleText"); }
    static get deleteBotDialogBodyText(): string { return this._getResourceString("deleteBotDialogBodyText"); }
    static get deleteBotDialogStatusDeleting(): string { return this._getResourceString("deleteBotDialogStatusDeleting"); }
    static get deleteBotDialogStatusDeleted(): string { return this._getResourceString("deleteBotDialogStatusDeleted"); }
    static get rollbackBotDialogRollbackButtonText(): string { return this._getResourceString("rollbackBotDialogRollbackButtonText"); }
    static get rollbackBotDialogTitleText(): string { return this._getResourceString("rollbackBotDialogTitleText"); }
    static get rollbackBotDialogBodyText(): string { return this._getResourceString("rollbackBotDialogBodyText"); }
    static get rollbackBotDialogErrorInfo(): string { return this._getResourceString("rollbackBotDialogErrorInfo"); }
    static get rollbackBotDialogErrorNoEndpoint(): string { return this._getResourceString("rollbackBotDialogErrorNoEndpoint"); }
    static get rollbackBotDialogErrorNoAzureToken(): string { return this._getResourceString("rollbackBotDialogErrorNoAzureToken"); }
    static get rollbackBotDialogStatusGettingInfo(): string { return this._getResourceString("rollbackBotDialogStatusGettingInfo"); }
    static get rollbackBotDialogStatusPreparing(): string { return this._getResourceString("rollbackBotDialogStatusPreparing"); }
    static get rollbackBotDialogStatusReverting(): string { return this._getResourceString("rollbackBotDialogStatusReverting"); }
    static get rollbackBotDialogStatusDeletingApp(): string { return this._getResourceString("rollbackBotDialogStatusDeletingApp"); }
    static get rollbackBotDialogStatusDeletingDeployment(): string { return this._getResourceString("rollbackBotDialogStatusDeletingDeployment"); }
    static get rollbackBotDialogConfirmationTitleText(): string { return this._getResourceString("rollbackBotDialogConfirmationTitleText"); }
    static get rollbackBotDialogConfirmationBodyText(): string { return this._getResourceString("rollbackBotDialogConfirmationBodyText"); }
    static get okButtonText(): string { return this._getResourceString("okButtonText"); }
    static get errorMessageErrorOccurred(): string { return this._getResourceString("errorMessageErrorOccurred"); }
    static get migrationDialogStatusGettingBotInfo(): string { return this._getResourceString("migrationDialogStatusGettingBotInfo"); }
    static get migrationDialogStatusGettingAzureInfo(): string { return this._getResourceString("migrationDialogStatusGettingAzureInfo"); }
    static get migrationDialogStatusGettingAppSettings(): string { return this._getResourceString("migrationDialogStatusGettingAppSettings"); }
    static get migrationDialogStatusDeployingMigrationBot(): string { return this._getResourceString("migrationDialogStatusDeployingMigrationBot"); }
    static get migrationDialogStatusRegisteringWithAzure(): string { return this._getResourceString("migrationDialogStatusRegisteringWithAzure"); }
    static get migrationDialogStatusUpdatingBotRecord(): string { return this._getResourceString("migrationDialogStatusUpdatingBotRecord"); }
    static get migrationDialogStatusCreatingRG(): string { return this._getResourceString("migrationDialogStatusCreatingRG"); }
    static get migrationDialogStatusMigratingFiles(): string { return this._getResourceString("migrationDialogStatusMigratingFiles"); }
    static get migrationDialogStatusWrappingUp(): string { return this._getResourceString("migrationDialogStatusWrappingUp"); }
    static get migrationDialogStatusDeployingStorage(): string { return this._getResourceString("migrationDialogStatusDeployingStorage"); }
    static get migrationDialogStatusDeployingSite(): string { return this._getResourceString("migrationDialogStatusDeployingSite"); }
    static get migrationDialogStatusConfiguringSite(): string { return this._getResourceString("migrationDialogStatusConfiguringSite"); }
    static get migrationDialogStatusDeploying(): string { return this._getResourceString("migrationDialogStatusDeploying"); }
    static get migrationDialogStatusFunctionCredentials(): string { return this._getResourceString("migrationDialogStatusFunctionCredentials"); }
    static get migrationDialogErrorNoSubs(): string { return this._getResourceString("migrationDialogErrorNoSubs"); }
    static get migrationDialogErrorNoAzureToken(): string { return this._getResourceString("migrationDialogErrorNoAzureToken"); }
    static get migrationDialogErrorNoLocations(): string { return this._getResourceString("migrationDialogErrorNoLocations"); }
    static get migrationDialogErrorNoAzureStorage(): string { return this._getResourceString("migrationDialogErrorNoAzureStorage"); }
    static get migrationDialogErrorAppNameUnavailable(): string { return this._getResourceString("migrationDialogErrorAppNameUnavailable"); }
    static get migrationDialogErrorAppNameInvalid(): string { return this._getResourceString("migrationDialogErrorAppNameInvalid"); }
    static get migrationDialogErrorNoBotType(): string { return this._getResourceString("migrationDialogErrorNoBotType"); }
    static get migrationDialogErrorBotInvalid(): string { return this._getResourceString("migrationDialogErrorBotInvalid"); }
    static get migrationDialogErrorEndpointMissing(): string { return this._getResourceString("migrationDialogErrorEndpointMissing"); }
    static get migrationDialogErrorProvisionInfoMissing(): string { return this._getResourceString("migrationDialogErrorProvisionInfoMissing"); }
    static get migrationDialogErrorResourceGroupNameMissing(): string { return this._getResourceString("migrationDialogErrorResourceGroupNameMissing"); }
    static get migrationDialogErrorSubscriptionIdMissing(): string { return this._getResourceString("migrationDialogErrorSubscriptionIdMissing"); }
    static get migrationDialogErrorSiteNameMissing(): string { return this._getResourceString("migrationDialogErrorSiteNameMissing"); }
    static get migrationDialogABSv2TitleText(): string { return this._getResourceString("migrationDialogABSv2TitleText"); }
    static get migrationDialogABSv2BodyText(): string { return this._getResourceString("migrationDialogABSv2BodyText"); }
    static get migrationDialogRegistrationBodyText(): string { return this._getResourceString("migrationDialogRegistrationBodyText"); }
    static get migrationDialogFailedTokenRefresh(): string { return this._getResourceString("migrationDialogFailedTokenRefresh"); }
    static get migrationDialogRefreshPage(): string { return this._getResourceString("migrationDialogRefreshPage"); }
    static get migrationSubscriptionDisabled(): string { return this._getResourceString("migrationSubscriptionDisabled"); }
    static get migrationTenantHasNoSubscriptions(): string { return this._getResourceString("migrationTenantHasNoSubscriptions"); }
    static get migrationDialogFuncPackBotTitle(): string { return this._getResourceString("migrationDialogFuncPackBotTitle"); }
    static get migrationDialogFuncPackBotMessage(): string { return this._getResourceString("migrationDialogFuncPackBotMessage"); }
    static get migrationDialogFuncPackBotLinkText(): string { return this._getResourceString("migrationDialogFuncPackBotLinkText"); }
    static get tosDialog_Header(): string { return this._getResourceString("tosDialog_Header"); }
    static get tosDialog_AgreeButton(): string { return this._getResourceString("tosDialog_AgreeButton"); }
    static get tosDialog_MessageChannels(): string { return this._getResourceString("tosDialog_MessageChannels"); }
    static get tosDialog_MessageMigration(): string { return this._getResourceString("tosDialog_MessageMigration"); }
    static get tosDialog_AzureTermsCheckbox(): string { return this._getResourceString("tosDialog_AzureTermsCheckbox"); }
    static get tosDialog_CortanaTermsCheckbox(): string { return this._getResourceString("tosDialog_CortanaTermsCheckbox"); }
    static get tosDialog_CombinedTermsCheckboxOneChannel(): string { return this._getResourceString("tosDialog_CombinedTermsCheckboxOneChannel"); }
    static get tosDialog_CombinedTermsCheckboxMultiChannels(): string { return this._getResourceString("tosDialog_CombinedTermsCheckboxMultiChannels"); }
    static get tosDialog_ABSTerms(): string { return this._getResourceString("tosDialog_ABSTerms"); }
    static get tosDialog_MSKnowledgeGraphTerms(): string { return this._getResourceString("tosDialog_MSKnowledgeGraphTerms"); }
    static get tosDialog_MSPublicationTerms(): string { return this._getResourceString("tosDialog_MSPublicationTerms"); }
    static get tosDialog_MSPrivacyStatement(): string { return this._getResourceString("tosDialog_MSPrivacyStatement"); }
    static get notice(): string { return this._getResourceString("notice"); }
    static get listElem(): string { return this._getResourceString("listElem"); }
    static get andListEnd(): string { return this._getResourceString("andListEnd"); }
    static get analyticsChannelsDropdown(): string { return this._getResourceString("analyticsChannelsDropdown"); }
    static get analyticsPeriodDropdown(): string { return this._getResourceString("analyticsPeriodDropdown"); }
    static get deprecatedChannel(): string { return this._getResourceString("deprecatedChannel"); }
    static get openInComposer(): string { return this._getResourceString("openInComposer"); }
    static get downloadComposer(): string { return this._getResourceString("downloadComposer"); }
    static get deprecatedWarning(): string { return this._getResourceString("deprecatedWarning"); }
    static get warningText(): string { return this._getResourceString("warningText"); }

    private static _getResourceString(key: string) {
        this._loadResourcesIfNeeded();

        if (this._currentCultureName !== "en") {
            const localizedResource = this._currentResources[key];
            if (localizedResource !== undefined) {
                return localizedResource;
            }
        }
        return Resources_en[key];
    }

    private static _loadResourcesIfNeeded() {
        const cultureName = Culture.Lang;

        if (cultureName === undefined) {
            this._currentResources = Resources_en;
            this._currentCultureName = "en";
        }
        else if (cultureName !== this._currentCultureName) {
            const resources = ResourcesMap[cultureName.toLowerCase()];
            if (resources) {
                this._currentResources = resources;
            }
            else {
                this._currentResources = Resources_en;
            }

            this._currentCultureName = cultureName;
        }
    }
}

interface IResources { [key: string]: string };

const Resources_en: IResources = {
    "unsupportedBrowser_Azure": "The Azure Bot Service doesn't support your browser yet.",
    "unsupportedBrowser": "Bot Framework doesn't support your browser yet.",
    "botKindRegistration": "Bot Services Bot",
    "botKindSdk": "Web App Bot",
    "botKindFunctions": "Functions Bot",
    "botKindConversationDesigner": "Conversation Designer Bot",
    "loggingIn": "Logging in",
    "loadingBot": "Loading bot...",
    "botIsNotReady": "Waiting for bot to be ready",
    "analyticsNotReady": "Waiting for Application Insights to be configured",
    "authorizingWebChat": "Authorizing Chat with Bot",
    "signInFailure": "There was an error signing you in. Make sure third party cookies are enabled in the browser.",
    "getChatTokenFailure": "There was an error getting a Chat authorization token. Refresh and try again.",
    "refreshSignInFailure": "There was an error refreshing your sign-in information. Make sure third party cookies are enabled in the browser.",
    "xhrResponse_400": "The action or the supplied values are invalid.",
    "xhrResponse_403": "This item cannot be accessed or modified.",
    "xhrResponse_404": "The item cannot be found.",
    "xhrResponse_500": "An internal error occurred at the server.",
    "xhrResponse_501": "This operation is not supported.",
    "xhrResponse_Message": "Error: %1",
    "xhrResponse_Unknown": "An unknown error occurred.",
    "AddAFeaturedChannelTitle": "Add a featured channel",
    "ConnectToChannelsTitle": "Connect to channels",
    "NoChannelsConfigured": "You haven't connected any channels yet. Select a channel to connect.",
    "MoreChannelsTitle": "More channels",
    "test": "Test",
    "startOver": "Start over",
    "retentionTitle": "Retention",
    "retentionDescription": "% users who messaged again (last 10 days)",
    "retentionHeader": "Days later",
    "retentionDate": "Date",
    "retentionUsers": "Users",
    "undetermined": "Undetermined",
    "loading": "loading...",
    "noAnalyticsData": "no data",
    "timespanLastHour": "Last Hour",
    "timespanLastDay": "Last Day",
    "timespanLastWeek": "Last Week",
    "timespanLastMonth": "Last Month",
    "timespanLast90Days": "Last 90 Days",
    "timespanUnknown": "Unknown timespan",
    "timelineCardUsersTitle": "Users",
    "timelineCardMessagesTitle": "Activities",
    "totalsCardTitle": "Grand Totals",
    "analyticsNotConfigured": "You haven't enabled Analytics via Azure Application Insights yet.",
    "analyticsNotConfiguredAction": "Provide your Application Insights Keys and ID for this bot in the following page: ",
    "analyticsNotConfiguredActionIbiza": "Provide your Application Insights Keys and ID for this bot on the settings page.",
    "learnMore": "Learn more",
    "cardTitleLoading": "%1 - %2",
    "cardTitleError": "%1 - error: %2",
    "timelineTableLabel": "Timeline table mapping %1 by time",
    "timelineChartLabel": "Timeline chart mapping %1 by time",
    "published": "Published",
    "health": "Health",
    "actions": "Actions",
    "channelname": "Name",
    "edit": "Edit",
    "running": "Running",
    "issuesTemplate": "Issues (<%= length %>)",
    "warningTemplate": "Warnings (<%= length %>)",
    "channelPublished": "Published",
    "tryOnCortana": "Try on <%= Name %> - learn how",
    "tryOnChannel": "Try on <%= Name %>",
    "manageInCortana": "Manage in Cortana dashboard",
    "channelRejected": "Rejected",
    "channelMoreDetails": "More details",
    "channelResubmit": "Re-submit for review...",
    "channelGetEmbedCodes": "Get bot embed codes",
    "channelConfigDeleteMessage": "This action will delete all channel configuration information. Are you sure you want to proceed?",
    "channelConfigDeleteHeader": "Delete channel",
    "channelConfigDeleteOk": "Yes, delete it",
    "channelConfigDeleteCancel": "No, keep it",
    "channelConfigLeaveMessage": "You have unsaved changes in this document. Are you sure you want to navigate away from this page?",
    "channelConfigLeaveHeader": "Discard changes",
    "channelConfigLeaveOk": "Yes, leave page",
    "channelConfigLeaveCancel": "No, stay on page",
    "channelEdit": "Edit",
    "dialogPleaseWait": "Please wait...",
    "embedPanelTitle": "Bot embed code",
    "embedPanelDescription": "Choose a channel to get the embed code for it. Copy and paste the code to your website.",
    "embedPanelFacebookFooter": "In order to use this embed Facebook requires you to include their JavaScript SDK in your page.",
    "embedPanelLearnMore": "Learn more.",
    "embedPanelChannelMovedHeader": "Embed code for %1 has moved",
    "embedPanelChannelMovedInstructions": "Click here to open the %1 configuration page",
    "embedPanelEmbedcodeForChannelLabel": "Embed code for %1",
    "embedPanelGettingCodes": "Getting codes...",
    "embedPanelNoCodeAvailable": "No embed code available for this bot.",
    "channelIssuesPanelSubtitle": "Recent issues",
    "channelIssuesPanelClearall": "Clear All",
    "channelIssuesPanelTimeColumnLabel": "Time",
    "channelIssuesPanelMessageColumnLabel": "Message",
    "channelIssuesPanelCorrelationIdColumnLabel": "Correlation ID",
    "unsavedChangesWillBeLost": "Unsaved changes will be lost.",
    "altImageChannel": "Configure %1 channel",
    "Bing": "Bing",
    "Cortana": "Cortana",
    "MicrosoftSearch": "Microsoft Search",
    "DirectLine": "Direct Line",
    "Email": "Email",
    "FacebookMessenger": "Facebook Messenger",
    "GroupMe": "GroupMe",
    "Kaizala": "Kaizala",
    "Kik": "Kik",
    "MicrosoftTeams": "Microsoft Teams",
    "Skype": "Skype",
    "SkypeforBusiness": "Skype for business",
    "_SkypeforBusiness": "Skype for business brand",
    "Slack": "Slack",
    "Telegram": "Telegram",
    "Twilio": "Twilio (SMS)",
    "migrationBannerCTAMigrateBot": "MIGRATE THIS BOT",
    "migrationBannerCTAStartMigrating": "START MIGRATING",
    "migrationBannerBlurb1": "With the launch of the new Azure Bot Service, we are migrating all bots to the new service by 3/31/2018.",
    "migrationBannerBlurb2": "about the migration.",
    "migrationBannerSuggestedBlurb": "Migration to Azure Bot Service is optional for this bot.",
    "migrationBannerPostDeadlineBlurb": "Bots requiring migration to Azure Bot Service must migrate now to avoid service interruption.",
    "migrationBannerBlockedBlurb": "Bot migration is past due, please migrate it now to avoid service interruption.",
    "migrationWillBeRequiredDialogMessage": "If you configure this channel, your bot will be required to migrate to Azure Bot Service by 3/31/2018. Are you sure you want to configure this channel?",
    "channelRequiresMigrationDialogMessage": "This channel is only available to bots in Azure Bot Service. Do you want to migrate this bot?",
    "channelRequiresABSBot": "This channel is only available to bots in Azure Bot Service.",
    "botRequiresMigrationDialogHeader": "Bot requires migration",
    "botRequiresMigrationDialogMessage": "Bot migration is past due, please migrate it now to avoid service interruption.",
    "yesMigrateThisBot": "Yes, migrate this bot",
    "myBotsMigrationStatusMigrated": "Migrated",
    "myBotsMigrationStatusNotMigrated": "Required",
    "myBotsMigrationStatusOptionalMigration": "Not required",
    "myBotsMigrationButtonMigrate": "Migrate",
    "myBotsMigrationButtonRollback": "Roll back migration",
    "deleteBotDialogDeleteButtonText": "Delete bot",
    "cancelButtonText": "Cancel",
    "deleteBotDialogTitleText": "You are about to delete this bot",
    "deleteBotDialogBodyText": "This action will erase all data associated with this bot and cannot be undone. Are you sure?",
    "deleteBotDialogStatusDeleting": "Deleting bot...",
    "deleteBotDialogStatusDeleted": "Bot deleted",
    "rollbackBotDialogRollbackButtonText": "Yes, roll back",
    "rollbackBotDialogTitleText": "Are you sure you want to roll back?",
    "rollbackBotDialogBodyText": "This action will roll back the migration completely and you will have to start the migration process from the start. Are you sure you want to proceed?",
    "rollbackBotDialogErrorInfo": "Error retrieving bot information from server.",
    "rollbackBotDialogErrorNoEndpoint": "Cannot perform rollback. No rollback endpoint found.",
    "rollbackBotDialogErrorNoAzureToken": "Cannot perform rollback. Failed to find an Azure Token to contact Azure.",
    "rollbackBotDialogStatusGettingInfo": "Gathering bot info...",
    "rollbackBotDialogStatusPreparing": "Preparing bot...",
    "rollbackBotDialogStatusReverting": "Reverting bot..",
    "rollbackBotDialogStatusDeletingApp": "Deleting upgraded app...",
    "rollbackBotDialogStatusDeletingDeployment": "Deleting deployment record...",
    "rollbackBotDialogConfirmationTitleText": "Rollback completed",
    "rollbackBotDialogConfirmationBodyText": "has been successfully rolled back.",
    "okButtonText": "Ok",
    "errorMessageErrorOccurred": "An error occurred",
    "migrationDialogStatusGettingBotInfo": "Getting bot info...",
    "migrationDialogStatusGettingAzureInfo": "Getting Azure info...",
    "migrationDialogStatusGettingAppSettings": "Getting bot app settings...",
    "migrationDialogStatusDeployingMigrationBot": "Initializing migrated bot...",
    "migrationDialogStatusRegisteringWithAzure": "Registering Bot Service with Azure...",
    "migrationDialogStatusUpdatingBotRecord": "Updating bot record...",
    "migrationDialogStatusCreatingRG": "Creating resource group...",
    "migrationDialogStatusMigratingFiles": "Migrating files to new bot...",
    "migrationDialogStatusWrappingUp": "Wrapping up deployment...",
    "migrationDialogStatusDeployingStorage": "Connecting bot to existing storage...",
    "migrationDialogStatusDeployingSite": "Deploying web site",
    "migrationDialogStatusConfiguringSite": "Configuring web site",
    "migrationDialogStatusDeploying": "Deploying",
    "migrationDialogStatusFunctionCredentials": "Getting new function app credentials...",
    "migrationDialogErrorNoSubs": "Failed to find any Azure subscriptions for the current user.",
    "migrationDialogErrorNoAzureToken": "Failed to find Azure access token for the current user.",
    "migrationDialogErrorNoLocations": "Failed to find any locations for the selected Azure subscription.",
    "migrationDialogErrorNoAzureStorage": "Failed to find an Azure storage account name in the app config.",
    "migrationDialogErrorAppNameUnavailable": "App name is not available.",
    "migrationDialogErrorAppNameInvalid": "Invalid app name.",
    "migrationDialogErrorNoBotType": "Current bot does not have a valid type.",
    "migrationDialogErrorBotInvalid": "This bot cannot be migrated because the bot is invalid.",
    "migrationDialogErrorEndpointMissing": "This bot cannot be migrated because the endpoint is missing.",
    "migrationDialogErrorProvisionInfoMissing": "This bot cannot be migrated because the provisioning info is missing.",
    "migrationDialogErrorResourceGroupNameMissing": "This bot cannot be migrated because the resource group name is missing.",
    "migrationDialogErrorSubscriptionIdMissing": "This bot cannot be migrated because the Azure subscription id is missing.",
    "migrationDialogErrorSiteNameMissing": "This bot cannot be migrated because the Azure site name is missing.",
    "migrationDialogABSv2TitleText": "Migration unavailable",
    "migrationDialogABSv2BodyText": "Migration is currently disabled for Conversation Designer (ABSv2) bots.",
    "migrationDialogRegistrationBodyText": "Migration is currently disabled for '{0}' bots.",
    "migrationDialogFailedTokenRefresh": "Azure token has expired.",
    "migrationDialogRefreshPage": "Please refresh the page and retry migration.",
    "migrationSubscriptionDisabled": "The selected Azure subscription is disabled. Please enable to continue migration.",
    "migrationTenantHasNoSubscriptions": "This directory doesn't contain any subscription.",
    "migrationDialogFuncPackBotTitle": "Azure Functions Pack is required in order to migrate this bot",
    "migrationDialogFuncPackBotMessage": "Node Functions bots need to be packaged with Azure Functions Pack before they can be migrated.",
    "migrationDialogFuncPackBotLinkText": "Learn how to run Azure Functions Pack on your bot code",
    "tosDialog_Header": "Terms of Service",
    "tosDialog_AgreeButton": "Agree",
    "tosDialog_MessageChannels": "The Online Services Terms do not apply to publication on channels. For example, terms for publication on Microsoft channels do not offer data processing terms.",
    "tosDialog_MessageMigration": "Please read and agree to the following terms.",
    "tosDialog_AzureTermsCheckbox": "I agree that the use of the Bot Framework site is subject to the {0} and the {1}.",
    "tosDialog_CortanaTermsCheckbox": "I agree to the {0} and the {1} for my deployment to the Cortana channel.",
    "tosDialog_CombinedTermsCheckboxOneChannel": "I agree to the {0} and the {1} for my deployment to the <%= channelslist %> channel.",
    "tosDialog_CombinedTermsCheckboxMultiChannels": "I agree to the {0} and the {1} for my deployment to the <%= channelslist %> channels.",
    "tosDialog_ABSTerms": "terms of my subscription for Azure Bot Service",
    "tosDialog_MSKnowledgeGraphTerms": "Cortana Channel Publication Terms",
    "tosDialog_MSPublicationTerms": "Microsoft Channel Publication Terms",
    "tosDialog_MSPrivacyStatement": "Microsoft Privacy Statements",
    "notice": " NOTICE: ",
    "listElem": "{0}, ",
    "andListEnd": "{0} and {1}",
    "analyticsChannelsDropdown": "Channels filter",
    "analyticsPeriodDropdown": "Time period",
    "deprecatedChannel": "(deprecated)",
    "openInComposer": "open in composer",
    "downloadComposer": "Download composer",
    "deprecatedWarning": "This page will be deprecated on June 17, 2022. You can setup and configure the channel through updated Channels blade.",
    "warningText": "Warning"
}

const Resources_de: IResources = {
    "unsupportedBrowser_Azure": "Ihr Browser wird vom Azure Bot Service noch nicht unterstützt.",
    "unsupportedBrowser": "Ihr Browser wird von Bot Framework noch nicht unterstützt.",
    "botKindRegistration": "Bot Services Bot",
    "botKindSdk": "Web App Bot",
    "botKindFunctions": "Functions Bot",
    "botKindConversationDesigner": "Conversation Designer Bot",
    "loggingIn": "Anmeldung wird ausgeführt.",
    "loadingBot": "Bot wird geladen...",
    "botIsNotReady": "Es wird darauf gewartet, dass der Bot bereit ist.",
    "analyticsNotReady": "Es wird auf den Abschluss der Application Insights-Konfiguration gewartet.",
    "authorizingWebChat": "Chat mit Bot wird autorisiert.",
    "signInFailure": "Es gab einen Fehler bei der Anmeldung. Stellen Sie sicher, dass Cookies von Drittanbietern im Browser aktiviert sind.",
    "getChatTokenFailure": "Beim Empfangen eines Chat-Autorisierungstokens ist ein Fehler aufgetreten. Aktualisieren Sie das Fenster, und wiederholen Sie den Vorgang.",
    "refreshSignInFailure": "Es gab einen Fehler bei der Aktualisierung Ihrer Anmeldeinformationen. Stellen Sie sicher, dass Cookies von Drittanbietern im Browser aktiviert sind.",
    "xhrResponse_400": "Die Aktion oder die bereitgestellten Werte sind ungültig.",
    "xhrResponse_403": "Für dieses Element sind weder Zugriff noch Änderung möglich.",
    "xhrResponse_404": "Das Element wurde nicht gefunden.",
    "xhrResponse_500": "Auf dem Server ist ein interner Fehler aufgetreten.",
    "xhrResponse_501": "Dieser Vorgang wird nicht unterstützt.",
    "xhrResponse_Message": "Fehler: %1",
    "xhrResponse_Unknown": "Es ist ein unbekannter Fehler aufgetreten.",
    "AddAFeaturedChannelTitle": "Einen ausgewählten Kanal hinzufügen",
    "ConnectToChannelsTitle": "Mit Kanälen verbinden",
    "NoChannelsConfigured": "Sie haben noch keine Kanäle verbunden. Wählen Sie einen Kanal aus, den Sie verbinden möchten.",
    "MoreChannelsTitle": "Weitere Kanäle",
    "test": "Test",
    "startOver": "Von vorne",
    "retentionTitle": "Aufbewahrung",
    "retentionDescription": "% Benutzer, die erneut eine Nachricht gesendet haben (letzte 10 Tage)",
    "retentionHeader": "Tage später",
    "retentionDate": "Datum",
    "retentionUsers": "Benutzer",
    "undetermined": "Unbestimmt",
    "loading": "Wird geladen...",
    "noAnalyticsData": "Keine Daten",
    "timespanLastHour": "Letzte Stunde",
    "timespanLastDay": "Letzter Tag",
    "timespanLastWeek": "Letzte Woche",
    "timespanLastMonth": "Letzter Monat",
    "timespanLast90Days": "Letzte 90 Tage",
    "timespanUnknown": "Unbekannter Zeitraum",
    "timelineCardUsersTitle": "Benutzer",
    "timelineCardMessagesTitle": "Aktivitäten",
    "totalsCardTitle": "Gesamtzahlen",
    "analyticsNotConfigured": "Sie haben Analytics noch nicht über Azure Application Insights aktiviert.",
    "analyticsNotConfiguredAction": "Geben Sie auf der folgenden Seite Ihre Application Insights-Schlüssel und -ID für diesen Bot an: ",
    "analyticsNotConfiguredActionIbiza": "Geben Sie Ihre Application Insights-Schlüssel und -ID für diesen Bot auf der Einstellungsseite an.",
    "learnMore": "Weitere Informationen",
    "cardTitleLoading": "%1 – %2",
    "cardTitleError": "%1 – Fehler: %2",
    "timelineTableLabel": "Zuordnung der Zeitachsentabelle \"%1\" nach Zeit",
    "timelineChartLabel": "Zuordnung des Zeitachsendiagramm \"%1\" nach Zeit",
    "published": "Veröffentlicht",
    "health": "Gesundheit",
    "channelname": "Name",
    "edit": "Bearbeiten",
    "running": "Wird ausgeführt",
    "issuesTemplate": "Probleme (<%= length %>)",
    "warningTemplate": "Warnungen (<%= length %>)",
    "channelPublished": "Veröffentlicht",
    "tryOnCortana": "Test in <%= Name %> – Erfahren Sie, wie",
    "tryOnChannel": "Test in <%= Name %>",
    "manageInCortana": "Im Cortana-Dashboard verwalten",
    "channelRejected": "Zurückgewiesen",
    "channelMoreDetails": "Weitere Details",
    "channelResubmit": "Erneut zur Prüfung übermitteln...",
    "channelGetEmbedCodes": "Bot-Einbettungscode abrufen",
    "channelConfigDeleteMessage": "Durch diese Aktion werden alle Informationen zur Kanalkonfiguration gelöscht. Möchten Sie wirklich fortfahren?",
    "channelConfigDeleteHeader": "Kanal löschen",
    "channelConfigDeleteOk": "Ja, löschen",
    "channelConfigDeleteCancel": "Nein, nicht löschen",
    "channelConfigLeaveMessage": "Dieses Dokument enthält nicht gespeicherte Änderungen. Möchten Sie diese Seite wirklich verlassen?",
    "channelConfigLeaveHeader": "Änderungen verwerfen",
    "channelConfigLeaveOk": "Ja, Seite verlassen",
    "channelConfigLeaveCancel": "Nein, auf der Seite bleiben",
    "channelEdit": "Bearbeiten",
    "dialogPleaseWait": "Bitte warten...",
    "embedPanelTitle": "Bot-Einbettungscode",
    "embedPanelDescription": "Wählen Sie einen Kanal, um den Einbettungscode für diesen abzurufen. Kopieren Sie den Code, und fügen Sie ihn in Ihre Website ein.",
    "embedPanelFacebookFooter": "Um diesen Einbettungscode für Facebook verwenden zu können, müssen Sie den JavaScript-SDK von Facebook in Ihre Seite integrieren.",
    "embedPanelLearnMore": "Weitere Informationen",
    "embedPanelChannelMovedHeader": "Der Einbettungscode für %1 wurde verschoben.",
    "embedPanelChannelMovedInstructions": "Klicken Sie hier, um die %1-Konfigurationsseite zu öffnen.",
    "embedPanelEmbedcodeForChannelLabel": "Einbettungscode für %1",
    "embedPanelGettingCodes": "Codes werden abgerufen...",
    "embedPanelNoCodeAvailable": "Für diesen Bot ist kein Einbettungscode verfügbar.",
    "channelIssuesPanelSubtitle": "Aktuelle Probleme",
    "channelIssuesPanelClearall": "Alle löschen",
    "channelIssuesPanelTimeColumnLabel": "Zeit",
    "channelIssuesPanelMessageColumnLabel": "Nachricht",
    "channelIssuesPanelCorrelationIdColumnLabel": "Korrelations-ID",
    "unsavedChangesWillBeLost": "Nicht gespeicherte Änderungen gehen verloren.",
    "altImageChannel": "%1 Kanal konfigurieren",
    "Bing": "Bing",
    "Cortana": "Cortana",
    "MicrosoftSearch": "Microsoft Search",
    "DirectLine": "Direct Line",
    "Email": "E-Mail",
    "FacebookMessenger": "Facebook Messenger",
    "GroupMe": "GroupMe",
    "Kaizala": "Kaizala",
    "Kik": "Kik",
    "MicrosoftTeams": "Microsoft Teams",
    "Skype": "Skype",
    "SkypeforBusiness": "Skype for Business",
    "_SkypeforBusiness": "Skype for Business-Marke",
    "Slack": "Slack",
    "Telegram": "Telegram",
    "Twilio": "Twilio (SMS)",
    "migrationBannerCTAMigrateBot": "MIGRIEREN SIE DIESEN BOT",
    "migrationBannerCTAStartMigrating": "STARTEN SIE DIE MIGRATION",
    "migrationBannerBlurb1": "Nach dem Start des neuen Azure Bot Service werden alle Bots bis zum 31.03.2018 zum neuen Dienst migriert.",
    "migrationBannerBlurb2": "Informationen zur Migration.",
    "migrationBannerSuggestedBlurb": "Die Migration auf den Azure Bot Service ist für diesen Bot optional.",
    "migrationBannerPostDeadlineBlurb": "Bots, für die eine Migration auf Azure Bot Service erforderlich ist, müssen jetzt migriert werden, um eine Dienstunterbrechung zu vermeiden.",
    "migrationBannerBlockedBlurb": "Die Bot-Migration ist überfällig. Bitte migrieren Sie ihn jetzt, um Dienstunterbrechungen zu vermeiden.",
    "migrationWillBeRequiredDialogMessage": "Wenn Sie diesen Kanal konfigurieren, muss Ihr Bot bis zum 31.3.2018 auf Azure Bot Service migriert werden. Möchten Sie diesen Kanal wirklich konfigurieren?",
    "channelRequiresMigrationDialogMessage": "Dieser Kanal ist nur für Bots in Azure Bot Service verfügbar. Möchten Sie diesen Bot migrieren?",
    "channelRequiresABSBot": "Dieser Kanal ist nur für Bots in Azure Bot Service verfügbar.",
    "botRequiresMigrationDialogHeader": "Bot-Migration erforderlich",
    "botRequiresMigrationDialogMessage": "Die Bot-Migration ist überfällig. Bitte migrieren Sie ihn jetzt, um Dienstunterbrechungen zu vermeiden.",
    "yesMigrateThisBot": "Ja, diesen Bot migrieren",
    "myBotsMigrationStatusMigrated": "Migriert",
    "myBotsMigrationStatusNotMigrated": "Pflichtfeld",
    "myBotsMigrationStatusOptionalMigration": "Nicht erforderlich",
    "myBotsMigrationButtonMigrate": "Migrieren",
    "myBotsMigrationButtonRollback": "Rollback für Migration ausführen",
    "deleteBotDialogDeleteButtonText": "Bot löschen",
    "cancelButtonText": "Abbrechen",
    "deleteBotDialogTitleText": "Sie sind im Begriff, diesen Bot zu löschen.",
    "deleteBotDialogBodyText": "Durch diese Aktion werden alle mit diesem Bot verknüpften Daten gelöscht. Dieser Vorgang kann nicht rückgängig gemacht werden. Möchten Sie den Bot wirklich löschen?",
    "deleteBotDialogStatusDeleting": "Bot wird gelöscht...",
    "deleteBotDialogStatusDeleted": "Bot gelöscht",
    "rollbackBotDialogRollbackButtonText": "Ja, Rollback ausführen",
    "rollbackBotDialogTitleText": "Möchten Sie das Rollback wirklich ausführen?",
    "rollbackBotDialogBodyText": "Durch diese Aktion wird ein vollständiges Rollback für die Migration ausgeführt, und Sie müssen mit dem Migrationsprozess von vorne beginnen. Möchten Sie den Vorgang wirklich fortsetzen?",
    "rollbackBotDialogErrorInfo": "Fehler beim Abrufen der Botinformationen vom Server.",
    "rollbackBotDialogErrorNoEndpoint": "Das Rollback kann nicht ausgeführt werden. Es wurde kein Endpunkt für das Rollback gefunden.",
    "rollbackBotDialogErrorNoAzureToken": "Das Rollback kann nicht ausgeführt werden. Es wurde kein Azure-Token gefunden, um eine Verbindung mit Azure herstellen zu können.",
    "rollbackBotDialogStatusGettingInfo": "Botinformationen werden gesammelt...",
    "rollbackBotDialogStatusPreparing": "Bot wird vorbereitet...",
    "rollbackBotDialogStatusReverting": "Bot wird zurückgesetzt...",
    "rollbackBotDialogStatusDeletingApp": "Aktualisierte App wird gelöscht...",
    "rollbackBotDialogStatusDeletingDeployment": "Bereitstellungsdatensatz wird gelöscht...",
    "rollbackBotDialogConfirmationTitleText": "Rollback abgeschlossen",
    "rollbackBotDialogConfirmationBodyText": "-Rollback wurde erfolgreich ausgeführt.",
    "okButtonText": "OK",
    "errorMessageErrorOccurred": "Es ist ein Fehler aufgetreten.",
    "migrationDialogStatusGettingBotInfo": "Botinformationen werden abgerufen...",
    "migrationDialogStatusGettingAzureInfo": "Azure-Informationen werden abgerufen...",
    "migrationDialogStatusGettingAppSettings": "Einstellungen der Bot-App werden abgerufen...",
    "migrationDialogStatusDeployingMigrationBot": "Migrierter Bot wird initialisiert...",
    "migrationDialogStatusRegisteringWithAzure": "Botdienst wird bei Azure registriert...",
    "migrationDialogStatusUpdatingBotRecord": "Botdatensatz wird aktualisiert...",
    "migrationDialogStatusCreatingRG": "Ressourcengruppe wird erstellt...",
    "migrationDialogStatusMigratingFiles": "Dateien werden zum neuen Bot migriert...",
    "migrationDialogStatusWrappingUp": "Bereitstellung wird fertig gestellt...",
    "migrationDialogStatusDeployingStorage": "Bot wird mit vorhandenem Speicher verbunden...",
    "migrationDialogStatusDeployingSite": "Website wird bereitgestellt",
    "migrationDialogStatusConfiguringSite": "Website wird konfiguriert",
    "migrationDialogStatusDeploying": "Bereitstellung wird ausgeführt",
    "migrationDialogStatusFunctionCredentials": "Anmeldeinformationen für neue Functions-App werden abgerufen...",
    "migrationDialogErrorNoSubs": "Es wurden keine Azure-Abonnements für den aktuellen Benutzer gefunden.",
    "migrationDialogErrorNoAzureToken": "Es wurde kein Azure-Zugriffstoken für den aktuellen Benutzer gefunden.",
    "migrationDialogErrorNoLocations": "Es wurden keine Standorte für das ausgewählte Azure-Abonnement gefunden.",
    "migrationDialogErrorNoAzureStorage": "Es wurde kein Azure-Speicherkontoname in der App-Konfiguration gefunden.",
    "migrationDialogErrorAppNameUnavailable": "Der App-Name ist nicht verfügbar.",
    "migrationDialogErrorAppNameInvalid": "Ungültiger App-Name.",
    "migrationDialogErrorNoBotType": "Der aktuelle Bot hat keinen gültigen Typ.",
    "migrationDialogErrorBotInvalid": "Dieser Bot kann nicht migriert werden, da es sich um einen ungültigen Bot handelt.",
    "migrationDialogErrorEndpointMissing": "Dieser Bot kann nicht migriert werden, da der Endpunkt fehlt.",
    "migrationDialogErrorProvisionInfoMissing": "Dieser Bot kann nicht migriert werden, da die Bereitstellungsinformationen fehlen.",
    "migrationDialogErrorResourceGroupNameMissing": "Dieser Bot kann nicht migriert werden, da der Ressourcengruppenname fehlt.",
    "migrationDialogErrorSubscriptionIdMissing": "Dieser Bot kann nicht migriert werden, da die ID des Azure-Abonnements fehlt.",
    "migrationDialogErrorSiteNameMissing": "Dieser Bot kann nicht migriert werden, da der Name der Azure-Site fehlt.",
    "migrationDialogABSv2TitleText": "Migration nicht verfügbar",
    "migrationDialogABSv2BodyText": "Die Migration von Conversation Designer (ABSv2)-Bots ist zurzeit deaktiviert.",
    "migrationDialogRegistrationBodyText": "Migrationen von {0}-Bots sind zurzeit deaktiviert.",
    "migrationDialogFailedTokenRefresh": "Das Azure-Token ist abgelaufen.",
    "migrationDialogRefreshPage": "Aktualisieren Sie die Seite, und wiederholen Sie die Migration.",
    "migrationSubscriptionDisabled": "Das ausgewählte Azure-Abonnement ist deaktiviert. Aktivieren Sie es, um die Migration fortzusetzen.",
    "migrationTenantHasNoSubscriptions": "Dieses Verzeichnis enthält kein Abonnement.",
    "migrationDialogFuncPackBotTitle": "Ein Azure Functions-Paket ist erforderlich, um diesen Bot zu migrieren.",
    "migrationDialogFuncPackBotMessage": "Node Functions-Bots müssen mit dem Azure Functions-Paket verpackt werden, bevor sie migriert werden können.",
    "migrationDialogFuncPackBotLinkText": "Erfahren Sie, wie Sie das Azure Functions-Paket auf Ihrem Bot-Code ausführen",
    "tosDialog_Header": "Nutzungsbedingungen",
    "tosDialog_AgreeButton": "Zustimmen",
    "tosDialog_MessageChannels": "Die Online Services-Nutzungsbedingungen gelten nicht für Veröffentlichungen in Kanälen. Die Nutzungsbedingungen für Veröffentlichungen in Microsoft-Kanälen enthalten beispielsweise keine Bestimmungen für die Verarbeitung von Daten.",
    "tosDialog_MessageMigration": "Lesen Sie die folgenden Nutzungsbedingungen, und stimmen Sie ihnen zu.",
    "tosDialog_AzureTermsCheckbox": "Ich stimme zu, dass die Verwendung der Bot Framework-Website den {0} und den {1} unterliegt.",
    "tosDialog_CortanaTermsCheckbox": "Ich stimme den {0} und den {1} für meine Bereitstellung im Cortana-Kanal zu.",
    "tosDialog_CombinedTermsCheckboxOneChannel": "Ich stimme den {0} und den {1} für meine Bereitstellung im folgenden Kanal zu: <%= channelslist %>.",
    "tosDialog_CombinedTermsCheckboxMultiChannels": "Ich stimme den {0} und den {1} für meine Bereitstellung in folgenden Kanälen zu: <%= channelslist %>.",
    "tosDialog_ABSTerms": "Bestimmungen meines Azure Bot Service-Abonnements",
    "tosDialog_MSKnowledgeGraphTerms": "Cortana Channel Publication-Nutzungsbedingungen",
    "tosDialog_MSPublicationTerms": "Microsoft Channel Publication-Nutzungsbedingungen",
    "tosDialog_MSPrivacyStatement": "Microsoft-Datenschutzbestimmungen",
    "notice": " HINWEIS:",
    "listElem": "{0},",
    "andListEnd": "{0} und {1}",
    "analyticsChannelsDropdown": "Kanalfilter",
    "analyticsPeriodDropdown": "Zeitraum",
    "deprecatedChannel": "(veraltet)",
    "openInComposer": "In Composer öffnen",
    "downloadComposer": "Composer herunterladen",
}

const Resources_es: IResources = {
    "unsupportedBrowser_Azure": "Azure Bot Service todavía no es compatible con tu explorador.",
    "unsupportedBrowser": "Bot Framework todavía no es compatible con tu explorador.",
    "botKindRegistration": "Bot Services Bot",
    "botKindSdk": "Web App Bot",
    "botKindFunctions": "Functions Bot",
    "botKindConversationDesigner": "Conversation Designer Bot",
    "loggingIn": "Iniciando sesión",
    "loadingBot": "Cargando bot...",
    "botIsNotReady": "Esperando a que el bot esté listo",
    "analyticsNotReady": "Esperando a que se configure Application Insights",
    "authorizingWebChat": "Autorizando chat con el bot",
    "signInFailure": "Se produjo un error al iniciar sesión. Asegúrese de que las cookies de terceros estén habilitadas en el navegador.",
    "getChatTokenFailure": "Se produjo un error al obtener un token de autorización de chat. Actualice el proceso y vuelva a intentarlo.",
    "refreshSignInFailure": "Se produjo un error al actualizar la información de inicio de sesión. Asegúrate de que las cookies de terceros están habilitadas en el navegador.",
    "xhrResponse_400": "La acción o los valores proporcionados no son válidos.",
    "xhrResponse_403": "Este elemento no es accesible ni se puede modificar.",
    "xhrResponse_404": "No se puede encontrar el elemento.",
    "xhrResponse_500": "Se produjo un error interno en el servidor.",
    "xhrResponse_501": "Esta operación no se admite.",
    "xhrResponse_Message": "Error: %1",
    "xhrResponse_Unknown": "Se produjo un error desconocido.",
    "AddAFeaturedChannelTitle": "Agregar un canal destacado",
    "ConnectToChannelsTitle": "Conectarse a canales",
    "NoChannelsConfigured": "Todavía no te has conectado a ningún canal. Selecciona un canal al que quieras conectarte.",
    "MoreChannelsTitle": "Más canales",
    "test": "Prueba",
    "startOver": "Empezar de nuevo",
    "retentionTitle": "Retención",
    "retentionDescription": "% usuarios que volvieron a enviar el mensaje (en los últimos 10 días).",
    "retentionHeader": "Días después",
    "retentionDate": "Fecha",
    "retentionUsers": "Usuarios",
    "undetermined": "Sin determinar",
    "loading": "cargando...",
    "noAnalyticsData": "sin datos",
    "timespanLastHour": "La última hora",
    "timespanLastDay": "El último día",
    "timespanLastWeek": "La última semana",
    "timespanLastMonth": "El último mes",
    "timespanLast90Days": "Últimos 90 días",
    "timespanUnknown": "Intervalo de tiempo desconocido",
    "timelineCardUsersTitle": "Usuarios",
    "timelineCardMessagesTitle": "Actividades",
    "totalsCardTitle": "Totales generales",
    "analyticsNotConfigured": "Todavía no has habilitado Analytics mediante Azure Application Insights.",
    "analyticsNotConfiguredAction": "Da las claves de Application Insights y el id. del bot en la siguiente página:",
    "analyticsNotConfiguredActionIbiza": "Da las claves de Application Insights y el id. del bot en la página de configuración.",
    "learnMore": "Más información",
    "cardTitleLoading": "%1 - %2",
    "cardTitleError": "%1 - error: %2",
    "timelineTableLabel": "Asignación de tabla de escala de tiempo %1 por hora",
    "timelineChartLabel": "Asignación del gráfico de escala de tiempo %1 por hora",
    "published": "Publicado",
    "health": "Estado",
    "channelname": "Nombre",
    "edit": "Editar",
    "running": "En funcionamiento",
    "issuesTemplate": "Problemas (<%= length %>)",
    "warningTemplate": "Advertencias (<%= length %>)",
    "channelPublished": "Publicado",
    "tryOnCortana": "Probar en <%= Name %>: averigua cómo",
    "tryOnChannel": "Probar en <%= Name %>",
    "manageInCortana": "Administrar en el panel de Cortana",
    "channelRejected": "Rechazado",
    "channelMoreDetails": "Más detalles",
    "channelResubmit": "Volver a enviar para la revisión...",
    "channelGetEmbedCodes": "Obtener los códigos para insertar de los bots",
    "channelConfigDeleteMessage": "Esta acción eliminará toda la información de configuración del canal. ¿Estás seguro de que quieres continuar?",
    "channelConfigDeleteHeader": "Eliminar canal",
    "channelConfigDeleteOk": "Sí, quiero eliminarlo",
    "channelConfigDeleteCancel": "No, quiero guardarlo",
    "channelConfigLeaveMessage": "Tienes cambios sin guardar en este documento. ¿Estás seguro de que quieres salir de esta página?",
    "channelConfigLeaveHeader": "Descartar cambios",
    "channelConfigLeaveOk": "Sí, salir de la página",
    "channelConfigLeaveCancel": "No, permanecer en la página",
    "channelEdit": "Editar",
    "dialogPleaseWait": "Espera...",
    "embedPanelTitle": "Código para insertar del bot",
    "embedPanelDescription": "Elige un canal del cual obtener el código para insertar correspondiente. Copia y pega el código en tu sitio web.",
    "embedPanelFacebookFooter": "Para poder usar este código para insertar de Facebook, debes incluir el SDK de JavaScript en la página.",
    "embedPanelLearnMore": "Obtén más información.",
    "embedPanelChannelMovedHeader": "Se movió el código para insertar de %1.",
    "embedPanelChannelMovedInstructions": "Haz clic aquí para abrir la página de configuración %1.",
    "embedPanelEmbedcodeForChannelLabel": "Código para insertar de %1",
    "embedPanelGettingCodes": "Obteniendo los códigos...",
    "embedPanelNoCodeAvailable": "No hay código para insertar disponible para este bot.",
    "channelIssuesPanelSubtitle": "Problemas recientes",
    "channelIssuesPanelClearall": "Borrar todo",
    "channelIssuesPanelTimeColumnLabel": "Hora",
    "channelIssuesPanelMessageColumnLabel": "Mensaje",
    "channelIssuesPanelCorrelationIdColumnLabel": "Id. de correlación",
    "unsavedChangesWillBeLost": "Los cambios que no haya guardado se perderán.",
    "altImageChannel": "Configurar el canal %1",
    "Bing": "Bing",
    "Cortana": "Cortana",
    "MicrosoftSearch": "Microsoft Search",
    "DirectLine": "Direct Line",
    "Email": "Correo",
    "FacebookMessenger": "Facebook Messenger",
    "GroupMe": "GroupMe",
    "Kaizala": "Kaizala",
    "Kik": "Kik",
    "MicrosoftTeams": "Microsoft Teams",
    "Skype": "Skype",
    "SkypeforBusiness": "Skype Empresarial",
    "_SkypeforBusiness": "Marca de Skype Empresarial",
    "Slack": "Slack",
    "Telegram": "Telegram",
    "Twilio": "Twilio (SMS)",
    "migrationBannerCTAMigrateBot": "MIGRAR ESTE BOT",
    "migrationBannerCTAStartMigrating": "COMENZAR LA MIGRACIÓN",
    "migrationBannerBlurb1": "A raíz del lanzamiento del nuevo servicio Azure Bot Service, migraremos todos los bots al nuevo servicio antes del 31/03/2018.",
    "migrationBannerBlurb2": "sobre la migración.",
    "migrationBannerSuggestedBlurb": "La migración a Azure Bot Service es opcional para este bot.",
    "migrationBannerPostDeadlineBlurb": "Para evitar la interrupción del servicio, se deben migrar ahora los bots que requieren de migración a Azure Bot Service.",
    "migrationBannerBlockedBlurb": "La migración de bot se ha vencido. Realícela ahora para evitar la interrupción del servicio.",
    "migrationWillBeRequiredDialogMessage": "Si configura este canal, deberá migrar el bot a Azure Bot Service antes del 31/3/2018. ¿Confirma que quiere configurar este canal?",
    "channelRequiresMigrationDialogMessage": "Este canal solo está disponible para bots de Azure Bot Service. ¿Desea migrar este bot?",
    "channelRequiresABSBot": "Este canal solo está disponible para bots de Azure Bot Service.",
    "botRequiresMigrationDialogHeader": "Es necesario migrar el bot",
    "botRequiresMigrationDialogMessage": "La migración de bot se ha vencido. Realícela ahora para evitar la interrupción del servicio.",
    "yesMigrateThisBot": "Sí, migrar este bot",
    "myBotsMigrationStatusMigrated": "Migrado",
    "myBotsMigrationStatusNotMigrated": "Obligatorio",
    "myBotsMigrationStatusOptionalMigration": "No se requiere",
    "myBotsMigrationButtonMigrate": "Migrar",
    "myBotsMigrationButtonRollback": "Revertir migración",
    "deleteBotDialogDeleteButtonText": "Eliminar bot",
    "cancelButtonText": "Cancelar",
    "deleteBotDialogTitleText": "Está a punto de eliminar este bot",
    "deleteBotDialogBodyText": "Esta acción eliminará todos los datos relacionados con el bot y no se puede deshacer. ¿Está seguro?",
    "deleteBotDialogStatusDeleting": "Eliminando bot...",
    "deleteBotDialogStatusDeleted": "Bot eliminado",
    "rollbackBotDialogRollbackButtonText": "Sí, revertir",
    "rollbackBotDialogTitleText": "¿Seguro que quiere realizar la reversión?",
    "rollbackBotDialogBodyText": "Esta acción revertirá totalmente la migración y tendrá que volver a iniciar el proceso desde cero. ¿Seguro que quiere continuar?",
    "rollbackBotDialogErrorInfo": "Error al recuperar la información del bot desde el servidor.",
    "rollbackBotDialogErrorNoEndpoint": "No se puede realizar la reversión porque no se encontró ningún punto de conexión de reversión.",
    "rollbackBotDialogErrorNoAzureToken": "No se puede realizar la reversión porque no se pudo encontrar ningún token de Azure para contactar con Azure.",
    "rollbackBotDialogStatusGettingInfo": "Obteniendo la información del bot...",
    "rollbackBotDialogStatusPreparing": "Preparando el bot...",
    "rollbackBotDialogStatusReverting": "Revirtiendo el bot...",
    "rollbackBotDialogStatusDeletingApp": "Eliminando la aplicación actualizada...",
    "rollbackBotDialogStatusDeletingDeployment": "Eliminando el registro de implementaciones...",
    "rollbackBotDialogConfirmationTitleText": "Reversión completada",
    "rollbackBotDialogConfirmationBodyText": "se revirtió correctamente.",
    "okButtonText": "Aceptar",
    "errorMessageErrorOccurred": "Se produjo un error.",
    "migrationDialogStatusGettingBotInfo": "Obteniendo la información del bot...",
    "migrationDialogStatusGettingAzureInfo": "Obteniendo la información de Azure...",
    "migrationDialogStatusGettingAppSettings": "Obteniendo la configuración de la aplicación Bot...",
    "migrationDialogStatusDeployingMigrationBot": "Inicializando el bot migrado...",
    "migrationDialogStatusRegisteringWithAzure": "Registrando Bot Service con Azure...",
    "migrationDialogStatusUpdatingBotRecord": "Actualizando el registro de bots...",
    "migrationDialogStatusCreatingRG": "Creando el grupo de recursos...",
    "migrationDialogStatusMigratingFiles": "Migrando archivos al nuevo bot...",
    "migrationDialogStatusWrappingUp": "Ajustando la implementación...",
    "migrationDialogStatusDeployingStorage": "Conectando el bot al almacenamiento existente...",
    "migrationDialogStatusDeployingSite": "Implementando el sitio web",
    "migrationDialogStatusConfiguringSite": "Configurando el sitio web",
    "migrationDialogStatusDeploying": "Implementando",
    "migrationDialogStatusFunctionCredentials": "Obteniendo las nuevas credenciales de Function App...",
    "migrationDialogErrorNoSubs": "No se pudo encontrar ninguna suscripción de Azure del usuario actual.",
    "migrationDialogErrorNoAzureToken": "No se pudo encontrar el token de acceso de Azure del usuario actual.",
    "migrationDialogErrorNoLocations": "No se pudo encontrar ninguna ubicación para la suscripción de Azure seleccionada.",
    "migrationDialogErrorNoAzureStorage": "No se pudo encontrar ningún nombre para la cuenta de almacenamiento de Azure en la configuración de la aplicación.",
    "migrationDialogErrorAppNameUnavailable": "El nombre de la aplicación no está disponible.",
    "migrationDialogErrorAppNameInvalid": "El nombre de la aplicación no es válido.",
    "migrationDialogErrorNoBotType": "El bot actual no tiene ningún tipo válido.",
    "migrationDialogErrorBotInvalid": "No se puede migrar este bot porque no es válido.",
    "migrationDialogErrorEndpointMissing": "No se puede migrar este bot porque falta el punto de conexión.",
    "migrationDialogErrorProvisionInfoMissing": "No se puede migrar este bot porque falta la información de aprovisionamiento.",
    "migrationDialogErrorResourceGroupNameMissing": "No se puede migrar este bot porque falta el nombre del grupo de recursos.",
    "migrationDialogErrorSubscriptionIdMissing": "No se puede migrar este bot porque falta el id. de la suscripción de Azure.",
    "migrationDialogErrorSiteNameMissing": "No se puede migrar este bot porque falta el nombre del sitio de Azure.",
    "migrationDialogABSv2TitleText": "La migración no está disponible",
    "migrationDialogABSv2BodyText": "La migración está deshabilitada para los bots del diseñador de conversaciones (ABSv2).",
    "migrationDialogRegistrationBodyText": "En estos momentos la migración de los bots \"{0}\" está deshabilitada.",
    "migrationDialogFailedTokenRefresh": "El token de Azure ha expirado.",
    "migrationDialogRefreshPage": "Actualice la página y vuelva a intentar la migración.",
    "migrationSubscriptionDisabled": "La suscripción de Azure seleccionada está deshabilitada. Habilítala para continuar con la migración.",
    "migrationTenantHasNoSubscriptions": "El directorio no contiene ninguna suscripción.",
    "migrationDialogFuncPackBotTitle": "Azure Functions Pack es necesario para migrar este bot.",
    "migrationDialogFuncPackBotMessage": "Los bots de Node Functions deben empaquetarse con Azure Functions Pack para poder migrarlos.",
    "migrationDialogFuncPackBotLinkText": "Aprende a ejecutar Azure Functions Pack en el código del bot.",
    "tosDialog_Header": "Términos del servicio",
    "tosDialog_AgreeButton": "Aceptar",
    "tosDialog_MessageChannels": "Los términos de Online Services no se aplican a la publicación de canales. Por ejemplo, los términos para la publicación de canales de Microsoft no ofrecen términos dedicados al procesamiento de datos.",
    "tosDialog_MessageMigration": "Lea y acepte los siguientes términos.",
    "tosDialog_AzureTermsCheckbox": "Estoy de acuerdo en que el uso del sitio Bot Framework esté sujeto a los {0} y a la {1}.",
    "tosDialog_CortanaTermsCheckbox": "Estoy de acuerdo con los {0} y la {1} para la implementación del canal de Cortana.",
    "tosDialog_CombinedTermsCheckboxOneChannel": "Estoy de acuerdo con los {0} y la {1} para la implementación del canal <%= channelslist %>.",
    "tosDialog_CombinedTermsCheckboxMultiChannels": "Estoy de acuerdo con los {0} y la {1} para la implementación de los canales <%= channelslist %>.",
    "tosDialog_ABSTerms": "términos de mi suscripción de Azure Bot Service",
    "tosDialog_MSKnowledgeGraphTerms": "Condiciones de publicación en el canal de Cortana",
    "tosDialog_MSPublicationTerms": "Términos para la publicación de canales de Microsoft",
    "tosDialog_MSPrivacyStatement": "Declaraciones de privacidad de Microsoft",
    "notice": " AVISO: ",
    "listElem": "{0},",
    "andListEnd": "{0} y {1}",
    "analyticsChannelsDropdown": "Filtro de canales",
    "analyticsPeriodDropdown": "Periodo de tiempo",
    "deprecatedChannel": "(en desuso)",
    "openInComposer": "abrir en Composer",
    "downloadComposer": "Descargar Composer",
}

const Resources_fr: IResources = {
    "unsupportedBrowser_Azure": "Azure Bot Service ne prend pas encore votre navigateur en charge.",
    "unsupportedBrowser": "Bot Framework ne prend pas encore votre navigateur en charge.",
    "botKindRegistration": "Bot Services Bot",
    "botKindSdk": "Web App Bot",
    "botKindFunctions": "Functions Bot",
    "botKindConversationDesigner": "Conversation Designer Bot",
    "loggingIn": "Connexion en cours",
    "loadingBot": "Chargement du bot...",
    "botIsNotReady": "Attente que le bot soit prêt",
    "analyticsNotReady": "En attente de la configuration d'Application Insights",
    "authorizingWebChat": "Autorisation de conversation avec le bot",
    "signInFailure": "Une erreur s'est produite lors de votre connexion. Assurez-vous que les cookies tiers sont activés dans le navigateur.",
    "getChatTokenFailure": "Une erreur s'est produite lors de l'obtention d'un jeton d'autorisation de discussion. Actualisez et réessayez.",
    "refreshSignInFailure": "Désolé... Une erreur est survenue lors de l'actualisation de vos informations de connexion. Veuillez vérifier que votre navigateur autorise les cookies tiers.",
    "xhrResponse_400": "L'action ou les valeurs fournies ne sont pas valides.",
    "xhrResponse_403": "Impossible d'accéder à l'élément ou de le modifier.",
    "xhrResponse_404": "L'élément est introuvable.",
    "xhrResponse_500": "Une erreur interne s'est produite sur le serveur.",
    "xhrResponse_501": "Cette opération n'est pas prise en charge.",
    "xhrResponse_Message": "Erreur : %1",
    "xhrResponse_Unknown": "Une erreur inconnue s'est produite.",
    "AddAFeaturedChannelTitle": "Ajouter une chaîne en vedette",
    "ConnectToChannelsTitle": "Connecter aux canaux",
    "NoChannelsConfigured": "Vous n'avez encore connecté aucun canal. Sélectionnez un canal à connecter.",
    "MoreChannelsTitle": "Plus de chaînes",
    "test": "Test",
    "startOver": "Recommencer",
    "retentionTitle": "Rétention",
    "retentionDescription": "% utilisateurs ayant de nouveau envoyé un message (au cours des 10 derniers jours)",
    "retentionHeader": "Jours plus tard",
    "retentionDate": "Date",
    "retentionUsers": "Utilisateurs",
    "undetermined": "Non déterminé",
    "loading": "chargement...",
    "noAnalyticsData": "aucune donnée",
    "timespanLastHour": "Dernière heure",
    "timespanLastDay": "Dernier jour",
    "timespanLastWeek": "Dernière semaine",
    "timespanLastMonth": "Dernier mois",
    "timespanLast90Days": "90 derniers jours",
    "timespanUnknown": "Période inconnue",
    "timelineCardUsersTitle": "Utilisateurs",
    "timelineCardMessagesTitle": "Activités",
    "totalsCardTitle": "Totaux généraux",
    "analyticsNotConfigured": "Vous n'avez pas encore activé Analytique via Azure Application Insights.",
    "analyticsNotConfiguredAction": "Fournissez vos clés Application Insights et l'ID de ce bot sur la page suivante : ",
    "analyticsNotConfiguredActionIbiza": "Fournissez vos clés Application Insights et l'ID de ce bot sur la page des paramètres.",
    "learnMore": "En savoir plus",
    "cardTitleLoading": "%1 - %2",
    "cardTitleError": "%1 - erreur : %2",
    "timelineTableLabel": "Table chronologique mappant les %1 selon le temps",
    "timelineChartLabel": "Graphique chronologique mappant les %1 selon le temps",
    "published": "Publié",
    "health": "Intégrité",
    "channelname": "Nom",
    "edit": "Modifier",
    "running": "Exécution en cours",
    "issuesTemplate": "Problèmes (<%= length %>)",
    "warningTemplate": "Avertissements (<%= length %>)",
    "channelPublished": "Publié",
    "tryOnCortana": "Essayer sur <%= Name %> - Découvrir la procédure",
    "tryOnChannel": "Essayer sur <%= Name %>",
    "manageInCortana": "Gérer dans le tableau de bord de Cortana",
    "channelRejected": "Rejetée",
    "channelMoreDetails": "Plus de détails",
    "channelResubmit": "Resoumettre pour évaluation...",
    "channelGetEmbedCodes": "Obtenir des codes de bot incorporés",
    "channelConfigDeleteMessage": "Cette opération supprimera toutes les informations de configuration du canal. Voulez-vous vraiment continuer ?",
    "channelConfigDeleteHeader": "Supprimer le canal",
    "channelConfigDeleteOk": "Oui, supprimer",
    "channelConfigDeleteCancel": "Non, conserver",
    "channelConfigLeaveMessage": "Des modifications de ce document n'ont pas été enregistrées. Voulez-vous vraiment quitter cette page ?",
    "channelConfigLeaveHeader": "Ignorer les modifications",
    "channelConfigLeaveOk": "Oui, quitter cette page",
    "channelConfigLeaveCancel": "Non, rester sur cette page",
    "channelEdit": "Modifier",
    "dialogPleaseWait": "Veuillez patienter...",
    "embedPanelTitle": "Code incorporé du bot",
    "embedPanelDescription": "Choisissez un canal pour en obtenir le code incorporé. Copiez et collez le code dans votre site web.",
    "embedPanelFacebookFooter": "Pour pouvoir utiliser ce code incorporé, Facebook exige que vous intégriez à votre page son Kit de développement logiciel (SDK) JavaScript.",
    "embedPanelLearnMore": "En savoir plus.",
    "embedPanelChannelMovedHeader": "Le code incorporé pour %1 a été déplacé",
    "embedPanelChannelMovedInstructions": "Cliquer ici pour ouvrir la page de configuration %1",
    "embedPanelEmbedcodeForChannelLabel": "Code incorporé pour %1",
    "embedPanelGettingCodes": "Obtention des codes...",
    "embedPanelNoCodeAvailable": "Aucun code incorporé n'est disponible pour ce bot.",
    "channelIssuesPanelSubtitle": "Problèmes récents",
    "channelIssuesPanelClearall": "Effacer tout",
    "channelIssuesPanelTimeColumnLabel": "Heure",
    "channelIssuesPanelMessageColumnLabel": "Message",
    "channelIssuesPanelCorrelationIdColumnLabel": "ID de corrélation",
    "unsavedChangesWillBeLost": "Les modifications non enregistrées seront perdues.",
    "altImageChannel": "Configurer le canal %1",
    "Bing": "Bing",
    "Cortana": "Cortana",
    "MicrosoftSearch": "Microsoft Search",
    "DirectLine": "Direct Line",
    "Email": "Adresse e-mail",
    "FacebookMessenger": "Facebook Messenger",
    "GroupMe": "GroupMe",
    "Kaizala": "Kaizala",
    "Kik": "Kik",
    "MicrosoftTeams": "Microsoft Teams",
    "Skype": "Skype",
    "SkypeforBusiness": "Skype Entreprise",
    "_SkypeforBusiness": "Marque Skype Entreprise",
    "Slack": "Slack",
    "Telegram": "Telegram",
    "Twilio": "Twilio (SMS)",
    "migrationBannerCTAMigrateBot": "MIGRER CE BOT",
    "migrationBannerCTAStartMigrating": "COMMENCER LA MIGRATION",
    "migrationBannerBlurb1": "Avec le lancement du nouveau Azure Bot Service, nous allons migrer tous les bots vers le nouveau service pour le 31/01/2018.",
    "migrationBannerBlurb2": "à propos de la migration.",
    "migrationBannerSuggestedBlurb": "La migration vers Azure Bot Service est facultative pour ce bot.",
    "migrationBannerPostDeadlineBlurb": "Les bots nécessitant la migration vers Azure Bot Service doivent migrer maintenant pour éviter toute interruption du service.",
    "migrationBannerBlockedBlurb": "L'échéance de la migration du bot est passée. Procédez à la migration maintenant pour éviter toute interruption du service.",
    "migrationWillBeRequiredDialogMessage": "Si vous configurez cette chaîne, votre bot devra migrer vers Azure Bot Service avant le 31/03/2018. Voulez-vous vraiment configurer cette chaîne ?",
    "channelRequiresMigrationDialogMessage": "Cette chaîne n'est disponible que pour les bots d'Azure Bot Service. Voulez-vous migrer ce bot ?",
    "channelRequiresABSBot": "Cette chaîne n'est disponible que pour les bots d'Azure Bot Service.",
    "botRequiresMigrationDialogHeader": "Le bot requiert la migration",
    "botRequiresMigrationDialogMessage": "L'échéance de la migration du bot est passée. Procédez à la migration maintenant pour éviter toute interruption du service.",
    "yesMigrateThisBot": "Oui, migrer ce bot",
    "myBotsMigrationStatusMigrated": "Migré",
    "myBotsMigrationStatusNotMigrated": "Obligatoire",
    "myBotsMigrationStatusOptionalMigration": "Non obligatoire",
    "myBotsMigrationButtonMigrate": "Migrer",
    "myBotsMigrationButtonRollback": "Restaurer la migration",
    "deleteBotDialogDeleteButtonText": "Supprimer le bot",
    "cancelButtonText": "Annuler",
    "deleteBotDialogTitleText": "Vous êtes sur le point de supprimer ce bot",
    "deleteBotDialogBodyText": "Cette action va effacer toutes les données associées à ce bot et ne peut pas être annulée. Voulez-vous continuer ?",
    "deleteBotDialogStatusDeleting": "Suppression du bot en cours...",
    "deleteBotDialogStatusDeleted": "Bot supprimé",
    "rollbackBotDialogRollbackButtonText": "Oui, restaurer",
    "rollbackBotDialogTitleText": "Voulez-vous vraiment procéder à la restauration ?",
    "rollbackBotDialogBodyText": "Cette action va restaurer complètement la migration et vous devrez commencer le processus de migration depuis le début. Voulez-vous vraiment continuer ?",
    "rollbackBotDialogErrorInfo": "Erreur lors de la récupération des informations sur le bot sur le serveur.",
    "rollbackBotDialogErrorNoEndpoint": "Impossible d'effectuer la restauration. Aucun point de terminaison de restauration trouvé.",
    "rollbackBotDialogErrorNoAzureToken": "Impossible d'effectuer la restauration. Échec de la recherche d'un jeton Azure pour contacter Azure.",
    "rollbackBotDialogStatusGettingInfo": "Collecte d'informations sur le bot...",
    "rollbackBotDialogStatusPreparing": "Préparation du bot en cours...",
    "rollbackBotDialogStatusReverting": "Restauration du bot en cours...",
    "rollbackBotDialogStatusDeletingApp": "Suppression de l'application mise à niveau...",
    "rollbackBotDialogStatusDeletingDeployment": "Suppression de l'enregistrement de déploiement...",
    "rollbackBotDialogConfirmationTitleText": "Restauration terminée",
    "rollbackBotDialogConfirmationBodyText": "a été restauré.",
    "okButtonText": "OK",
    "errorMessageErrorOccurred": "Une erreur s'est produite",
    "migrationDialogStatusGettingBotInfo": "Obtention des informations sur le bot...",
    "migrationDialogStatusGettingAzureInfo": "Obtention des informations sur Azure...",
    "migrationDialogStatusGettingAppSettings": "Obtention des paramètres d'application du bot...",
    "migrationDialogStatusDeployingMigrationBot": "Initialisation du bot migré en cours...",
    "migrationDialogStatusRegisteringWithAzure": "Inscription du service bot avec Azure...",
    "migrationDialogStatusUpdatingBotRecord": "Mise à jour de l'enregistrement de bot en cours...",
    "migrationDialogStatusCreatingRG": "Création d'un groupe de ressources en cours...",
    "migrationDialogStatusMigratingFiles": "Migration des fichiers vers le nouveau bot...",
    "migrationDialogStatusWrappingUp": "Finalisation du déploiement en cours...",
    "migrationDialogStatusDeployingStorage": "Connexion du bot au stockage existant...",
    "migrationDialogStatusDeployingSite": "Déploiement de site web en cours",
    "migrationDialogStatusConfiguringSite": "Configuration du site web en cours",
    "migrationDialogStatusDeploying": "Déploiement en cours",
    "migrationDialogStatusFunctionCredentials": "Obtention de nouvelles informations d'identification pour l'application de fonction...",
    "migrationDialogErrorNoSubs": "Échec de la recherche d'abonnements Azure pour l'utilisateur actuel.",
    "migrationDialogErrorNoAzureToken": "Échec de la recherche d'un jeton d'accès Azure pour l'utilisateur actuel.",
    "migrationDialogErrorNoLocations": "Désolé... Une erreur est survenue lors de la recherche d'emplacements pour l'abonnement Azure sélectionné.",
    "migrationDialogErrorNoAzureStorage": "Échec de la recherche d'un nom de compte Stockage Azure dans la configuration de l'application.",
    "migrationDialogErrorAppNameUnavailable": "Le nom de l'application n'est pas disponible.",
    "migrationDialogErrorAppNameInvalid": "Nom d'application non valide.",
    "migrationDialogErrorNoBotType": "Le bot actuel n'a pas de type valide.",
    "migrationDialogErrorBotInvalid": "Impossible de migrer ce bot, car il n'est pas valide.",
    "migrationDialogErrorEndpointMissing": "Impossible de migrer ce bot, car le point de terminaison est manquant.",
    "migrationDialogErrorProvisionInfoMissing": "Impossible de migrer ce bot, car les infos sur l'approvisionnement sont manquantes.",
    "migrationDialogErrorResourceGroupNameMissing": "Impossible de migrer ce bot, car le nom du groupe de ressources est manquant.",
    "migrationDialogErrorSubscriptionIdMissing": "Désolé... Nous ne pouvons pas migrer ce bot, car nous ne trouvons pas l'ID d'abonnement Azure.",
    "migrationDialogErrorSiteNameMissing": "Impossible de migrer ce bot, car le nom du site Azure est manquant.",
    "migrationDialogABSv2TitleText": "Migration non disponible",
    "migrationDialogABSv2BodyText": "La migration est actuellement désactivée pour les bots Concepteur de conversations (ABSv2).",
    "migrationDialogRegistrationBodyText": "La migration est actuellement désactivée pour les bots « {0} ».",
    "migrationDialogFailedTokenRefresh": "Le jeton Azure a expiré.",
    "migrationDialogRefreshPage": "Actualisez la page et réessayez la migration.",
    "migrationSubscriptionDisabled": "L'abonnement Azure sélectionné est désactivé. Veuillez l’activer pour continuer la migration.",
    "migrationTenantHasNoSubscriptions": "Ce répertoire ne contient aucun abonnement.",
    "migrationDialogFuncPackBotTitle": "Le pack Azure Functions est obligatoire pour migrer ce bot",
    "migrationDialogFuncPackBotMessage": "Les bots de fonction Node doivent être fournis avec le pack Azure Functions avant de pouvoir être migrés.",
    "migrationDialogFuncPackBotLinkText": "Découvrez comment exécuter le pack Azure Functions sur le code de votre bot",
    "tosDialog_Header": "Conditions d'utilisation",
    "tosDialog_AgreeButton": "J'accepte",
    "tosDialog_MessageChannels": "Les conditions d'utilisation en ligne ne s'appliquent pas à la publication sur les chaînes. Par exemple, les conditions de publication sur les chaînes Microsoft n'offrent pas de conditions de traitement des données.",
    "tosDialog_MessageMigration": "Veuillez lire et accepter les conditions suivantes.",
    "tosDialog_AzureTermsCheckbox": "J'accepte que l'utilisation du site Bot Framework soit soumise aux {0} et à la {1}.",
    "tosDialog_CortanaTermsCheckbox": "J'accepte les {0} et la {1} pour mon déploiement sur la chaîne Cortana.",
    "tosDialog_CombinedTermsCheckboxOneChannel": "J'accepte les {0} et la {1} pour mon déploiement sur la chaîne <%= channelslist %>.",
    "tosDialog_CombinedTermsCheckboxMultiChannels": "J'accepte les {0} et la {1} pour mon déploiement sur les chaînes <%= channelslist %>.",
    "tosDialog_ABSTerms": "conditions de mon abonnement à Azure Bot Service",
    "tosDialog_MSKnowledgeGraphTerms": "Conditions de publication de la chaîne Cortana",
    "tosDialog_MSPublicationTerms": "Conditions de publication de la chaîne Microsoft",
    "tosDialog_MSPrivacyStatement": "Déclarations de confidentialité de Microsoft",
    "notice": " AVIS : ",
    "listElem": "{0}, ",
    "andListEnd": "{0} et {1}",
    "analyticsChannelsDropdown": "Filtre de chaîne",
    "analyticsPeriodDropdown": "Période",
    "deprecatedChannel": "(déconseillé)",
    "openInComposer": "ouvrir dans composer",
    "downloadComposer": "Télécharger composer",
}

const Resources_it: IResources = {
    "unsupportedBrowser_Azure": "Il servizio Azure Bot ancora non supporta il browser.",
    "unsupportedBrowser": "Bot Framework ancora non supporta il browser.",
    "botKindRegistration": "Bot Services Bot",
    "botKindSdk": "Web App Bot",
    "botKindFunctions": "Functions Bot",
    "botKindConversationDesigner": "Conversation Designer Bot",
    "loggingIn": "Accesso in corso...",
    "loadingBot": "Caricamento del bot in corso...",
    "botIsNotReady": "In attesa che il bot sia pronto",
    "analyticsNotReady": "In attesa della configurazione di Application Insights",
    "authorizingWebChat": "Autorizzazione della chat con bot in corso",
    "signInFailure": "Si è verificato un errore durante l'accesso. Verifica che i cookie di terze parti siano abilitati nel browser.",
    "getChatTokenFailure": "Si è verificato un errore durante l'ottenimento del token di autorizzazione per la chat. Aggiornare e riprovare.",
    "refreshSignInFailure": "Si è verificato un errore durante l'aggiornamento delle informazioni di accesso. Verificare che i cookie di terze parti siano abilitati nel browser.",
    "xhrResponse_400": "L'azione o i valori forniti non sono validi.",
    "xhrResponse_403": "Impossibile accedere o modificare questo elemento.",
    "xhrResponse_404": "Impossibile trovare l'elemento.",
    "xhrResponse_500": "Si è verificato un errore interno del server.",
    "xhrResponse_501": "Operazione non supportata.",
    "xhrResponse_Message": "Errore: %1",
    "xhrResponse_Unknown": "Si è verificato un errore sconosciuto.",
    "AddAFeaturedChannelTitle": "Aggiungi un canale in primo piano",
    "ConnectToChannelsTitle": "Connessione ai canali",
    "NoChannelsConfigured": "Non è stato ancora connesso alcun canale. Selezionare un canale da connettere.",
    "MoreChannelsTitle": "Altri canali",
    "test": "Test",
    "startOver": "Ricomincia",
    "retentionTitle": "Conservazione",
    "retentionDescription": "% utenti che hanno nuovamente inviato messaggi (ultimi 10 giorni)",
    "retentionHeader": "Giorni dopo",
    "retentionDate": "Data",
    "retentionUsers": "Utenti",
    "undetermined": "Indeterminato",
    "loading": "caricamento in corso...",
    "noAnalyticsData": "nessun dato",
    "timespanLastHour": "Ultima ora",
    "timespanLastDay": "Ultimo giorno",
    "timespanLastWeek": "Ultima settimana",
    "timespanLastMonth": "Ultimo mese",
    "timespanLast90Days": "Ultimi 90 giorni",
    "timespanUnknown": "Timespan sconosciuto",
    "timelineCardUsersTitle": "Utenti",
    "timelineCardMessagesTitle": "Attività",
    "totalsCardTitle": "Totali complessivi",
    "analyticsNotConfigured": "Ancora non è stato abilitato Analisi tramite Azure Application Insights.",
    "analyticsNotConfiguredAction": "Fornire l'ID e le chiavi di Application Insights per questo bot nella pagina seguente:",
    "analyticsNotConfiguredActionIbiza": "Fornire l'ID e le chiavi di Application Insights per questo bot nella pagina delle impostazioni.",
    "learnMore": "Altre informazioni",
    "cardTitleLoading": "%1 - %2",
    "cardTitleError": "%1 - errore: %2",
    "timelineTableLabel": "Mapping della tabella %1 della cronologia in base all'orario",
    "timelineChartLabel": "Mapping del grafico %1 della cronologia in base all'orario",
    "published": "Pubblicato",
    "health": "Integrità",
    "channelname": "Nome",
    "edit": "Modifica",
    "running": "In esecuzione",
    "issuesTemplate": "Problemi (<%= length %>)",
    "warningTemplate": "Avvisi (<%= length %>)",
    "channelPublished": "Pubblicato",
    "tryOnCortana": "Prova su <%= Name %> - altre informazioni",
    "tryOnChannel": "Prova su <%= Name %>",
    "manageInCortana": "Gestire nel dashboard di Cortana",
    "channelRejected": "Rifiutato",
    "channelMoreDetails": "Altri dettagli",
    "channelResubmit": "Inviare nuovamente per la revisione...",
    "channelGetEmbedCodes": "Ottieni codici di incorporamento bot",
    "channelConfigDeleteMessage": "Questa azione eliminerà tutte le informazioni di configurazione del canale. Continuare?",
    "channelConfigDeleteHeader": "Elimina canale",
    "channelConfigDeleteOk": "Sì, eliminalo",
    "channelConfigDeleteCancel": "No, mantienilo",
    "channelConfigLeaveMessage": "Sono presenti modifiche non salvate nel documento. Uscire dalla pagina?",
    "channelConfigLeaveHeader": "Ignora modifiche",
    "channelConfigLeaveOk": "Sì, esci dalla pagina",
    "channelConfigLeaveCancel": "No, resta nella pagina",
    "channelEdit": "Modifica",
    "dialogPleaseWait": "Attendere...",
    "embedPanelTitle": "Codice di incorporamento bot",
    "embedPanelDescription": "Scegliere un canale per ottenere il relativo codice di incorporamento. Copiare e incollare il codice nel sito Web.",
    "embedPanelFacebookFooter": "Per utilizzare questo incorporamento Facebook richiede di includere il relativo SDK JavaScript nella pagina.",
    "embedPanelLearnMore": "Ulteriori informazioni.",
    "embedPanelChannelMovedHeader": "Il codice di incorporamento per %1 è stato spostato",
    "embedPanelChannelMovedInstructions": "Fare clic qui per aprire la pagina di configurazione %1",
    "embedPanelEmbedcodeForChannelLabel": "Il codice di incorporamento per %1",
    "embedPanelGettingCodes": "Recupero dei codici in corso...",
    "embedPanelNoCodeAvailable": "Nessun codice di incorporamento disponibile per questo bot.",
    "channelIssuesPanelSubtitle": "Problemi recenti",
    "channelIssuesPanelClearall": "Deseleziona tutto",
    "channelIssuesPanelTimeColumnLabel": "Data e ora",
    "channelIssuesPanelMessageColumnLabel": "Messaggio",
    "channelIssuesPanelCorrelationIdColumnLabel": "ID correlazione",
    "unsavedChangesWillBeLost": "Le modifiche non salvate andranno perse.",
    "altImageChannel": "Configura canale %1",
    "Bing": "Bing",
    "Cortana": "Cortana",
    "MicrosoftSearch": "Microsoft Search",
    "DirectLine": "Direct Line",
    "Email": "E-mail",
    "FacebookMessenger": "Facebook Messenger",
    "GroupMe": "GroupMe",
    "Kaizala": "Kaizala",
    "Kik": "Kik",
    "MicrosoftTeams": "Microsoft Teams",
    "Skype": "Skype",
    "SkypeforBusiness": "Skype for Business",
    "_SkypeforBusiness": "Marchio Skype for Business",
    "Slack": "Slack",
    "Telegram": "Telegram",
    "Twilio": "Twilio (SMS)",
    "migrationBannerCTAMigrateBot": "MIGRA QUESTO BOT",
    "migrationBannerCTAStartMigrating": "AVVIA MIGRAZIONE",
    "migrationBannerBlurb1": "Con il lancio del nuovo servizio Azure Bot, tutti i bot verranno migrati nel nuovo servizio entro il 31/03/2018.",
    "migrationBannerBlurb2": "informazioni sulla migrazione.",
    "migrationBannerSuggestedBlurb": "La migrazione al servizio Azure Bot è facoltativa per questo bot.",
    "migrationBannerPostDeadlineBlurb": "I bot che richiedono la migrazione al servizio Azure Bot devono effettuare ora la migrazione per evitare l'interruzione del servizio.",
    "migrationBannerBlockedBlurb": "Migrazione del bot scaduta, esegui la migrazione ora per evitare un'interruzione del servizio.",
    "migrationWillBeRequiredDialogMessage": "Se configuri questo canale, il bot richiederà la migrazione al servizio Azure Bot entro il 31/03/2018. Vuoi configurare questo canale?",
    "channelRequiresMigrationDialogMessage": "Questo canale è disponibile solo per i bot nel servizio Azure Bot. Vuoi migrare questo bot?",
    "channelRequiresABSBot": "Questo canale è disponibile solo per i bot nel servizio Azure Bot.",
    "botRequiresMigrationDialogHeader": "Il bot richiede la migrazione",
    "botRequiresMigrationDialogMessage": "Migrazione del bot scaduta, esegui la migrazione ora per evitare un'interruzione del servizio.",
    "yesMigrateThisBot": "Sì, esegui la migrazione di questo bot",
    "myBotsMigrationStatusMigrated": "Migrazione completata",
    "myBotsMigrationStatusNotMigrated": "Obbligatorio",
    "myBotsMigrationStatusOptionalMigration": "Non obbligatorio",
    "myBotsMigrationButtonMigrate": "Esegui migrazione",
    "myBotsMigrationButtonRollback": "Esegui rollback migrazione",
    "deleteBotDialogDeleteButtonText": "Elimina bot",
    "cancelButtonText": "Annulla",
    "deleteBotDialogTitleText": "Questo bot sta per essere eliminato",
    "deleteBotDialogBodyText": "Questa azione cancellerà tutti i dati associati a questo bot e non può essere annullata. Continuare?",
    "deleteBotDialogStatusDeleting": "Eliminazione bot in corso...",
    "deleteBotDialogStatusDeleted": "Bot eliminato",
    "rollbackBotDialogRollbackButtonText": "Sì, esegui rollback",
    "rollbackBotDialogTitleText": "Eseguire rollback?",
    "rollbackBotDialogBodyText": "Questa azione eseguirà il rollback completo della migrazione e sarà necessario avviare il processo di migrazione dall'inizio. Continuare?",
    "rollbackBotDialogErrorInfo": "Errore durante il recupero delle informazioni sul bot dal server.",
    "rollbackBotDialogErrorNoEndpoint": "Impossibile eseguire rollback. Nessun endpoint di rollback trovato.",
    "rollbackBotDialogErrorNoAzureToken": "Impossibile eseguire rollback. Impossibile trovare un token di Azure per contattare Azure.",
    "rollbackBotDialogStatusGettingInfo": "Raccolta informazioni bot in corso...",
    "rollbackBotDialogStatusPreparing": "Preparazione bot in corso...",
    "rollbackBotDialogStatusReverting": "Ripristino bot in corso..",
    "rollbackBotDialogStatusDeletingApp": "Eliminazione app aggiornata in corso...",
    "rollbackBotDialogStatusDeletingDeployment": "Eliminazione record distribuzione in corso...",
    "rollbackBotDialogConfirmationTitleText": "Rollback completato",
    "rollbackBotDialogConfirmationBodyText": "ha completato il rollback.",
    "okButtonText": "OK",
    "errorMessageErrorOccurred": "Si è verificato un errore",
    "migrationDialogStatusGettingBotInfo": "Ottenimento informazioni su bot in corso...",
    "migrationDialogStatusGettingAzureInfo": "Ottenimento informazioni su Azure in corso...",
    "migrationDialogStatusGettingAppSettings": "Ottenimento impostazioni app bot in corso...",
    "migrationDialogStatusDeployingMigrationBot": "Inizializzazione bot migrato in corso...",
    "migrationDialogStatusRegisteringWithAzure": "Registrazione Servizio Bot con Azure in corso...",
    "migrationDialogStatusUpdatingBotRecord": "Aggiornamento record bot in corso...",
    "migrationDialogStatusCreatingRG": "Creazione gruppo di risorse in corso...",
    "migrationDialogStatusMigratingFiles": "Migrazione file su nuovo bot in corso...",
    "migrationDialogStatusWrappingUp": "Wrapping distribuzione in corso...",
    "migrationDialogStatusDeployingStorage": "Connessione del bot alla risorsa di archiviazione esistente in corso...",
    "migrationDialogStatusDeployingSite": "Distribuzione sito Web in corso",
    "migrationDialogStatusConfiguringSite": "Configurazione sito Web in corso",
    "migrationDialogStatusDeploying": "Distribuzione in corso",
    "migrationDialogStatusFunctionCredentials": "Ottenimento nuove credenziali delle app per le funzioni in corso...",
    "migrationDialogErrorNoSubs": "Impossibile trovare sottoscrizioni di Azure per l'utente corrente.",
    "migrationDialogErrorNoAzureToken": "Impossibile trovare il token di accesso di Azure per l'utente corrente.",
    "migrationDialogErrorNoLocations": "Non è stato possibile trovare posizioni per la sottoscrizione di Azure selezionata.",
    "migrationDialogErrorNoAzureStorage": "Impossibile trovare un nome account di Archiviazione di Azure nella configurazione dell'app.",
    "migrationDialogErrorAppNameUnavailable": "Nome app non disponibile.",
    "migrationDialogErrorAppNameInvalid": "Nome app non valido.",
    "migrationDialogErrorNoBotType": "Il bot corrente non dispone di un tipo valido.",
    "migrationDialogErrorBotInvalid": "Impossibile migrare questo bot perché non è valido.",
    "migrationDialogErrorEndpointMissing": "Impossibile migrare questo bot perché l'endpoint è mancante.",
    "migrationDialogErrorProvisionInfoMissing": "Impossibile migrare questo bot perché le informazioni sul provisioning sono mancanti.",
    "migrationDialogErrorResourceGroupNameMissing": "Impossibile migrare questo bot perché il nome del gruppo di risorse è mancante.",
    "migrationDialogErrorSubscriptionIdMissing": "Non è possibile migrare questo bot perché manca l'ID sottoscrizione di Azure.",
    "migrationDialogErrorSiteNameMissing": "Impossibile migrare questo bot perché il nome del sito di Azure è mancante.",
    "migrationDialogABSv2TitleText": "Migrazione non disponibile",
    "migrationDialogABSv2BodyText": "La migrazione è al momento disabilitata per i bot Progettazione della conversazione (ABSv2).",
    "migrationDialogRegistrationBodyText": "La migrazione è al momento disabilitata per i bot '{0}'.",
    "migrationDialogFailedTokenRefresh": "Token di Azure scaduto.",
    "migrationDialogRefreshPage": "Aggiornare la pagina e riprovare a eseguire la migrazione.",
    "migrationSubscriptionDisabled": "La sottoscrizione di Azure selezionata è disabilitata. Abilitarla per continuare la migrazione.",
    "migrationTenantHasNoSubscriptions": "Questa directory non contiene alcuna sottoscrizione.",
    "migrationDialogFuncPackBotTitle": "Il pacchetto Funzioni di Azure è obbligatorio per poter migrare questo bot",
    "migrationDialogFuncPackBotMessage": "I bot di funzioni del nodo devono essere inclusi nel pacchetto Funzioni di Azure prima di poter essere migrati.",
    "migrationDialogFuncPackBotLinkText": "Informazioni su come eseguire il pacchetto Funzioni di Azure sul codice bot",
    "tosDialog_Header": "Condizioni d'uso",
    "tosDialog_AgreeButton": "Accetto",
    "tosDialog_MessageChannels": "Le Condizioni dei servizi online non si applicano alla pubblicazione sui canali. Ad esempio, le condizioni per la pubblicazione sui canali Microsoft non offrono le condizioni per l'elaborazione dei dati.",
    "tosDialog_MessageMigration": "Leggere e accettare le condizioni seguenti.",
    "tosDialog_AzureTermsCheckbox": "Accetto che l'uso del sito framework del bot sia soggetto alle {0} e alle {1}.",
    "tosDialog_CortanaTermsCheckbox": "Accetto le {0} e le {1} per la distribuzione sul canale Cortana.",
    "tosDialog_CombinedTermsCheckboxOneChannel": "Accetto le {0} e le {1} per la distribuzione sul canale <%= channelslist %>.",
    "tosDialog_CombinedTermsCheckboxMultiChannels": "Accetto le {0} e le {1} per la distribuzione sui canali <%= channelslist %>.",
    "tosDialog_ABSTerms": "condizioni della sottoscrizione per il servizio Azure Bot",
    "tosDialog_MSKnowledgeGraphTerms": "Condizioni per la pubblicazione sul canale Cortana",
    "tosDialog_MSPublicationTerms": "Condizioni per la pubblicazione sul canale Microsoft",
    "tosDialog_MSPrivacyStatement": "Informative sulla privacy di Microsoft",
    "notice": " AVVISO: ",
    "listElem": "{0}",
    "andListEnd": "{0} e {1}",
    "analyticsChannelsDropdown": "Filtro canali",
    "analyticsPeriodDropdown": "Periodo",
    "deprecatedChannel": "(deprecato)",
    "openInComposer": "Apri in Composer",
    "downloadComposer": "Scarica Composer",
}

const Resources_ja: IResources = {
    "unsupportedBrowser_Azure": "Azure Bot Service は、ご使用のブラウザーをまだサポートしていません。",
    "unsupportedBrowser": "Bot Framework は、ご使用のブラウザーをまだサポートしていません。",
    "botKindRegistration": "Bot Services Bot",
    "botKindSdk": "Web App Bot",
    "botKindFunctions": "Functions Bot",
    "botKindConversationDesigner": "Conversation Designer Bot",
    "loggingIn": "ログイン中",
    "loadingBot": "ボットを読み込んでいます...",
    "botIsNotReady": "ボットの準備完了を待機中",
    "analyticsNotReady": "Application Insights の構成を待機中",
    "authorizingWebChat": "ボットとのチャットを承認中",
    "signInFailure": "サインイン中にエラーが発生しました。ブラウザーでサード パーティの Cookie が有効になっていることを確認してください。",
    "getChatTokenFailure": "チャット承認トークンを取得中にエラーが発生しました。更新してもう一度やり直してください。",
    "refreshSignInFailure": "サインイン情報の更新中にエラーが発生しました。ブラウザーでサード パーティの Cookie が有効になっていることを確認してください。",
    "xhrResponse_400": "この操作または指定された値は無効です。",
    "xhrResponse_403": "このアイテムにアクセスできないか、このアイテムを変更できません。",
    "xhrResponse_404": "このアイテムは見つかりません。",
    "xhrResponse_500": "サーバーで内部エラーが発生しました。",
    "xhrResponse_501": "この操作はサポートされていません。",
    "xhrResponse_Message": "エラー: %1",
    "xhrResponse_Unknown": "不明なエラーが発生しました。",
    "AddAFeaturedChannelTitle": "おすすめチャンネルの追加",
    "ConnectToChannelsTitle": "チャンネルに接続",
    "NoChannelsConfigured": "どのチャンネルもまだ接続されていません。接続するチャンネルを選択してください。",
    "MoreChannelsTitle": "その他のチャンネル",
    "test": "テスト",
    "startOver": "やり直す",
    "retentionTitle": "リテンション",
    "retentionDescription": "% 人のユーザーが再びメッセージを送信 (過去 10 日間)",
    "retentionHeader": "経過日数",
    "retentionDate": "日付",
    "retentionUsers": "ユーザー",
    "undetermined": "不明",
    "loading": "読み込み中...",
    "noAnalyticsData": "データがありません",
    "timespanLastHour": "過去 1 時間以内",
    "timespanLastDay": "過去 24 時間以内",
    "timespanLastWeek": "先週",
    "timespanLastMonth": "先月",
    "timespanLast90Days": "過去 90 日間",
    "timespanUnknown": "不明な期間",
    "timelineCardUsersTitle": "ユーザー",
    "timelineCardMessagesTitle": "アクティビティ",
    "totalsCardTitle": "総計",
    "analyticsNotConfigured": "Azure Application Insights を介した分析がまだ有効になっていません。",
    "analyticsNotConfiguredAction": "このボットの Application Insights キーおよび ID を次のページで指定してください。 ",
    "analyticsNotConfiguredActionIbiza": "このボットの Application Insights キーおよび ID を設定ページで指定してください。",
    "learnMore": "詳細",
    "cardTitleLoading": "%1 - %2",
    "cardTitleError": "%1 - エラー: %2",
    "timelineTableLabel": "タイムライン テーブルのマッピング %1 (時間別)",
    "timelineChartLabel": "タイムライン グラフのマッピング %1 (時間別)",
    "published": "公開済み",
    "health": "正常性",
    "channelname": "名前",
    "edit": "編集",
    "running": "実行中",
    "issuesTemplate": "問題 (<%= length %>)",
    "warningTemplate": "警告 (<%= length %>)",
    "channelPublished": "公開済み",
    "tryOnCortana": "<%= Name %> で試行 - 方法を表示",
    "tryOnChannel": "<%= Name %> で試行",
    "manageInCortana": "Cortana ダッシュボードで管理",
    "channelRejected": "拒否",
    "channelMoreDetails": "詳細",
    "channelResubmit": "レビュー依頼を再送信...",
    "channelGetEmbedCodes": "ボットの埋め込みコードを取得",
    "channelConfigDeleteMessage": "このアクションを実行すると、すべてのチャンネル構成情報が削除されます。続行しますか?",
    "channelConfigDeleteHeader": "チャンネルを削除",
    "channelConfigDeleteOk": "はい、削除します",
    "channelConfigDeleteCancel": "いいえ、削除しません",
    "channelConfigLeaveMessage": "このドキュメントには未保存の変更があります。このページから移動してもよろしいですか?",
    "channelConfigLeaveHeader": "変更を破棄",
    "channelConfigLeaveOk": "はい、ページから移動します",
    "channelConfigLeaveCancel": "いいえ、ページにとどまります",
    "channelEdit": "編集",
    "dialogPleaseWait": "しばらくお待ちください...",
    "embedPanelTitle": "ボットの埋め込みコード",
    "embedPanelDescription": "埋め込みコードを取得するチャンネルを選択してください。このコードを Web サイトにコピー/貼り付けしてください。",
    "embedPanelFacebookFooter": "この埋め込みを使用するには、Facebook の JavaScript SDK をページに含める必要があります。",
    "embedPanelLearnMore": "詳細",
    "embedPanelChannelMovedHeader": "%1 の埋め込みコードは移動しました",
    "embedPanelChannelMovedInstructions": "%1 の構成ページを開くには、ここをクリックします",
    "embedPanelEmbedcodeForChannelLabel": "%1 の埋め込みコード",
    "embedPanelGettingCodes": "コードを取得しています...",
    "embedPanelNoCodeAvailable": "このボットに使用できる埋め込みコードはありません。",
    "channelIssuesPanelSubtitle": "最近の問題",
    "channelIssuesPanelClearall": "すべてクリア",
    "channelIssuesPanelTimeColumnLabel": "時間",
    "channelIssuesPanelMessageColumnLabel": "メッセージ",
    "channelIssuesPanelCorrelationIdColumnLabel": "関連付け ID",
    "unsavedChangesWillBeLost": "未保存の変更は失われます。",
    "altImageChannel": "%1 チャンネルを構成",
    "Bing": "Bing",
    "Cortana": "Cortana",
    "MicrosoftSearch": "Microsoft Search",
    "DirectLine": "Direct Line",
    "Email": "メール",
    "FacebookMessenger": "Facebook Messenger",
    "GroupMe": "GroupMe",
    "Kaizala": "Kaizala",
    "Kik": "Kik",
    "MicrosoftTeams": "Microsoft Teams",
    "Skype": "Skype",
    "SkypeforBusiness": "Skype for Business",
    "_SkypeforBusiness": "Skype for Business ブランド",
    "Slack": "Slack",
    "Telegram": "Telegram",
    "Twilio": "Twilio (SMS)",
    "migrationBannerCTAMigrateBot": "このボットを移行する",
    "migrationBannerCTAStartMigrating": "移行を開始する",
    "migrationBannerBlurb1": "新しい Azure Bot Service のリリースに伴い、2018/03/31 までにすべてのボットを新しいサービスに移行します。",
    "migrationBannerBlurb2": "移行について。",
    "migrationBannerSuggestedBlurb": "このボットの Azure Bot Service への移行は任意です。",
    "migrationBannerPostDeadlineBlurb": "Azure Bot Service への移行が必要なボットは、サービスの中断を避けるためにいますぐ移行する必要があります。",
    "migrationBannerBlockedBlurb": "ボット移行の期日が過ぎています。サービスが中断することのないよう、今すぐ移行してください。",
    "migrationWillBeRequiredDialogMessage": "このチャンネルを構成する場合、2018/3/31 までにボットを Azure Bot Service に移行する必要があります。このチャンネルを構成してよろしいですか?",
    "channelRequiresMigrationDialogMessage": "このチャンネルは Azure Bot Service のボットしか使用できません。このボットを移行しますか?",
    "channelRequiresABSBot": "このチャネルは Azure Bot Service のボットのみが対象です。",
    "botRequiresMigrationDialogHeader": "ボットの移行が必要",
    "botRequiresMigrationDialogMessage": "ボット移行の期日が過ぎています。サービスが中断することのないよう、今すぐ移行してください。",
    "yesMigrateThisBot": "はい、このボットを移行します",
    "myBotsMigrationStatusMigrated": "移行済み",
    "myBotsMigrationStatusNotMigrated": "必須",
    "myBotsMigrationStatusOptionalMigration": "不要",
    "myBotsMigrationButtonMigrate": "移行",
    "myBotsMigrationButtonRollback": "移行のロールバック",
    "deleteBotDialogDeleteButtonText": "ボットの削除",
    "cancelButtonText": "キャンセル",
    "deleteBotDialogTitleText": "このボットを削除しようとしています",
    "deleteBotDialogBodyText": "このアクションを行うと、このボットに関連するすべてのデータが消去されます。このアクションを元に戻すことはできません。よろしいですか?",
    "deleteBotDialogStatusDeleting": "ボットを削除しています...",
    "deleteBotDialogStatusDeleted": "ボットが削除されました",
    "rollbackBotDialogRollbackButtonText": "はい、ロールバックします",
    "rollbackBotDialogTitleText": "ロールバックしますか?",
    "rollbackBotDialogBodyText": "このアクションを行うと、移行が完全にロールバックされ、移行プロセスを最初から開始しなければならなくなります。続行しますか?",
    "rollbackBotDialogErrorInfo": "サーバーからボット情報を取得中にエラーが発生しました。",
    "rollbackBotDialogErrorNoEndpoint": "ロールバックを実行できません。ロールバック エンドポイントが見つかりませんでした。",
    "rollbackBotDialogErrorNoAzureToken": "ロールバックを実行できません。Azure にアクセスするための Azure トークンが見つかりませんでした。",
    "rollbackBotDialogStatusGettingInfo": "ボット情報の取得中...",
    "rollbackBotDialogStatusPreparing": "ボットの準備中...",
    "rollbackBotDialogStatusReverting": "ボットの復元中..",
    "rollbackBotDialogStatusDeletingApp": "アップグレードしたアプリの削除中...",
    "rollbackBotDialogStatusDeletingDeployment": "デプロイ レコードの削除中...",
    "rollbackBotDialogConfirmationTitleText": "ロールバック完了",
    "rollbackBotDialogConfirmationBodyText": "は正常にロールバックされました。",
    "okButtonText": "OK",
    "errorMessageErrorOccurred": "エラーが発生しました",
    "migrationDialogStatusGettingBotInfo": "ボット情報の取得中...",
    "migrationDialogStatusGettingAzureInfo": "Azure 情報の取得中...",
    "migrationDialogStatusGettingAppSettings": "ボット アプリ設定の取得中...",
    "migrationDialogStatusDeployingMigrationBot": "移行したボットの初期化中...",
    "migrationDialogStatusRegisteringWithAzure": "Azure にボット サービスを登録中...",
    "migrationDialogStatusUpdatingBotRecord": "ボット レコードの更新中...",
    "migrationDialogStatusCreatingRG": "リソース グループの作成中...",
    "migrationDialogStatusMigratingFiles": "新しいボットにファイルを移行中...",
    "migrationDialogStatusWrappingUp": "デプロイのラッピング中...",
    "migrationDialogStatusDeployingStorage": "ボットを既存のストレージに接続中...",
    "migrationDialogStatusDeployingSite": "Web サイトのデプロイ中",
    "migrationDialogStatusConfiguringSite": "Web サイトの構成中",
    "migrationDialogStatusDeploying": "デプロイ中",
    "migrationDialogStatusFunctionCredentials": "新しい Function App 資格情報の取得中...",
    "migrationDialogErrorNoSubs": "現在のユーザーの Azure サブスクリプションが見つかりませんでした。",
    "migrationDialogErrorNoAzureToken": "現在のユーザーの Azure アクセス トークンが見つかりませんでした。",
    "migrationDialogErrorNoLocations": "選択した Azure サブスクリプションの場所が見つかりませんでした。",
    "migrationDialogErrorNoAzureStorage": "アプリ構成に Azure ストレージ アカウント名が見つかりませんでした。",
    "migrationDialogErrorAppNameUnavailable": "アプリ名を利用できません。",
    "migrationDialogErrorAppNameInvalid": "アプリ名が無効です。",
    "migrationDialogErrorNoBotType": "現在のボットに有効な種類がありません。",
    "migrationDialogErrorBotInvalid": "ボットが無効のため、このボットを移行できません。",
    "migrationDialogErrorEndpointMissing": "エンドポイントがないため、このボットを移行できません。",
    "migrationDialogErrorProvisionInfoMissing": "プロビジョニング情報がないため、このボットを移行できません。",
    "migrationDialogErrorResourceGroupNameMissing": "リソース グループ名がないため、このボットを移行できません。",
    "migrationDialogErrorSubscriptionIdMissing": "Azure サブスクリプション ID がないため、このボットを移行できません。",
    "migrationDialogErrorSiteNameMissing": "Azure サイト名がないため、このボットを移行できません。",
    "migrationDialogABSv2TitleText": "移行を利用できません",
    "migrationDialogABSv2BodyText": "会話デザイナー (ABSv2) ボットの移行は現在無効になっています。",
    "migrationDialogRegistrationBodyText": "'{0}' ボットの移行は現在無効になっています。",
    "migrationDialogFailedTokenRefresh": "Azure トークンの有効期限が切れています。",
    "migrationDialogRefreshPage": "ページを更新して、移行を再試行してください。",
    "migrationSubscriptionDisabled": "選択した Azure サブスクリプションは無効です。有効にして移行を続けてください。",
    "migrationTenantHasNoSubscriptions": "このディレクトリにはサブスクリプションが含まれていません。",
    "migrationDialogFuncPackBotTitle": "このボットを移行するには、Azure Functions Pack が必要です",
    "migrationDialogFuncPackBotMessage": "ノード機能ボットを移行するには、事前に Azure Functions Pack を使用してパッケージ化する必要があります。",
    "migrationDialogFuncPackBotLinkText": "ボット コード上で Azure Functions Pack を実行する方法について学習する",
    "tosDialog_Header": "サービス条件",
    "tosDialog_AgreeButton": "同意",
    "tosDialog_MessageChannels": "オンライン サービス条件はチャンネルでの公開には適用されません。たとえば、Microsoft チャンネルでの公開に関する条件では、データ処理条件が提供されません。",
    "tosDialog_MessageMigration": "以下の条件を読んで同意してください。",
    "tosDialog_AzureTermsCheckbox": "Bot Framework サイトの使用が {0} および {1} の対象になることに同意します。",
    "tosDialog_CortanaTermsCheckbox": "Cortana チャンネルへのデプロイに関する{0}および{1}に同意します。",
    "tosDialog_CombinedTermsCheckboxOneChannel": "<%= channelslist %> チャンネルへのデプロイに関する{0}および{1}に同意します。",
    "tosDialog_CombinedTermsCheckboxMultiChannels": "<%= channelslist %> チャンネルへのデプロイに関する{0}および{1}に同意します。",
    "tosDialog_ABSTerms": "Azure Bot Service のサブスクリプション使用条件",
    "tosDialog_MSKnowledgeGraphTerms": "Cortana チャンネル公開条件",
    "tosDialog_MSPublicationTerms": "Microsoft チャンネル公開使用条件",
    "tosDialog_MSPrivacyStatement": "Microsoft プライバシーに関する声明",
    "notice": " 注意: ",
    "listElem": "{0}、",
    "andListEnd": "{0} および {1}",
    "analyticsChannelsDropdown": "チャンネル フィルター",
    "analyticsPeriodDropdown": "期間",
    "deprecatedChannel": "(非推奨)",
    "openInComposer": "Composer で開く",
    "downloadComposer": "Composer のダウンロード",
}

const Resources_ko: IResources = {
    "unsupportedBrowser_Azure": "Azure Bot Service가 아직 브라우저를 지원하지 않습니다.",
    "unsupportedBrowser": "Bot Framework가 아직 브라우저를 지원하지 않습니다.",
    "botKindRegistration": "Bot Services Bot",
    "botKindSdk": "Web App Bot",
    "botKindFunctions": "Functions Bot",
    "botKindConversationDesigner": "Conversation Designer Bot",
    "loggingIn": "로그인하는 중",
    "loadingBot": "봇 불러오는 중…",
    "botIsNotReady": "봇 준비를 기다리는 중",
    "analyticsNotReady": "구성될 Application Insights를 기다리는 중",
    "authorizingWebChat": "봇으로 채팅 인증 중",
    "signInFailure": "로그인하는 중에 오류가 발생했습니다. 브라우저에 제3자 쿠키가 활성화되어 있는지 확인하십시오.",
    "getChatTokenFailure": "채팅 인증 토큰을 가져오는 중에 오류가 발생했습니다. 새로고침하고 다시 시도하십시오.",
    "refreshSignInFailure": "로그인 정보를 갱신하는 중에 오류가 발생했습니다. 브라우저에 제3자 쿠키가 활성화되어 있는지 확인하십시오.",
    "xhrResponse_400": "행동이나 공급 값이 유효하지 않습니다.",
    "xhrResponse_403": "이 아이템은 접근이나 수정이 불가능합니다.",
    "xhrResponse_404": "이 아이템은 찾을 수 없습니다.",
    "xhrResponse_500": "서버에 내부 오류가 발생했습니다.",
    "xhrResponse_501": "이 작업은 지원되지 않습니다.",
    "xhrResponse_Message": "오류: %1",
    "xhrResponse_Unknown": "알 수 없는 오류가 발생했습니다.",
    "AddAFeaturedChannelTitle": "추천 채널 추가",
    "ConnectToChannelsTitle": "채널에 연결하세요.",
    "NoChannelsConfigured": "아직 채널을 연결할 수 없습니다. 연결할 채널을 선택하세요.",
    "MoreChannelsTitle": "채널 더 보기",
    "test": "검사",
    "startOver": "다시 시작",
    "retentionTitle": "보존",
    "retentionDescription": "다시 메시지를 보낸 사용자 %명 (지난 10일간)",
    "retentionHeader": "일 후",
    "retentionDate": "날짜",
    "retentionUsers": "사용자",
    "undetermined": "미확인",
    "loading": "로드 중...",
    "noAnalyticsData": "데이터 없음",
    "timespanLastHour": "지난 시간",
    "timespanLastDay": "어제",
    "timespanLastWeek": "지난주",
    "timespanLastMonth": "지난달",
    "timespanLast90Days": "지난 90일",
    "timespanUnknown": "알 수 없는 주기",
    "timelineCardUsersTitle": "사용자",
    "timelineCardMessagesTitle": "활동",
    "totalsCardTitle": "총 합계",
    "analyticsNotConfigured": "아직 Azure Application Insights를 통한 분석을 활성화할 수 없습니다.",
    "analyticsNotConfiguredAction": "다음 페이지에서 이 봇의 Application Insights 키와 ID를 제공하세요.",
    "analyticsNotConfiguredActionIbiza": "설정 페이지에서 이 봇의 Application Insights 키와 ID를 제공하세요.",
    "learnMore": "자세히 알아보기",
    "cardTitleLoading": "%1 - %2",
    "cardTitleError": "%1 - 오류: %2",
    "timelineTableLabel": "타임 테이블 매핑 %1(시간별)",
    "timelineChartLabel": "시간별 타임라인 차트 매핑 %1",
    "published": "게시됨",
    "health": "건강",
    "channelname": "이름",
    "edit": "편집",
    "running": "달리기",
    "issuesTemplate": "문제 (<%= length %>)",
    "warningTemplate": "경고 (<%= length %>)",
    "channelPublished": "게시됨",
    "tryOnCortana": "<%= Name %>에 시도 - 방법 배우기",
    "tryOnChannel": "<%= Name %>에 시도",
    "manageInCortana": "Cortana 대시보드에서 관리",
    "channelRejected": "거절됨",
    "channelMoreDetails": "더 자세한 내용",
    "channelResubmit": "검토를 위해 재제출…",
    "channelGetEmbedCodes": "봇 임베드 코드 얻기",
    "channelConfigDeleteMessage": "이 행동은 모든 채널 구성 정보를 삭제합니다. 정말로 진행하시겠습니까?",
    "channelConfigDeleteHeader": "채널 삭제",
    "channelConfigDeleteOk": "예. 삭제하겠습니다.",
    "channelConfigDeleteCancel": "아니요, 유지하겠습니다.",
    "channelConfigLeaveMessage": "이 문서에 저장되지 않은 변경 사항이 있습니다. 정말로 이 페이지에서 나가시겠습니까?",
    "channelConfigLeaveHeader": "변경 취소",
    "channelConfigLeaveOk": "예. 페이지를 떠나겠습니다.",
    "channelConfigLeaveCancel": "아니요. 페이지에 남겠습니다.",
    "channelEdit": "편집",
    "dialogPleaseWait": "잠시 기다려 주십시오...",
    "embedPanelTitle": "봇 임베드 코드",
    "embedPanelDescription": "임베드 코드를 얻을 채널을 선택하세요. 코드를 웹사이트에 복사 및 붙여넣기하세요.",
    "embedPanelFacebookFooter": "이 임베드 Facebook을 사용하려면 페이지에 JavaScript SDK를 포함해야 합니다.",
    "embedPanelLearnMore": "자세히 알아보기",
    "embedPanelChannelMovedHeader": "%1용 임베드 코드가 이동했습니다.",
    "embedPanelChannelMovedInstructions": "%1 구성 페이지를 열려면 이곳을 클릭하세요.",
    "embedPanelEmbedcodeForChannelLabel": "%1용 임베드 코드",
    "embedPanelGettingCodes": "코드 획득 중…",
    "embedPanelNoCodeAvailable": "이 봇에서 사용 가능한 임베드 코드가 없습니다.",
    "channelIssuesPanelSubtitle": "최근 문제",
    "channelIssuesPanelClearall": "모두 지우기",
    "channelIssuesPanelTimeColumnLabel": "시간",
    "channelIssuesPanelMessageColumnLabel": "메시지",
    "channelIssuesPanelCorrelationIdColumnLabel": "상관 관계 ID",
    "unsavedChangesWillBeLost": "저장되지 않은 변경 사항은 사라집니다.",
    "altImageChannel": "%1 채널 구성",
    "Bing": "Bing",
    "Cortana": "Cortana",
    "MicrosoftSearch": "Microsoft Search",
    "DirectLine": "Direct Line",
    "Email": "전자 메일",
    "FacebookMessenger": "Facebook Messenger",
    "GroupMe": "GroupMe",
    "Kaizala": "Kaizala",
    "Kik": "Kik",
    "MicrosoftTeams": "Microsoft Teams",
    "Skype": "Skype",
    "SkypeforBusiness": "업무용 Skype",
    "_SkypeforBusiness": "비즈니스 브랜드용 Skype",
    "Slack": "Slack",
    "Telegram": "Telegram",
    "Twilio": "Twilio (SMS)",
    "migrationBannerCTAMigrateBot": "이 봇 마이그레이션",
    "migrationBannerCTAStartMigrating": "마이그레이션 시작",
    "migrationBannerBlurb1": "새로운 Azure Bot Service 출시 시, 2018년 3월 31일까지 새로운 서비스에 모든 봇을 마이그레이션합니다.",
    "migrationBannerBlurb2": "마이그레이션 정보입니다.",
    "migrationBannerSuggestedBlurb": "Azure Bot Service로 마이그레이션은 이 봇에 선택 사항입니다.",
    "migrationBannerPostDeadlineBlurb": "Azure Bot Service에 마이그레이션이 필요한 봇은 서비스 중단을 방지하기 위해 지금 마이그레이션해야 합니다.",
    "migrationBannerBlockedBlurb": "봇 마이그레이션 기한이 지났습니다. 지금 마이그레이션하여 서비스 중단을 방지하십시오.",
    "migrationWillBeRequiredDialogMessage": "이 채널을 구성하는 경우, 귀하의 봇은 2018년 3월 31일까지 Azure Bot Service에 마이그레이션되어야 합니다. 정말로 이 채널을 구성하시겠습니까?",
    "channelRequiresMigrationDialogMessage": "이 채널은 Azure Bot Service의 봇에만 사용할 수 있습니다. 이 봇을 마이그레이션하시겠습니까?",
    "channelRequiresABSBot": "이 채널은 Azure Bot Service의 봇에만 사용할 수 있습니다.",
    "botRequiresMigrationDialogHeader": "봇에 마이그레이션이 필요합니다",
    "botRequiresMigrationDialogMessage": "봇 마이그레이션 기한이 지났습니다. 지금 마이그레이션하여 서비스 중단을 방지하십시오.",
    "yesMigrateThisBot": "예, 이 봇을 마이그레이션합니다",
    "myBotsMigrationStatusMigrated": "마이그레이션됨",
    "myBotsMigrationStatusNotMigrated": "필수",
    "myBotsMigrationStatusOptionalMigration": "필요하지 않음",
    "myBotsMigrationButtonMigrate": "마이그레이션",
    "myBotsMigrationButtonRollback": "마이그레이션 롤백",
    "deleteBotDialogDeleteButtonText": "봇 삭제",
    "cancelButtonText": "취소",
    "deleteBotDialogTitleText": "이 봇을 삭제하려고 합니다.",
    "deleteBotDialogBodyText": "이 작업은 이 봇과 관련된 모든 데이터를 삭제하며 되돌릴 수 없습니다. 계속하시겠습니까?",
    "deleteBotDialogStatusDeleting": "봇 삭제 중...",
    "deleteBotDialogStatusDeleted": "봇 삭제됨",
    "rollbackBotDialogRollbackButtonText": "예, 롤백합니다.",
    "rollbackBotDialogTitleText": "정말로 롤백하시겠습니까?",
    "rollbackBotDialogBodyText": "이 작업은 마이그레이션을 완전히 롤백하므로, 마이그레이션 과정을 처음부터 시작해야 합니다. 정말로 계속하시겠습니까?",
    "rollbackBotDialogErrorInfo": "서버에서 봇 정보를 받는 중 오류가 발생했습니다.",
    "rollbackBotDialogErrorNoEndpoint": "롤백을 수행할 수 없습니다. 롤백 끝점을 찾을 수 없습니다.",
    "rollbackBotDialogErrorNoAzureToken": "롤백을 수행할 수 없습니다. Azure에 연락할 수 있는 Azure 토큰을 찾는 데 실패했습니다.",
    "rollbackBotDialogStatusGettingInfo": "봇 정보 수집 중...",
    "rollbackBotDialogStatusPreparing": "봇 준비 중...",
    "rollbackBotDialogStatusReverting": "봇 되돌리기 중...",
    "rollbackBotDialogStatusDeletingApp": "업그레이드된 앱 삭제 중...",
    "rollbackBotDialogStatusDeletingDeployment": "배포 기록 삭제 중...",
    "rollbackBotDialogConfirmationTitleText": "롤백 완료",
    "rollbackBotDialogConfirmationBodyText": "롤백되었습니다.",
    "okButtonText": "확인",
    "errorMessageErrorOccurred": "오류가 발생했습니다.",
    "migrationDialogStatusGettingBotInfo": "봇 정보 받는 중...",
    "migrationDialogStatusGettingAzureInfo": "Azure 정보 받는 중...",
    "migrationDialogStatusGettingAppSettings": "봇 앱 설정 받는 중...",
    "migrationDialogStatusDeployingMigrationBot": "마이그레이션된 봇 초기 설정 중...",
    "migrationDialogStatusRegisteringWithAzure": "Azure로 봇 서비스 등록 중...",
    "migrationDialogStatusUpdatingBotRecord": "봇 기록 업데이트 중...",
    "migrationDialogStatusCreatingRG": "리소스 그룹 생성 중...",
    "migrationDialogStatusMigratingFiles": "새로운 봇에 파일 마이그레이션 중...",
    "migrationDialogStatusWrappingUp": "배포 끝내는 중...",
    "migrationDialogStatusDeployingStorage": "기존 저장소에 봇 연결 중...",
    "migrationDialogStatusDeployingSite": "웹 사이트 배포 중",
    "migrationDialogStatusConfiguringSite": "웹 사이트 구성 중",
    "migrationDialogStatusDeploying": "배포 중",
    "migrationDialogStatusFunctionCredentials": "새로운 기능 앱 자격 증명 받는 중...",
    "migrationDialogErrorNoSubs": "현재 사용자에 대한 Azure 구독을 찾는 데 실패했습니다.",
    "migrationDialogErrorNoAzureToken": "현재 사용자에 대한 Azure 권한 토큰을 찾는 데 실패했습니다.",
    "migrationDialogErrorNoLocations": "선택한 Azure 구독에 대한 위치를 찾는 데 실패했습니다.",
    "migrationDialogErrorNoAzureStorage": "앱 구성에서 Azure 저장소 계정 이름을 찾는 데 실패했습니다.",
    "migrationDialogErrorAppNameUnavailable": "앱 이름을 사용할 수 없습니다.",
    "migrationDialogErrorAppNameInvalid": "유효하지 않은 앱 이름입니다.",
    "migrationDialogErrorNoBotType": "현재 봇은 유효한 유형이 아닙니다.",
    "migrationDialogErrorBotInvalid": "이 봇은 유효하지 않기 대문에 마이그레이션될 수 없습니다.",
    "migrationDialogErrorEndpointMissing": "이 봇은 끝점이 없기 때문에 마이그레이션될 수 없습니다.",
    "migrationDialogErrorProvisionInfoMissing": "이 봇은 프로비전 정보가 없기 때문에 마이그레이션될 수 없습니다.",
    "migrationDialogErrorResourceGroupNameMissing": "이 봇은 리소스 그룹 이름이 없기 때문에 마이그레이션될 수 없습니다.",
    "migrationDialogErrorSubscriptionIdMissing": "이 봇은 Azure 구독 ID가 없기 때문에 마이그레이션될 수 없습니다.",
    "migrationDialogErrorSiteNameMissing": "이 봇은 Azure 사이트 이름이 없기 때문에 마이그레이션될 수 없습니다.",
    "migrationDialogABSv2TitleText": "마이그레이션 이용 불가",
    "migrationDialogABSv2BodyText": "현재 대화 디자이너(ABSv2) 봇에 대한 마이그레이션이 비활성화되었습니다.",
    "migrationDialogRegistrationBodyText": "'{0}' 봇에 대한 마이그레이션이 현재 비활성화되었습니다.",
    "migrationDialogFailedTokenRefresh": "Azure 토큰이 만료되었습니다.",
    "migrationDialogRefreshPage": "페이지를 새로고침하고 마이그레이션을 재시도하십시오.",
    "migrationSubscriptionDisabled": "선택한 Azure 구독이 비활성화되었습니다. 마이그레이션을 계속하려면 활성화하십시오.",
    "migrationTenantHasNoSubscriptions": "이 디렉터리는 구독을 포함하지 않습니다.",
    "migrationDialogFuncPackBotTitle": "이 봇을 마이그레이션하려면 Azure Functions 팩이 필요합니다.",
    "migrationDialogFuncPackBotMessage": "노드 기능 봇은 마이그레이션되기 전에 Azure Functions 팩으로 패키지되어야 합니다.",
    "migrationDialogFuncPackBotLinkText": "봇 코드에서 Azure Functions를 실행하는 방법 알아보기",
    "tosDialog_Header": "서비스 약관",
    "tosDialog_AgreeButton": "동의",
    "tosDialog_MessageChannels": "온라인 서비스 약관은 채널의 발행에 적용되지 않습니다. 예를 들어, Microsoft 채널의 발행에 대한 약관은 데이터 처리 약관을 제공하지 않습니다.",
    "tosDialog_MessageMigration": "다음 약관을 읽고 동의하십시오.",
    "tosDialog_AzureTermsCheckbox": "봇 프레임워크 사이트가 {0} 및 {1}에 사용되는 것을 동의합니다.",
    "tosDialog_CortanaTermsCheckbox": "Cortana 채널에 대한 내 배포를 위해 {0} 및 {1}에 동의합니다.",
    "tosDialog_CombinedTermsCheckboxOneChannel": "<%= channelslist %> 채널에 대한 내 배포를 위해 {0} 및 {1}에 동의합니다.",
    "tosDialog_CombinedTermsCheckboxMultiChannels": "<%= channelslist %> 채널에 대한 내 배포를 위해 {0} 및 {1}에 동의합니다.",
    "tosDialog_ABSTerms": "Azure Bot Service에 대한 내 구독 기간입니다.",
    "tosDialog_MSKnowledgeGraphTerms": "Cortana 채널 게시 약관",
    "tosDialog_MSPublicationTerms": "Microsoft 채널 발행 약관",
    "tosDialog_MSPrivacyStatement": "Microsoft 개인정보 보호정책",
    "notice": " 공지: ",
    "listElem": "{0},",
    "andListEnd": "{0} 및 {1}",
    "analyticsChannelsDropdown": "채널 필터",
    "analyticsPeriodDropdown": "주기",
    "deprecatedChannel": "(사용되지 않음)",
    "openInComposer": "Composer에서 열기",
    "downloadComposer": "Composer 다운로드",
}

const Resources_ru: IResources = {
    "unsupportedBrowser_Azure": "Служба Azure Bot еще не поддерживает ваш браузер.",
    "unsupportedBrowser": "Bot Framework еще не поддерживает ваш браузер.",
    "botKindRegistration": "Bot Services Bot",
    "botKindSdk": "Web App Bot",
    "botKindFunctions": "Functions Bot",
    "botKindConversationDesigner": "Conversation Designer Bot",
    "loggingIn": "Выполняется вход",
    "loadingBot": "Загрузка программы-робота...",
    "botIsNotReady": "Ожидание готовности бота",
    "analyticsNotReady": "Ожидание настройки Application Insights",
    "authorizingWebChat": "Авторизация чата с ботом",
    "signInFailure": "Во время входа произошла ошибка. Убедитесь, что в браузере разрешены сторонние файлы cookie.",
    "getChatTokenFailure": "При получении токена авторизации чата произошла ошибка. Обновите страницу и повторите попытку.",
    "refreshSignInFailure": "При обновлении данных для входа произошла ошибка. Убедитесь, что в браузере разрешены сторонние файлы cookie.",
    "xhrResponse_400": "Действие или заданные значения недопустимы.",
    "xhrResponse_403": "Этот элемент недоступен или изменен.",
    "xhrResponse_404": "Элемент не найден.",
    "xhrResponse_500": "На сервере произошла внутренняя ошибка.",
    "xhrResponse_501": "Эта операция не поддерживается.",
    "xhrResponse_Message": "Ошибка: %1",
    "xhrResponse_Unknown": "Произошла неизвестная ошибка.",
    "AddAFeaturedChannelTitle": "Добавить рекомендуемый канал",
    "ConnectToChannelsTitle": "Подключиться к каналам",
    "NoChannelsConfigured": "Вы еще не подключили ни одного канала. Выберите канал для подключения.",
    "MoreChannelsTitle": "Другие каналы",
    "test": "Испытание",
    "startOver": "Начать заново",
    "retentionTitle": "Хранение",
    "retentionDescription": "% пользователей, которые отправляли сообщения снова (за последние 10 дней)",
    "retentionHeader": "Днями позже",
    "retentionDate": "Дата",
    "retentionUsers": "Пользователи",
    "undetermined": "Не определено",
    "loading": "Идет загрузка...",
    "noAnalyticsData": "Нет данных",
    "timespanLastHour": "За последний час",
    "timespanLastDay": "За последний день",
    "timespanLastWeek": "За последнюю неделю",
    "timespanLastMonth": "За последний месяц",
    "timespanLast90Days": "Последние 90 дней",
    "timespanUnknown": "Неизвестный период",
    "timelineCardUsersTitle": "Пользователи",
    "timelineCardMessagesTitle": "Действия",
    "totalsCardTitle": "Общие итоги",
    "analyticsNotConfigured": "Вы еще не включили аналитику через Azure Application Insights.",
    "analyticsNotConfiguredAction": "Предоставьте ключи Application Insights и идентификаторы для программы-робота на следующей странице:",
    "analyticsNotConfiguredActionIbiza": "Предоставьте ключи Application Insights и идентификаторы для программы-робота на странице настроек.",
    "learnMore": "Узнать больше",
    "cardTitleLoading": "%1 — %2",
    "cardTitleError": "%1 — ошибка: %2",
    "timelineTableLabel": "Сопоставление таблицы временной шкалы \"%1\" по времени",
    "timelineChartLabel": "Сопоставление диаграммы временной шкалы \"%1\" по времени",
    "published": "Опубликовано",
    "health": "Здоровье",
    "channelname": "Имя",
    "edit": "Изменить",
    "running": "Бег",
    "issuesTemplate": "Проблемы (<%= length %>)",
    "warningTemplate": "Предупреждения (<%= length %>)",
    "channelPublished": "Опубликовано",
    "tryOnCortana": "Протестировать на <%= Name %> — узнать как",
    "tryOnChannel": "Протестировать на <%= Name %>",
    "manageInCortana": "Открыть на панели управления Кортана",
    "channelRejected": "Отклонено",
    "channelMoreDetails": "Подробнее",
    "channelResubmit": "Повторная отправка на проверку...",
    "channelGetEmbedCodes": "Получить встроенные коды программ-роботов",
    "channelConfigDeleteMessage": "Действие удалит всю информацию о конфигурации канала. Продолжить?",
    "channelConfigDeleteHeader": "Удалить канал",
    "channelConfigDeleteOk": "Да, удалить",
    "channelConfigDeleteCancel": "Нет, не удалять",
    "channelConfigLeaveMessage": "В этом документе есть несохраненные изменения. Вы действительно хотите уйти со страницы?",
    "channelConfigLeaveHeader": "Отменить изменения",
    "channelConfigLeaveOk": "Да, уйти со страницы",
    "channelConfigLeaveCancel": "Нет, остаться на странице",
    "channelEdit": "Изменить",
    "dialogPleaseWait": "Подождите...",
    "embedPanelTitle": "Встроенный код программы-робота",
    "embedPanelDescription": "Выберите канал, чтобы получить для него встроенный код. Скопируйте и вставьте код на свой сайт.",
    "embedPanelFacebookFooter": "Чтобы использовать этот встроенный код Facebook, вы должны включить на своей странице его JavaScript.",
    "embedPanelLearnMore": "Узнать больше",
    "embedPanelChannelMovedHeader": "Встроенный код для канала %1 перемещен",
    "embedPanelChannelMovedInstructions": "Нажмите здесь, чтобы открыть страницу настроек канала %1",
    "embedPanelEmbedcodeForChannelLabel": "Встроенный код для канала %1",
    "embedPanelGettingCodes": "Получение кодов...",
    "embedPanelNoCodeAvailable": "Для этого бота нет доступного встроенного кода.",
    "channelIssuesPanelSubtitle": "Последние проблемы",
    "channelIssuesPanelClearall": "Очистить все",
    "channelIssuesPanelTimeColumnLabel": "Время",
    "channelIssuesPanelMessageColumnLabel": "Сообщение",
    "channelIssuesPanelCorrelationIdColumnLabel": "Идентификатор корреляции",
    "unsavedChangesWillBeLost": "Несохраненные изменения будут потеряны.",
    "altImageChannel": "Настройка канала %1",
    "Bing": "Bing",
    "Cortana": "Кортана",
    "MicrosoftSearch": "Microsoft Search",
    "DirectLine": "Direct Line",
    "Email": "Электронная почта",
    "FacebookMessenger": "Facebook Messenger",
    "GroupMe": "GroupMe",
    "Kaizala": "Kaizala",
    "Kik": "Kik",
    "MicrosoftTeams": "Microsoft Teams",
    "Skype": "Skype",
    "SkypeforBusiness": "Skype для бизнеса",
    "_SkypeforBusiness": "Skype для бизнеса (бренд)",
    "Slack": "Slack",
    "Telegram": "Telegram",
    "Twilio": "Twilio (SMS)",
    "migrationBannerCTAMigrateBot": "ПЕРЕНЕСТИ ЭТОГО БОТА",
    "migrationBannerCTAStartMigrating": "НАЧАЛО МИГРАЦИИ",
    "migrationBannerBlurb1": "При запуске новой службы Azure Bot все боты будут перенесены в новую службу до 31.03.2018.",
    "migrationBannerBlurb2": "О миграции.",
    "migrationBannerSuggestedBlurb": "Перенос этого бота в службу Azure Bot необязателен.",
    "migrationBannerPostDeadlineBlurb": "Ботов, требующих переноса в службу Azure Bot, необходимо перенести прямо сейчас, чтобы не допустить нарушения работы службы.",
    "migrationBannerBlockedBlurb": "Перенос бота просрочен. Перенесите его, чтобы не допустить нарушения работы службы.",
    "migrationWillBeRequiredDialogMessage": "При настройке этого канала необходимо перенести бота в службу Azure Bot до 31.03.2018. Вы действительно хотите настроить этот канал?",
    "channelRequiresMigrationDialogMessage": "Этот канал доступен только для ботов в службе Azure Bot. Перенести этого бота?",
    "channelRequiresABSBot": "Этот канал доступен только для ботов в службе Azure Bot.",
    "botRequiresMigrationDialogHeader": "Необходимо перенести бота",
    "botRequiresMigrationDialogMessage": "Перенос бота просрочен. Перенесите его, чтобы не допустить нарушения работы службы.",
    "yesMigrateThisBot": "Да, перенести этого бота",
    "myBotsMigrationStatusMigrated": "Миграция выполнена",
    "myBotsMigrationStatusNotMigrated": "Обязательно",
    "myBotsMigrationStatusOptionalMigration": "Не требуется",
    "myBotsMigrationButtonMigrate": "Миграция",
    "myBotsMigrationButtonRollback": "Откат миграции",
    "deleteBotDialogDeleteButtonText": "Удалить бота",
    "cancelButtonText": "Отмена",
    "deleteBotDialogTitleText": "Вы собираетесь удалить этого бота",
    "deleteBotDialogBodyText": "Все данные, связанные с этим ботом, будут безвозвратно удалены. Вы уверены?",
    "deleteBotDialogStatusDeleting": "Удаление бота...",
    "deleteBotDialogStatusDeleted": "Бот удален",
    "rollbackBotDialogRollbackButtonText": "Да, выполнить откат",
    "rollbackBotDialogTitleText": "Вы действительно хотите выполнить откат?",
    "rollbackBotDialogBodyText": "Будет выполнен полный откат миграции, и процедуру миграции придется начать сначала. Продолжить?",
    "rollbackBotDialogErrorInfo": "Ошибка при получении сведений бота с сервера.",
    "rollbackBotDialogErrorNoEndpoint": "Невозможно выполнить откат. Не удалось найти конечную точку.",
    "rollbackBotDialogErrorNoAzureToken": "Невозможно выполнить откат. Не удалось найти токен Azure для подключения к Azure.",
    "rollbackBotDialogStatusGettingInfo": "Идет сбор сведений бота...",
    "rollbackBotDialogStatusPreparing": "Идет подготовка бота...",
    "rollbackBotDialogStatusReverting": "Идет откат бота...",
    "rollbackBotDialogStatusDeletingApp": "Удаление обновленного приложения...",
    "rollbackBotDialogStatusDeletingDeployment": "Удаление записи развертывания...",
    "rollbackBotDialogConfirmationTitleText": "Выполнен откат",
    "rollbackBotDialogConfirmationBodyText": "— успешно выполнен откат.",
    "okButtonText": "ОК",
    "errorMessageErrorOccurred": "Произошла ошибка",
    "migrationDialogStatusGettingBotInfo": "Получение сведений бота...",
    "migrationDialogStatusGettingAzureInfo": "Получение сведений Azure...",
    "migrationDialogStatusGettingAppSettings": "Получение параметров приложения бота...",
    "migrationDialogStatusDeployingMigrationBot": "Инициализация перенесенного бота...",
    "migrationDialogStatusRegisteringWithAzure": "Регистрация службы бота в Azure...",
    "migrationDialogStatusUpdatingBotRecord": "Обновление записи бота...",
    "migrationDialogStatusCreatingRG": "Создание группы ресурсов...",
    "migrationDialogStatusMigratingFiles": "Миграция файлов в нового бота...",
    "migrationDialogStatusWrappingUp": "Размещение развертывания...",
    "migrationDialogStatusDeployingStorage": "Подключение бота к существующему хранилищу...",
    "migrationDialogStatusDeployingSite": "Развертывание веб-сайта",
    "migrationDialogStatusConfiguringSite": "Настройка веб-сайта",
    "migrationDialogStatusDeploying": "Развертывание",
    "migrationDialogStatusFunctionCredentials": "Получение учетных данных нового приложения-функции...",
    "migrationDialogErrorNoSubs": "Не удалось найти подписки Azure для текущего пользователя.",
    "migrationDialogErrorNoAzureToken": "Не удалось найти токен доступа Azure для текущего пользователя.",
    "migrationDialogErrorNoLocations": "Не удалось найти расположения для выбранной подписки Azure.",
    "migrationDialogErrorNoAzureStorage": "Не удалось найти имя учетной записи хранилища Azure в конфигурации приложения.",
    "migrationDialogErrorAppNameUnavailable": "Имя приложения недоступно.",
    "migrationDialogErrorAppNameInvalid": "Недопустимое имя приложения.",
    "migrationDialogErrorNoBotType": "Недопустимый тип этого бота.",
    "migrationDialogErrorBotInvalid": "Миграция этого бота невозможна, поскольку он является недопустимым.",
    "migrationDialogErrorEndpointMissing": "Миграция этого бота невозможна, поскольку отсутствует конечная точка.",
    "migrationDialogErrorProvisionInfoMissing": "Миграция этого бота невозможна, поскольку отсутствуют сведения о подготовке.",
    "migrationDialogErrorResourceGroupNameMissing": "Миграция этого бота невозможна, поскольку отсутствует группа ресурсов.",
    "migrationDialogErrorSubscriptionIdMissing": "Миграция этого бота невозможна, поскольку отсутствует код подписки Azure.",
    "migrationDialogErrorSiteNameMissing": "Миграция этого бота невозможна, поскольку отсутствует имя сайта Azure.",
    "migrationDialogABSv2TitleText": "Миграция недоступна",
    "migrationDialogABSv2BodyText": "Миграция для ботов конструктора общения (ABSv2) сейчас отключена.",
    "migrationDialogRegistrationBodyText": "Сейчас миграция отключена для ботов \"{0}\".",
    "migrationDialogFailedTokenRefresh": "Срок действия токена Azure истек.",
    "migrationDialogRefreshPage": "Обновите страницу и повторите попытку миграции.",
    "migrationSubscriptionDisabled": "Выбранная подписка Azure отключена. Включите ее для продолжения миграции.",
    "migrationTenantHasNoSubscriptions": "В этом каталоге нет подписки.",
    "migrationDialogFuncPackBotTitle": "Для миграции этого бота необходим пакет функций Azure",
    "migrationDialogFuncPackBotMessage": "Перед миграцией боты Node Functions должны быть упакованы с помощью пакета функций Azure.",
    "migrationDialogFuncPackBotLinkText": "Подробнее о запуске пакета функций Azure в своем коде бота",
    "tosDialog_Header": "Условия использования",
    "tosDialog_AgreeButton": "Принимаю",
    "tosDialog_MessageChannels": "Условия Online Services не распространяются на публикацию каналов. Например, условия публикации в каналах Майкрософт не предполагают обработку данных.",
    "tosDialog_MessageMigration": "Прочтите и примите следующие условия.",
    "tosDialog_AzureTermsCheckbox": "Я соглашаюсь с тем, что {0} и {1} регулируют использование Bot Framework.",
    "tosDialog_CortanaTermsCheckbox": "Я соглашаюсь с условиями {0} и {1} для своего развертывания в канале Кортаны.",
    "tosDialog_CombinedTermsCheckboxOneChannel": "Я соглашаюсь с условиями {0} и {1} для своего развертывания в канале <%= channelslist %>.",
    "tosDialog_CombinedTermsCheckboxMultiChannels": "Я соглашаюсь с условиями {0} и {1} для своего развертывания в каналах <%= channelslist %>.",
    "tosDialog_ABSTerms": "условия подписки на службу Azure Bot",
    "tosDialog_MSKnowledgeGraphTerms": "Условия публикации канала Кортаны",
    "tosDialog_MSPublicationTerms": "Условия Microsoft Channel Publication",
    "tosDialog_MSPrivacyStatement": "Заявления о конфиденциальности Майкрософт",
    "notice": " УВЕДОМЛЕНИЕ: ",
    "listElem": "{0},",
    "andListEnd": "{0} и {1}",
    "analyticsChannelsDropdown": "Фильтр каналов",
    "analyticsPeriodDropdown": "Период времени",
    "deprecatedChannel": "(устарел)",
    "openInComposer": "открыть в Composer",
    "downloadComposer": "Скачать Composer",
}

const Resources_cs: IResources = {
    "unsupportedBrowser_Azure": "Služba Azure Bot Service zatím nepodporuje váš prohlížeč.",
    "unsupportedBrowser": "Služba Bot Framework zatím nepodporuje váš prohlížeč.",
    "botKindRegistration": "Bot Services Bot",
    "botKindSdk": "Web App Bot",
    "botKindFunctions": "Functions Bot",
    "botKindConversationDesigner": "Conversation Designer Bot",
    "loggingIn": "Přihlašování",
    "loadingBot": "Robot se načítá...",
    "botIsNotReady": "Čeká se, až bude robot připravený",
    "analyticsNotReady": "Čeká se na konfiguraci Application Insights",
    "authorizingWebChat": "Autorizování chatu s robotem",
    "signInFailure": "Při přihlašování došlo k chybě. Ujistěte se, že máte v prohlížeči povolené soubory cookies třetích stran.",
    "getChatTokenFailure": "Při získávání autorizačního tokenu pro chat došlo k chybě. Aktualizujte stránku a zkuste to znovu.",
    "refreshSignInFailure": "Při obnovování vašich přihlašovacích informací došlo k chybě. Ujistěte se, že máte v prohlížeči povolené soubory cookies třetích stran.",
    "xhrResponse_400": "Akce nebo poskytnuté hodnoty nejsou platné.",
    "xhrResponse_403": "Tuto položku nelze otevřít nebo upravit.",
    "xhrResponse_404": "Položku nelze nalézt.",
    "xhrResponse_500": "Na serveru došlo k vnitřní chybě.",
    "xhrResponse_501": "Tato operace není podporována.",
    "xhrResponse_Message": "Chyba: %1",
    "xhrResponse_Unknown": "Došlo k neznámé chybě.",
    "AddAFeaturedChannelTitle": "Přidat vybraný kanál",
    "ConnectToChannelsTitle": "Připojení ke kanálům",
    "NoChannelsConfigured": "Ještě jste nepřipojili žádné kanály. Vyberte kanál, který chcete připojit.",
    "MoreChannelsTitle": "Další kanály",
    "test": "Test",
    "startOver": "Začít znovu",
    "retentionTitle": "Retence",
    "retentionDescription": "% uživatelů, kteří napsali znovu (posledních 10 dní)",
    "retentionHeader": "Po kolika dnech",
    "retentionDate": "Datum",
    "retentionUsers": "Uživatelé",
    "undetermined": "Neurčeno",
    "loading": "načítá se...",
    "noAnalyticsData": "žádná data",
    "timespanLastHour": "Poslední hodina",
    "timespanLastDay": "Poslední den",
    "timespanLastWeek": "Poslední týden",
    "timespanLastMonth": "Poslední měsíc",
    "timespanLast90Days": "Posledních 90 dnů",
    "timespanUnknown": "Neznámý časový rozsah",
    "timelineCardUsersTitle": "Uživatelé",
    "timelineCardMessagesTitle": "Aktivity",
    "totalsCardTitle": "Celkové součty",
    "analyticsNotConfigured": "Zatím jste nepovolili analýzu pomocí Azure Application Insights.",
    "analyticsNotConfiguredAction": "Na následující stránce zadejte ID a klíče Application Insights pro tohoto robota: ",
    "analyticsNotConfiguredActionIbiza": "Zadejte pro tohoto robota ID a klíče Application Insights na stránce nastavení.",
    "learnMore": "Další informace",
    "cardTitleLoading": "%1 – %2",
    "cardTitleError": "%1 – chyba: %2",
    "timelineTableLabel": "Tabulka grafu %1 s časovou osou a mapováním podle času",
    "timelineChartLabel": "Graf %1 s časovou osou a mapováním podle času",
    "published": "Publikováno",
    "health": "Zdraví",
    "channelname": "Název",
    "edit": "Upravit",
    "running": "Běží",
    "issuesTemplate": "Problémy (<%= length %>)",
    "warningTemplate": "Upozornění (<%= length %>)",
    "channelPublished": "Publikováno",
    "tryOnCortana": "Zkuste <%= Name %> – zjistěte jak",
    "tryOnChannel": "Zkuste <%= Name %>",
    "manageInCortana": "Spravovat na řídicím panelu Cortany",
    "channelRejected": "Odmítnuto",
    "channelMoreDetails": "Další podrobnosti",
    "channelResubmit": "Znovu odeslat k revizi...",
    "channelGetEmbedCodes": "Získat kódy pro vložení robota",
    "channelConfigDeleteMessage": "Touto akcí odstraníte všechny informace o konfiguraci kanálu. Opravdu si přejete pokračovat?",
    "channelConfigDeleteHeader": "Odstranit kanál",
    "channelConfigDeleteOk": "Ano, odstranit",
    "channelConfigDeleteCancel": "Ne, ponechat",
    "channelConfigLeaveMessage": "V dokumentu máte neuložené změny. Opravdu chcete tuto stránku opustit?",
    "channelConfigLeaveHeader": "Zahodit změny",
    "channelConfigLeaveOk": "Ano, opustit stránku",
    "channelConfigLeaveCancel": "Ne, zůstat na stránce",
    "channelEdit": "Upravit",
    "dialogPleaseWait": "Počkejte prosím...",
    "embedPanelTitle": "Kód pro vložení robota",
    "embedPanelDescription": "Výběrem kanálu získáte jeho kód pro vložení. Tento kód zkopírujte a vložte na svůj web.",
    "embedPanelFacebookFooter": "Chcete-li použít tento vložený kód, musíte na své stránce zahrnout sadu JavaScript SDK, kterou Facebook vyžaduje.",
    "embedPanelLearnMore": "Další informace.",
    "embedPanelChannelMovedHeader": "Kód pro vložení kanálu %1 byl přesunut",
    "embedPanelChannelMovedInstructions": "Kliknutím sem otevřete stránku konfigurace kanálu %1",
    "embedPanelEmbedcodeForChannelLabel": "Kód pro vložení kanálu %1",
    "embedPanelGettingCodes": "Získávají se kódy...",
    "embedPanelNoCodeAvailable": "U tohoto robota není k dispozici žádný kód pro vložení.",
    "channelIssuesPanelSubtitle": "Nedávné problémy",
    "channelIssuesPanelClearall": "Vymazat vše",
    "channelIssuesPanelTimeColumnLabel": "Čas",
    "channelIssuesPanelMessageColumnLabel": "Zpráva",
    "channelIssuesPanelCorrelationIdColumnLabel": "ID korelace",
    "unsavedChangesWillBeLost": "Neuložené změny budou ztraceny.",
    "altImageChannel": "Konfigurovat kanál %1",
    "Bing": "Bing",
    "Cortana": "Cortana",
    "MicrosoftSearch": "Microsoft Search",
    "DirectLine": "Direct Line",
    "Email": "E-mail",
    "FacebookMessenger": "Facebook Messenger",
    "GroupMe": "GroupMe",
    "Kaizala": "Kaizala",
    "Kik": "Kik",
    "MicrosoftTeams": "Microsoft Teams",
    "Skype": "Skype",
    "SkypeforBusiness": "Skype pro firmy",
    "_SkypeforBusiness": "Značka Skype pro firmy",
    "Slack": "Slack",
    "Telegram": "Telegram",
    "Twilio": "Twilio (SMS)",
    "migrationBannerCTAMigrateBot": "MIGROVAT TOHOTO ROBOTA",
    "migrationBannerCTAStartMigrating": "ZAHÁJIT MIGRACI",
    "migrationBannerBlurb1": "V rámci spuštění nové služby Azure Bot Service migrujeme všechny roboty k 31. březnu 2018 do nové služby.",
    "migrationBannerBlurb2": "o migraci.",
    "migrationBannerSuggestedBlurb": "Migrace do služby Azure Bot Service je pro tohoto robota volitelná.",
    "migrationBannerPostDeadlineBlurb": "Roboty vyžadující migraci do služby Azure Bot Service je nutné migrovat hned teď, aby nedošlo k přerušení služby.",
    "migrationBannerBlockedBlurb": "Migrace robota je po termínu, migrujte ho prosím hned teď, aby nedošlo k přerušení služby.",
    "migrationWillBeRequiredDialogMessage": "Pokud nakonfigurujete tento kanál, bude nutné do 31. března 2018 migrovat vašeho robota do služby Azure Bot Service. Opravdu chcete tento kanál konfigurovat?",
    "channelRequiresMigrationDialogMessage": "Tento kanál je k dispozici pouze pro roboty ve službě Azure Bot Service. Chcete tohoto robota migrovat?",
    "channelRequiresABSBot": "Tento kanál je k dispozici jen pro boty služby Azure Bot Service.",
    "botRequiresMigrationDialogHeader": "Robot vyžaduje migraci",
    "botRequiresMigrationDialogMessage": "Migrace robota je po termínu, migrujte ho prosím hned teď, aby nedošlo k přerušení služby.",
    "yesMigrateThisBot": "Ano, migrovat tohoto robota",
    "myBotsMigrationStatusMigrated": "Migrován",
    "myBotsMigrationStatusNotMigrated": "Povinné",
    "myBotsMigrationStatusOptionalMigration": "Nepovinné",
    "myBotsMigrationButtonMigrate": "Migrovat",
    "myBotsMigrationButtonRollback": "Vrátit migraci zpět",
    "deleteBotDialogDeleteButtonText": "Odstranit robota",
    "cancelButtonText": "Zrušit",
    "deleteBotDialogTitleText": "Chystáte se odstranit tohoto robota",
    "deleteBotDialogBodyText": "Tato akce, kterou nejde vrátit, vymaže všechna data asociovaná s tímto robotem. Jste si jistí?",
    "deleteBotDialogStatusDeleting": "Odstraňování robota...",
    "deleteBotDialogStatusDeleted": "Robot odstraněn",
    "rollbackBotDialogRollbackButtonText": "Ano, vrátit zpět",
    "rollbackBotDialogTitleText": "Opravdu chcete provést vrácení zpět?",
    "rollbackBotDialogBodyText": "Tato akce kompletně vrátí migraci a vy budete muset začít proces migrace od začátku. Opravdu chcete pokračovat?",
    "rollbackBotDialogErrorInfo": "Při získávání informací robota ze serveru došlo k chybě.",
    "rollbackBotDialogErrorNoEndpoint": "Vrácení zpět nelze provést. Nebyl nalezen žádný koncový bod pro vrácení.",
    "rollbackBotDialogErrorNoAzureToken": "Vrácení zpět nelze provést. Nepodařilo se najít token Azure nutný k navázání kontaktu s Azure.",
    "rollbackBotDialogStatusGettingInfo": "Shromažďují se informace robota...",
    "rollbackBotDialogStatusPreparing": "Robot se připravuje...",
    "rollbackBotDialogStatusReverting": "Robot se vrací zpět...",
    "rollbackBotDialogStatusDeletingApp": "Odstraňuje se upgradovaná aplikace...",
    "rollbackBotDialogStatusDeletingDeployment": "Odstraňuje se záznam nasazení...",
    "rollbackBotDialogConfirmationTitleText": "Vrácení bylo dokončeno",
    "rollbackBotDialogConfirmationBodyText": "byla úspěšně vrácena.",
    "okButtonText": "OK",
    "errorMessageErrorOccurred": "Došlo k chybě",
    "migrationDialogStatusGettingBotInfo": "Získávají se informace robota...",
    "migrationDialogStatusGettingAzureInfo": "Získávají se informace Azure...",
    "migrationDialogStatusGettingAppSettings": "Získávají se nastavení aplikace robota...",
    "migrationDialogStatusDeployingMigrationBot": "Probíhá inicializace migrovaného robota...",
    "migrationDialogStatusRegisteringWithAzure": "Probíhá registrace služby Bot Service v Azure...",
    "migrationDialogStatusUpdatingBotRecord": "Aktualizuje se záznam robota...",
    "migrationDialogStatusCreatingRG": "Vytváří se skupina prostředků...",
    "migrationDialogStatusMigratingFiles": "Probíhá migrace souborů do nového robota...",
    "migrationDialogStatusWrappingUp": "Dokončuje se nasazení...",
    "migrationDialogStatusDeployingStorage": "Probíhá připojování robota k existujícímu úložišti...",
    "migrationDialogStatusDeployingSite": "Probíhá nasazování webu",
    "migrationDialogStatusConfiguringSite": "Probíhá konfigurace webu",
    "migrationDialogStatusDeploying": "Probíhá nasazování",
    "migrationDialogStatusFunctionCredentials": "Získávají se nové přihlašovací údaje aplikace Function App...",
    "migrationDialogErrorNoSubs": "Pro aktuálního uživatele se nepodařilo najít žádné předplatné Azure.",
    "migrationDialogErrorNoAzureToken": "Pro aktuálního uživatele se nepodařilo najít přístupový token Azure.",
    "migrationDialogErrorNoLocations": "Pro vybrané předplatné Azure se nepodařilo najít žádná umístění.",
    "migrationDialogErrorNoAzureStorage": "V konfiguraci aplikace se nepodařilo najít název účtu úložiště Azure.",
    "migrationDialogErrorAppNameUnavailable": "Název aplikace není k dispozici.",
    "migrationDialogErrorAppNameInvalid": "Název aplikace je neplatný.",
    "migrationDialogErrorNoBotType": "Aktuální robot nemá platný typ.",
    "migrationDialogErrorBotInvalid": "Tohoto robota nelze migrovat, protože je neplatný.",
    "migrationDialogErrorEndpointMissing": "Tohoto robota nelze migrovat, protože chybí koncový bod.",
    "migrationDialogErrorProvisionInfoMissing": "Tohoto robota nelze migrovat, protože chybí informace o zřizování.",
    "migrationDialogErrorResourceGroupNameMissing": "Tohoto robota nelze migrovat, protože chybí název skupiny prostředků.",
    "migrationDialogErrorSubscriptionIdMissing": "Tohoto robota nelze migrovat, protože chybí ID předplatného Azure.",
    "migrationDialogErrorSiteNameMissing": "Tohoto robota nelze migrovat, protože chybí název webu Azure.",
    "migrationDialogABSv2TitleText": "Migrace není k dispozici",
    "migrationDialogABSv2BodyText": "Migrace je pro roboty služby Conversation Designer (ABSv2) aktuálně zakázána.",
    "migrationDialogRegistrationBodyText": "Pro roboty typu {0} je migrace aktuálně zakázána.",
    "migrationDialogFailedTokenRefresh": "Platnost tokenu Azure vypršela.",
    "migrationDialogRefreshPage": "Aktualizujte prosím stránku a zkuste provést migraci znovu.",
    "migrationSubscriptionDisabled": "Vybrané předplatné Azure je zakázané. Pokud chcete pokračovat v migraci, povolte ho.",
    "migrationTenantHasNoSubscriptions": "Tento adresář neobsahuje žádné předplatné.",
    "migrationDialogFuncPackBotTitle": "K migraci tohoto robota je nutný balíček Azure Functions",
    "migrationDialogFuncPackBotMessage": "Roboty Node Functions je před migrací nutné zahrnout do balíčku Azure Functions.",
    "migrationDialogFuncPackBotLinkText": "Zjistěte, jak spustit balíček Azure Functions u kódu vašeho robota",
    "tosDialog_Header": "Podmínky služby",
    "tosDialog_AgreeButton": "Souhlas",
    "tosDialog_MessageChannels": "Podmínky služeb Online Services neplatí pro publikování na kanálech. Podmínky publikování na kanálech Microsoftu například neobsahují podmínky zpracování dat.",
    "tosDialog_MessageMigration": "Přečtěte si prosím a odsouhlaste následující podmínky.",
    "tosDialog_AzureTermsCheckbox": "Souhlasím, že používání webu Bot Framework podléhá těmto podmínkám: {0} a {1}.",
    "tosDialog_CortanaTermsCheckbox": "Souhlasím s podmínkami ({0} a {1}) nasazení do kanálu Cortany.",
    "tosDialog_CombinedTermsCheckboxOneChannel": "Souhlasím s podmínkami ({0} a {1}) nasazení do kanálu <%= channelslist %>.",
    "tosDialog_CombinedTermsCheckboxMultiChannels": "Souhlasím s podmínkami ({0} a {1}) nasazení do kanálů <%= channelslist %>.",
    "tosDialog_ABSTerms": "podmínky mého předplatného Azure Bot Service",
    "tosDialog_MSKnowledgeGraphTerms": "Podmínky publikování na kanálu Cortana",
    "tosDialog_MSPublicationTerms": "Podmínky publikování na kanálu Microsoft",
    "tosDialog_MSPrivacyStatement": "Prohlášení o zásadách ochrany osobních údajů společnosti Microsoft",
    "notice": " OZNÁMENÍ: ",
    "listElem": "{0}, ",
    "andListEnd": "{0} a {1}",
    "analyticsChannelsDropdown": "Filtr kanálů",
    "analyticsPeriodDropdown": "Časové období",
    "deprecatedChannel": "(zastaralé)",
    "openInComposer": "otevřít v composeru",
    "downloadComposer": "Stáhnout composer",
}

const Resources_nl: IResources = {
    "unsupportedBrowser_Azure": "Uw browser wordt nog niet door Azure Bot Service ondersteund.",
    "unsupportedBrowser": "Uw browser wordt nog niet door Bot Framework ondersteund.",
    "botKindRegistration": "Bot Services Bot",
    "botKindSdk": "Web App Bot",
    "botKindFunctions": "Functions Bot",
    "botKindConversationDesigner": "Conversation Designer Bot",
    "loggingIn": "Bezig met aanmelden",
    "loadingBot": "Bot laden...",
    "botIsNotReady": "Wachten tot bot gereed is",
    "analyticsNotReady": "Wachten tot Application Insights wordt geconfigureerd",
    "authorizingWebChat": "Chat met bot autoriseren",
    "signInFailure": "Er is een fout opgetreden bij uw aanmelding. Controleer of cookies van derden zijn ingeschakeld in de browser.",
    "getChatTokenFailure": "Er is een fout opgetreden bij het ophalen van een chatverificatietoken. Vernieuw de pagina en probeer het opnieuw.",
    "refreshSignInFailure": "Er is een fout opgetreden bij het vernieuwen van uw aanmeldingsgegevens. Controleer of cookies van derden zijn ingeschakeld in de browser.",
    "xhrResponse_400": "De actie is ongeldig of de opgegeven waarden zijn ongeldig.",
    "xhrResponse_403": "Dit item kan niet worden geopend of gewijzigd.",
    "xhrResponse_404": "Kan het item niet vinden.",
    "xhrResponse_500": "Er is bij de server een interne fout opgetreden.",
    "xhrResponse_501": "Deze bewerking wordt niet ondersteund.",
    "xhrResponse_Message": "Fout: %1",
    "xhrResponse_Unknown": "Er is een onbekende fout opgetreden.",
    "AddAFeaturedChannelTitle": "Een aanbevolen kanaal toevoegen",
    "ConnectToChannelsTitle": "Verbinden met kanalen",
    "NoChannelsConfigured": "U hebt nog geen kanalen verbonden. Selecteer een kanaal waarmee u verbinding wilt maken.",
    "MoreChannelsTitle": "Meer kanalen",
    "test": "Test",
    "startOver": "Opnieuw beginnen",
    "retentionTitle": "Retentie",
    "retentionDescription": "% gebruikers die opnieuw een bericht hebben verzonden (afgelopen 10 dagen)",
    "retentionHeader": "Dagen later",
    "retentionDate": "Datum",
    "retentionUsers": "Gebruikers",
    "undetermined": "Onbepaald",
    "loading": "laden...",
    "noAnalyticsData": "geen gegevens",
    "timespanLastHour": "Afgelopen uur",
    "timespanLastDay": "Afgelopen dag",
    "timespanLastWeek": "Vorige week",
    "timespanLastMonth": "Vorige maand",
    "timespanLast90Days": "Afgelopen 90 dagen",
    "timespanUnknown": "Onbekend tijdsbestek",
    "timelineCardUsersTitle": "Gebruikers",
    "timelineCardMessagesTitle": "Activiteiten",
    "totalsCardTitle": "Eindtotaal",
    "analyticsNotConfigured": "U hebt Analytics nog niet ingeschakeld via Azure Application Insights.",
    "analyticsNotConfiguredAction": "Geef op de volgende pagina uw Application Insights-sleutels en id op voor deze bot: ",
    "analyticsNotConfiguredActionIbiza": "Geef op de pagina met instellingen uw Application Insights-sleutels en id voor deze bot op.",
    "learnMore": "Meer informatie",
    "cardTitleLoading": "%1 - %2",
    "cardTitleError": "%1 - fout: %2",
    "timelineTableLabel": "Toewijzing voor tijdlijntabel %1 op tijd",
    "timelineChartLabel": "Toewijzing voor tijdlijngrafiek %1 op tijd",
    "published": "Gepubliceerd",
    "health": "Gezondheids",
    "channelname": "Naam",
    "edit": "Bewerken",
    "running": "Wordt uitgevoerd",
    "issuesTemplate": "Problemen (<%= length %>)",
    "warningTemplate": "Waarschuwingen (<%= length %>)",
    "channelPublished": "Gepubliceerd",
    "tryOnCortana": "Probeer op <%= Name %> - meer informatie",
    "tryOnChannel": "Probeer op <%= Name %>",
    "manageInCortana": "Beheren in Cortana-dashboard",
    "channelRejected": "Afgewezen",
    "channelMoreDetails": "Meer details",
    "channelResubmit": "Opnieuw ter beoordeling indienen...",
    "channelGetEmbedCodes": "Insluitcodes voor bot ophalen",
    "channelConfigDeleteMessage": "Door deze actie worden alle kanaalconfiguratiegegevens verwijderd. Weet u zeker dat u wilt doorgaan?",
    "channelConfigDeleteHeader": "Kanaal verwijderen",
    "channelConfigDeleteOk": "Ja, verwijderen",
    "channelConfigDeleteCancel": "Nee, niet verwijderen",
    "channelConfigLeaveMessage": "Dit document bevat niet-opgeslagen wijzigingen. Weet u zeker dat u deze pagina wilt verlaten?",
    "channelConfigLeaveHeader": "Wijzigingen negeren",
    "channelConfigLeaveOk": "Ja, de pagina verlaten",
    "channelConfigLeaveCancel": "Nee, op de pagina blijven",
    "channelEdit": "Bewerken",
    "dialogPleaseWait": "Even geduld...",
    "embedPanelTitle": "Insluitcode van bot",
    "embedPanelDescription": "Kies een kanaal waarvoor u de insluitcode wilt ophalen. Kopieer en plak de code naar uw website.",
    "embedPanelFacebookFooter": "U moet de JavaScript SDK van Facebook in uw pagina opnemen om deze insluitcode te kunnen gebruiken.",
    "embedPanelLearnMore": "Meer informatie.",
    "embedPanelChannelMovedHeader": "Insluitcode voor %1 is verplaatst",
    "embedPanelChannelMovedInstructions": "Klik hier om configuratiepagina %1 te openen",
    "embedPanelEmbedcodeForChannelLabel": "Insluitcode voor %1",
    "embedPanelGettingCodes": "Codes ophalen...",
    "embedPanelNoCodeAvailable": "Geen insluitcode beschikbaar voor deze bot.",
    "channelIssuesPanelSubtitle": "Recente problemen",
    "channelIssuesPanelClearall": "Alles wissen",
    "channelIssuesPanelTimeColumnLabel": "Tijd",
    "channelIssuesPanelMessageColumnLabel": "Bericht",
    "channelIssuesPanelCorrelationIdColumnLabel": "Correlatie-id",
    "unsavedChangesWillBeLost": "Niet-opgeslagen wijzigingen gaan verloren.",
    "altImageChannel": "Kanaal %1 configureren",
    "Bing": "Bing",
    "Cortana": "Cortana",
    "MicrosoftSearch": "Microsoft Search",
    "DirectLine": "Direct Line",
    "Email": "E-mail",
    "FacebookMessenger": "Facebook Messenger",
    "GroupMe": "GroupMe",
    "Kaizala": "Kaizala",
    "Kik": "Kik",
    "MicrosoftTeams": "Microsoft Teams",
    "Skype": "Skype",
    "SkypeforBusiness": "Skype voor Bedrijven",
    "_SkypeforBusiness": "Skype voor Bedrijven, merk",
    "Slack": "Slack",
    "Telegram": "Telegram",
    "Twilio": "Twilio (SMS)",
    "migrationBannerCTAMigrateBot": "DEZE BOT MIGREREN",
    "migrationBannerCTAStartMigrating": "MIGRATIE STARTEN",
    "migrationBannerBlurb1": "Met de introductie van de nieuwe Azure Bot Service migreren we tot 31-3-2018 alle bots naar de nieuwe service.",
    "migrationBannerBlurb2": "over de migratie.",
    "migrationBannerSuggestedBlurb": "Migratie naar Azure Bot Service is optioneel voor deze bot.",
    "migrationBannerPostDeadlineBlurb": "Bots die migratie naar Azure Bot Service vereisen, moeten nu worden gemigreerd om onderbreking van de service te voorkomen.",
    "migrationBannerBlockedBlurb": "Botmigratie is achterstallig. Migreer de bot nu om onderbreking van de service te voorkomen.",
    "migrationWillBeRequiredDialogMessage": "Als u dit kanaal configureert, moet uw bot uiterlijk op 31-3-2018 worden gemigreerd naar Azure Bot Service. Weet u zeker dat u dit kanaal wilt configureren?",
    "channelRequiresMigrationDialogMessage": "Dit kanaal is alleen beschikbaar voor bots in Azure Bot Service. Wilt u deze bot migreren?",
    "channelRequiresABSBot": "Dit kanaal is alleen beschikbaar voor bots in Azure Bot Service.",
    "botRequiresMigrationDialogHeader": "Bot vereist migratie",
    "botRequiresMigrationDialogMessage": "Botmigratie is achterstallig. Migreer de bot nu om onderbreking van de service te voorkomen.",
    "yesMigrateThisBot": "Ja, deze bot migreren",
    "myBotsMigrationStatusMigrated": "Gemigreerd",
    "myBotsMigrationStatusNotMigrated": "Vereist",
    "myBotsMigrationStatusOptionalMigration": "Niet vereist",
    "myBotsMigrationButtonMigrate": "Migreren",
    "myBotsMigrationButtonRollback": "Migratie terugdraaien",
    "deleteBotDialogDeleteButtonText": "Bot verwijderen",
    "cancelButtonText": "Annuleren",
    "deleteBotDialogTitleText": "U staat op het punt deze bot te verwijderen",
    "deleteBotDialogBodyText": "Deze actie zal alle gegevens wissen die aan deze bot zijn gekoppeld, en kan niet ongedaan worden gemaakt. Weet u het zeker?",
    "deleteBotDialogStatusDeleting": "Bot verwijderen...",
    "deleteBotDialogStatusDeleted": "Bot verwijderd",
    "rollbackBotDialogRollbackButtonText": "Ja, terugdraaien",
    "rollbackBotDialogTitleText": "Weet u zeker dat u wilt terugdraaien?",
    "rollbackBotDialogBodyText": "Met deze actie wordt de migratie volledig teruggedraaid en moet u het migratieproces volledig overnieuw beginnen. Weet u zeker dat u wilt doorgaan?",
    "rollbackBotDialogErrorInfo": "Fout bij het ophalen van botinformatie van de server.",
    "rollbackBotDialogErrorNoEndpoint": "Kan niet terugdraaien. Geen eindpunt voor terugdraaien gevonden.",
    "rollbackBotDialogErrorNoAzureToken": "Kan niet terugdraaien. Er kan geen Azure-token worden gevonden voor contact met Azure.",
    "rollbackBotDialogStatusGettingInfo": "Botinformatie verzamelen...",
    "rollbackBotDialogStatusPreparing": "Bot voorbereiden...",
    "rollbackBotDialogStatusReverting": "Bot terugdraaien...",
    "rollbackBotDialogStatusDeletingApp": "Bijgewerkte app verwijderen...",
    "rollbackBotDialogStatusDeletingDeployment": "Implementatierecord verwijderen...",
    "rollbackBotDialogConfirmationTitleText": "Terugdraaien voltooid",
    "rollbackBotDialogConfirmationBodyText": "is teruggedraaid.",
    "okButtonText": "OK",
    "errorMessageErrorOccurred": "Er is een fout opgetreden",
    "migrationDialogStatusGettingBotInfo": "Botinformatie ophalen...",
    "migrationDialogStatusGettingAzureInfo": "Azure-informatie ophalen...",
    "migrationDialogStatusGettingAppSettings": "App-instellingen voor bot ophalen...",
    "migrationDialogStatusDeployingMigrationBot": "Gemigreerde bot initialiseren...",
    "migrationDialogStatusRegisteringWithAzure": "Bot Service registreren bij Azure...",
    "migrationDialogStatusUpdatingBotRecord": "Botrecord bijwerken...",
    "migrationDialogStatusCreatingRG": "Resourcegroep maken...",
    "migrationDialogStatusMigratingFiles": "Bestanden migreren naar nieuwe bot...",
    "migrationDialogStatusWrappingUp": "Implementatie afronden...",
    "migrationDialogStatusDeployingStorage": "Bot verbinden met huidige opslag...",
    "migrationDialogStatusDeployingSite": "Website implementeren",
    "migrationDialogStatusConfiguringSite": "Website configureren",
    "migrationDialogStatusDeploying": "Implementeren",
    "migrationDialogStatusFunctionCredentials": "Referenties voor nieuwe functie-app ophalen...",
    "migrationDialogErrorNoSubs": "Kan geen Azure-abonnementen vinden voor de huidige gebruiker.",
    "migrationDialogErrorNoAzureToken": "Kan geen Azure-toegangstoken vinden voor de huidige gebruiker.",
    "migrationDialogErrorNoLocations": "Kan geen locaties vinden voor het geselecteerde Azure-abonnement.",
    "migrationDialogErrorNoAzureStorage": "Kan geen Azure-opslagaccountnaam vinden in de app-config.",
    "migrationDialogErrorAppNameUnavailable": "App-naam is niet beschikbaar.",
    "migrationDialogErrorAppNameInvalid": "Ongeldige app-naam.",
    "migrationDialogErrorNoBotType": "Huidige bot heeft geen geldig type.",
    "migrationDialogErrorBotInvalid": "Deze bot kan niet worden gemigreerd omdat de bot ongeldig is.",
    "migrationDialogErrorEndpointMissing": "Deze bot kan niet worden gemigreerd omdat het eindpunt ontbreekt.",
    "migrationDialogErrorProvisionInfoMissing": "Deze bot kan niet worden gemigreerd omdat de inrichtingsinformatie ontbreekt.",
    "migrationDialogErrorResourceGroupNameMissing": "Deze bot kan niet worden gemigreerd omdat de resourcegroepsnaam ontbreekt.",
    "migrationDialogErrorSubscriptionIdMissing": "Deze bot kan niet worden gemigreerd omdat de Azure-abonnements-id ontbreekt.",
    "migrationDialogErrorSiteNameMissing": "Deze bot kan niet worden gemigreerd omdat de Azure-sitenaam ontbreekt.",
    "migrationDialogABSv2TitleText": "Migratie niet beschikbaar",
    "migrationDialogABSv2BodyText": "Migratie is momenteel uitgeschakeld voor Conversation Designer-bots (ABSv2).",
    "migrationDialogRegistrationBodyText": "Migratie is momenteel uitgeschakeld voor '{0}'-bots.",
    "migrationDialogFailedTokenRefresh": "Azure-token is verlopen.",
    "migrationDialogRefreshPage": "Vernieuw de pagina en probeer de migratie opnieuw.",
    "migrationSubscriptionDisabled": "Het geselecteerde Azure-abonnement is uitgeschakeld. Schakel dit in om door te gaan met de migratie.",
    "migrationTenantHasNoSubscriptions": "Deze map bevat geen abonnement.",
    "migrationDialogFuncPackBotTitle": "Azure Functions-pakket is vereist voor migratie van deze bot",
    "migrationDialogFuncPackBotMessage": "Node Functions-bots moeten worden geleverd bij het Azure Functions-pakket voordat ze kunnen worden gemigreerd.",
    "migrationDialogFuncPackBotLinkText": "Meer informatie over het uitvoeren van het Azure Functions-pakket op uw botcode",
    "tosDialog_Header": "Gebruiksvoorwaarden",
    "tosDialog_AgreeButton": "Akkoord",
    "tosDialog_MessageChannels": "De voorwaarden voor Online Services zijn niet van toepassing op publicatie op kanalen. De publicatievoorwaarden voor Microsoft-kanalen omvatten bijvoorbeeld geen voorwaarden voor gegevensverwerking.",
    "tosDialog_MessageMigration": "Lees de volgende voorwaarden en ga ermee akkoord.",
    "tosDialog_AzureTermsCheckbox": "Ik ga ermee akkoord dat het gebruik van de Bot Framework-site onderhevig is aan de {0} en de {1}.",
    "tosDialog_CortanaTermsCheckbox": "Ik ga akkoord met de {0} en de {1} voor mijn implementatie voor het Cortana-kanaal.",
    "tosDialog_CombinedTermsCheckboxOneChannel": "Ik ga akkoord met de {0} en de {1} voor mijn implementatie voor het <%= channelslist %>-kanaal.",
    "tosDialog_CombinedTermsCheckboxMultiChannels": "Ik ga akkoord met de {0} en de {1} voor mijn implementatie voor de <%= channelslist %>-kanalen.",
    "tosDialog_ABSTerms": "voorwaarden voor mijn abonnement voor Azure Bot Service",
    "tosDialog_MSKnowledgeGraphTerms": "Publicatievoorwaarden voor Cortana-kanaal",
    "tosDialog_MSPublicationTerms": "Publicatievoorwaarden voor Microsoft Channel",
    "tosDialog_MSPrivacyStatement": "Privacyverklaringen van Microsoft",
    "notice": " OPMERKING: ",
    "listElem": "{0}, ",
    "andListEnd": "{0} en {1}",
    "analyticsChannelsDropdown": "Kanalenfilter",
    "analyticsPeriodDropdown": "Tijdsperiode",
    "deprecatedChannel": "(afgeschaft)",
    "openInComposer": "openen in composer",
    "downloadComposer": "Composer downloaden",
}

const Resources_hu: IResources = {
    "unsupportedBrowser_Azure": "Az Azure Bot Service még nem támogatja ezt a böngészőt.",
    "unsupportedBrowser": "A Bot keretrendszer még nem támogatja ezt a böngészőt.",
    "botKindRegistration": "Bot Services Bot",
    "botKindSdk": "Web App Bot",
    "botKindFunctions": "Functions Bot",
    "botKindConversationDesigner": "Conversation Designer Bot",
    "loggingIn": "Bejelentkezés",
    "loadingBot": "Bot betöltése...",
    "botIsNotReady": "Várakozás a robot készen állására",
    "analyticsNotReady": "Várakozás az Application Insights konfigurálása",
    "authorizingWebChat": "Csevegés engedélyezése robottal",
    "signInFailure": "Hiba történt a bejelentkezéskor. Ellenőrizze, hogy a harmadik féltől származó cookie-k engedélyezve vannak-e a böngészőben.",
    "getChatTokenFailure": "A Csevegés engedélyezési token megszerzésénél hiba történt. Frissítse, és próbálkozzon újra.",
    "refreshSignInFailure": "Hiba történt a bejelentkezési információk frissítésekor. Ellenőrizze, hogy a harmadik féltől származó cookie-k engedélyezve vannak-e a böngészőben.",
    "xhrResponse_400": "A művelet vagy a megadott értékek érvénytelenek.",
    "xhrResponse_403": "Ez az elem nem érhető el és nem módosítható.",
    "xhrResponse_404": "Az elem nem található.",
    "xhrResponse_500": "Belső hiba történt a kiszolgálón.",
    "xhrResponse_501": "Ez a művelet nem támogatott.",
    "xhrResponse_Message": "Hiba: %1",
    "xhrResponse_Unknown": "Ismeretlen hiba történt.",
    "AddAFeaturedChannelTitle": "Kiemelt csatorna hozzáadása",
    "ConnectToChannelsTitle": "Csatlakozás csatornákhoz",
    "NoChannelsConfigured": "Még egyik csatornához sem csatlakozott. Válasszon ki egy csatornát a csatlakozáshoz.",
    "MoreChannelsTitle": "Több csatorna",
    "test": "Teszt",
    "startOver": "Újrakezdés",
    "retentionTitle": "Megőrzés",
    "retentionDescription": "% felhasználók, akik újból üzentek (utolsó 10 nap)",
    "retentionHeader": "Nappal később",
    "retentionDate": "Dátum",
    "retentionUsers": "Felhasználók",
    "undetermined": "Meghatározatlan",
    "loading": "Betöltés...",
    "noAnalyticsData": "Nincsenek adatok",
    "timespanLastHour": "Utolsó óra",
    "timespanLastDay": "Utolsó nap",
    "timespanLastWeek": "Előző hét",
    "timespanLastMonth": "Múlt hónap",
    "timespanLast90Days": "Elmúlt 90 nap",
    "timespanUnknown": "Ismeretlen időtartam",
    "timelineCardUsersTitle": "Felhasználók",
    "timelineCardMessagesTitle": "Tevékenységek",
    "totalsCardTitle": "Végösszegek",
    "analyticsNotConfigured": "Ön még nem engedélyezte az Analytics via Azure Application Insights funkciót.",
    "analyticsNotConfiguredAction": "Adja meg az Application Insights kulcsokat és a bot azonosítóját a következő lapon: ",
    "analyticsNotConfiguredActionIbiza": "Adja meg az Application Insights kulcsokat és a bot azonosítóját a beállítások lapon.",
    "learnMore": "További információ",
    "cardTitleLoading": "%1 - %2",
    "cardTitleError": "%1 - hiba: %2",
    "timelineTableLabel": "%1 idő szerint, idővonaltábla hozzárendelése",
    "timelineChartLabel": "%1 idő szerint, idővonal-diagram hozzárendelése",
    "published": "Közzétéve",
    "health": "Egészség",
    "channelname": "Név",
    "edit": "Szerkesztés",
    "running": "Futás",
    "issuesTemplate": "Problémák (<%= length %>)",
    "warningTemplate": "Figyelmeztetések (<%= length %>)",
    "channelPublished": "Közzétéve",
    "tryOnCortana": "Próbálja meg ezt: <%= Name %> - megtudhatja, hogyan",
    "tryOnChannel": "Próbálja meg ezt: <%= Name %>",
    "manageInCortana": "Kezelés Cortana irányítópultban",
    "channelRejected": "Elutasítva",
    "channelMoreDetails": "További részletek",
    "channelResubmit": "Küldje el ellenőrzésre újból...",
    "channelGetEmbedCodes": "Bot beágyazási kódok beolvasása",
    "channelConfigDeleteMessage": "Ez a művelet törli az összes csatorna konfigurációs adatait. Biztosan folytatni kívánja?",
    "channelConfigDeleteHeader": "Csatorna törlése",
    "channelConfigDeleteOk": "Igen, törlöm",
    "channelConfigDeleteCancel": "Nem, tartsa meg",
    "channelConfigLeaveMessage": "Nem mentett módosítások vannak ebben a dokumentumban. Biztosan el akarja hagyni ezt az oldalt?",
    "channelConfigLeaveHeader": "Módosítások elvetése",
    "channelConfigLeaveOk": "Igen, elhagyom az oldalt",
    "channelConfigLeaveCancel": "Nem, maradjon a lapon",
    "channelEdit": "Szerkesztés",
    "dialogPleaseWait": "Kis türelmet...",
    "embedPanelTitle": "Bot beágyazási kód",
    "embedPanelDescription": "Válasszon egy csatornát a hozzá tartozó beágyazási kód beolvasásához. Másolja le és illessze be a kódot a webhelyére.",
    "embedPanelFacebookFooter": "A Facebook beágyazás használatához szükséges, hogy az Ön oldala tartalmazza a Facebook JavaScript SDK-ját.",
    "embedPanelLearnMore": "További információ",
    "embedPanelChannelMovedHeader": "%1 beágyazási kódját áthelyezték",
    "embedPanelChannelMovedInstructions": "Kattintson ide a %1 konfigurációs lap megnyitásához",
    "embedPanelEmbedcodeForChannelLabel": "Beágyazási kód ehhez: %1",
    "embedPanelGettingCodes": "Kódok beolvasása...",
    "embedPanelNoCodeAvailable": "Nem érhető el beágyazási kód ehhez a bothoz.",
    "channelIssuesPanelSubtitle": "Legutóbbi problémák",
    "channelIssuesPanelClearall": "Összes törlése",
    "channelIssuesPanelTimeColumnLabel": "Idő",
    "channelIssuesPanelMessageColumnLabel": "Üzenet",
    "channelIssuesPanelCorrelationIdColumnLabel": "Korrelációazonosító",
    "unsavedChangesWillBeLost": "A nem mentett változtatások elvesznek.",
    "altImageChannel": "%1 csatorna konfigurálása",
    "Bing": "Bing",
    "Cortana": "Cortana",
    "MicrosoftSearch": "Microsoft Search",
    "DirectLine": "Direct Line",
    "Email": "E-mail",
    "FacebookMessenger": "Facebook Messenger",
    "GroupMe": "GroupMe",
    "Kaizala": "Kaizala",
    "Kik": "Kik",
    "MicrosoftTeams": "Microsoft Teams",
    "Skype": "Skype",
    "SkypeforBusiness": "Skype vállalati verzió",
    "_SkypeforBusiness": "Skype for business márka",
    "Slack": "Slack",
    "Telegram": "Telegram",
    "Twilio": "Twilio (SMS)",
    "migrationBannerCTAMigrateBot": "A ROBOT ÁTTELEPÍTÉSE",
    "migrationBannerCTAStartMigrating": "ÁTTELEPÍTÉS INDÍTÁSA",
    "migrationBannerBlurb1": "Az új Azure Bot Service elindításával minden robotot áttelepítünk az új szolgáltatásba 2018/3/31-ig.",
    "migrationBannerBlurb2": "az áttelepítésről.",
    "migrationBannerSuggestedBlurb": "Az Azure Bot Service-be való áttelepítés nem kötelező ennél a robotnál.",
    "migrationBannerPostDeadlineBlurb": "Az Azure Bot Service-be áttelepítést igénylő robotokat most kell áttelepíteni a szolgáltatás megszakadásának elkerülése érdekében.",
    "migrationBannerBlockedBlurb": "A robot áttelepítésének határideje lejárt, telepítse át most a szolgáltatás megszakadásának elkerülése érdekében.",
    "migrationWillBeRequiredDialogMessage": "Ha beállítja ezt a csatornát, a robotot át kell telepítenie az Azure Bot Service-be 2018. 3. 31.-ig. Biztosan be szeretné állítani a csatornát?",
    "channelRequiresMigrationDialogMessage": "A csatorna csak az Azure Bot Service-be telepített robotok számára áll rendelkezésre. Szeretné áttelepíteni a robotot?",
    "channelRequiresABSBot": "A csatorna csak az Azure Bot Service-be telepített robotok számára áll rendelkezésre.",
    "botRequiresMigrationDialogHeader": "Robot áttelepítése szükséges",
    "botRequiresMigrationDialogMessage": "A robot áttelepítésének határideje lejárt, telepítse át most a szolgáltatás megszakadásának elkerülése érdekében.",
    "yesMigrateThisBot": "Igen, telepítse át a robotot",
    "myBotsMigrationStatusMigrated": "Áttelepítve",
    "myBotsMigrationStatusNotMigrated": "Szükséges",
    "myBotsMigrationStatusOptionalMigration": "Nem szükséges",
    "myBotsMigrationButtonMigrate": "Áttelepít",
    "myBotsMigrationButtonRollback": "Áttelepítés visszaállítás",
    "deleteBotDialogDeleteButtonText": "Robot törlése",
    "cancelButtonText": "Mégse",
    "deleteBotDialogTitleText": "Törölni készül ezt a robotot",
    "deleteBotDialogBodyText": "Ez a művelet a robothoz társított összes adatot törli, és nem vonható vissza. Biztos benne?",
    "deleteBotDialogStatusDeleting": "Robot törlése...",
    "deleteBotDialogStatusDeleted": "Robot törölve",
    "rollbackBotDialogRollbackButtonText": "Igen, állítsa vissza",
    "rollbackBotDialogTitleText": "Valóban visszaállítja?",
    "rollbackBotDialogBodyText": "Ez a művelet teljesen visszaállítja az áttelepítést, és az áttelepítési folyamatot előlről el kell indítania. Biztosan folytatni kívánja?",
    "rollbackBotDialogErrorInfo": "Hiba történt a robot adatainak kiszolgálóról való lekérése közben.",
    "rollbackBotDialogErrorNoEndpoint": "A visszaállítás nem hajtható végre. Nem található visszaállítási végpont.",
    "rollbackBotDialogErrorNoAzureToken": "A visszaállítás nem hajtható végre. Nem sikerült Azure tokent találni az Azure-hoz való kapcsolódáshoz.",
    "rollbackBotDialogStatusGettingInfo": "Robot információ gyűjtése...",
    "rollbackBotDialogStatusPreparing": "Robot előkészítése...",
    "rollbackBotDialogStatusReverting": "Robot visszaállítása..",
    "rollbackBotDialogStatusDeletingApp": "Frissített alkalmazás törlése...",
    "rollbackBotDialogStatusDeletingDeployment": "Telepítési bejegyzés törlése...",
    "rollbackBotDialogConfirmationTitleText": "Visszaállítás befejezve",
    "rollbackBotDialogConfirmationBodyText": "visszaállítás sikeresen megtörtént.",
    "okButtonText": "Ok",
    "errorMessageErrorOccurred": "Hiba történt",
    "migrationDialogStatusGettingBotInfo": "Robot információ lekérdezése...",
    "migrationDialogStatusGettingAzureInfo": "Azure információk lekérdezése...",
    "migrationDialogStatusGettingAppSettings": "Robotalkalmazás beállításainak lekérdezése...",
    "migrationDialogStatusDeployingMigrationBot": "Áttelepített robot inicializálása...",
    "migrationDialogStatusRegisteringWithAzure": "Robotszolgáltatás regisztrálása Azure-ban...",
    "migrationDialogStatusUpdatingBotRecord": "Robot bejegyzés frissítése...",
    "migrationDialogStatusCreatingRG": "Erőforráscsoport létrehozása...",
    "migrationDialogStatusMigratingFiles": "Fájlok áttelepítése új robothoz...",
    "migrationDialogStatusWrappingUp": "Telepítés befejezése...",
    "migrationDialogStatusDeployingStorage": "Robot csatlakoztatása meglévő tárolóhoz...",
    "migrationDialogStatusDeployingSite": "Webhely üzembe helyezése",
    "migrationDialogStatusConfiguringSite": "Webhely konfigurálása",
    "migrationDialogStatusDeploying": "Üzembe helyezés",
    "migrationDialogStatusFunctionCredentials": "Új függvényalkalmazás hitelesítő adatainak beolvasása...",
    "migrationDialogErrorNoSubs": "Nem sikerült az aktuális felhasználóhoz tartozó Azure előfizetést találni.",
    "migrationDialogErrorNoAzureToken": "Nem sikerült Azure hozzáférési tokent találni az aktuális felhasználóhoz.",
    "migrationDialogErrorNoLocations": "Nem sikerült a kijelölt Azure előfizetéshez tartozó helyet találni.",
    "migrationDialogErrorNoAzureStorage": "Nem sikerült Azure tárfiók nevet találni az alkalmazáskonfigurációban.",
    "migrationDialogErrorAppNameUnavailable": "Alkalmazás neve nem elérhető.",
    "migrationDialogErrorAppNameInvalid": "Érvénytelen alkalmazásnév.",
    "migrationDialogErrorNoBotType": "Az aktuális robot nem rendelkezik érvényes típussal.",
    "migrationDialogErrorBotInvalid": "A robot nem telepíthető át, mert érvénytelen.",
    "migrationDialogErrorEndpointMissing": "A robot nem telepíthető át, mert hiányzik a végpont.",
    "migrationDialogErrorProvisionInfoMissing": "A robot nem telepíthető át, mert az üzembe helyezési információk hiányoznak.",
    "migrationDialogErrorResourceGroupNameMissing": "A robot nem telepíthető át, mert hiányzik az erőforráscsoport neve.",
    "migrationDialogErrorSubscriptionIdMissing": "A robot nem telepíthető át, mert hiányzik az Azure előfizetés azonosítója.",
    "migrationDialogErrorSiteNameMissing": "A robot nem telepíthető át, mert hiányzik az Azure webhely neve.",
    "migrationDialogABSv2TitleText": "Az áttelepítés nem elérhető",
    "migrationDialogABSv2BodyText": "Az áttelepítés jelenleg le van tiltva a beszélgetéstervező (ABSv2) robotoknál.",
    "migrationDialogRegistrationBodyText": "Az áttelepítés jelenleg le van tiltva a(z) '{0}' robotoknál.",
    "migrationDialogFailedTokenRefresh": "Az Azure token lejárt.",
    "migrationDialogRefreshPage": "Frissítse a lapot, és próbálja meg újra az áttelepítést.",
    "migrationSubscriptionDisabled": "A kiválasztott Azure előfizetés le van tiltva. Engedélyezze az áttelepítés folytatásához.",
    "migrationTenantHasNoSubscriptions": "Ez a könyvtár nem tartalmaz előfizetést.",
    "migrationDialogFuncPackBotTitle": "Azure Functions Pack szükséges a robot áttelepítéséhez",
    "migrationDialogFuncPackBotMessage": "A Node Functions robotokat be kell csomagolni az Azure Functions Pack segítségével, mielőtt áttelepítésre kerülhetnének.",
    "migrationDialogFuncPackBotLinkText": "Ismerje meg, hogyan futtatható az Azure Functions Pack a robot kódján",
    "tosDialog_Header": "Szolgáltatási feltételek",
    "tosDialog_AgreeButton": "Megállapodnak abban",
    "tosDialog_MessageChannels": "Az online szolgáltatások feltételei nem vonatkoznak a csatornákon történő közzétételre. Például a Microsoft csatornákon való közzététel feltételei nem kínálnak adatfeldolgozási feltételeket.",
    "tosDialog_MessageMigration": "Olvassa el, és fogadja el a következő feltételeket.",
    "tosDialog_AzureTermsCheckbox": "Elfogadom, hogy a robot keretrendszer webhelyének használata {0} és a(z) {1} hatálya alá tartozik.",
    "tosDialog_CortanaTermsCheckbox": "Elfogadom a Cortana csatonában való közzétételemre vonatkozóan a {0} és {1} dokumentumokban foglaltakat.",
    "tosDialog_CombinedTermsCheckboxOneChannel": "Elfogadom a(z) <%= channelslist %> csatonában való közzétételemre vonatkozóan a {0} és {1} dokumentumokban foglaltakat.",
    "tosDialog_CombinedTermsCheckboxMultiChannels": "Elfogadom a(z) <%= channelslist %> csatonákban való közzétételemre vonatkozóan a {0} és {1} dokumentumokban foglaltakat.",
    "tosDialog_ABSTerms": "saját Azure Bot Service előfizetés feltételei",
    "tosDialog_MSKnowledgeGraphTerms": "Cortana csatorna közzétételi feltételek",
    "tosDialog_MSPublicationTerms": "Közzétételi feltételek Microsoft csatornán",
    "tosDialog_MSPrivacyStatement": "A Microsoft adatvédelmi nyilatkozata",
    "notice": " MEGJEGYZÉS: ",
    "listElem": "{0}, ",
    "andListEnd": "{0} és {1}",
    "analyticsChannelsDropdown": "Csatornaszűrő",
    "analyticsPeriodDropdown": "Időszak",
    "deprecatedChannel": "(elavult)",
    "openInComposer": "megnyitás a Composerben",
    "downloadComposer": "A Composer letöltése",
}

const Resources_pl: IResources = {
    "unsupportedBrowser_Azure": "Usługa Azure Bot Service nie obsługuje jeszcze Twojej przeglądarki.",
    "unsupportedBrowser": "Platforma Bot Framework nie obsługuje jeszcze Twojej przeglądarki.",
    "botKindRegistration": "Bot Services Bot",
    "botKindSdk": "Web App Bot",
    "botKindFunctions": "Functions Bot",
    "botKindConversationDesigner": "Conversation Designer Bot",
    "loggingIn": "Logowanie",
    "loadingBot": "Trwa ładowanie bota...",
    "botIsNotReady": "Oczekiwanie, aż bot będzie gotowy",
    "analyticsNotReady": "Oczekiwanie na skonfigurowanie usługi Application Insights",
    "authorizingWebChat": "Autoryzowanie rozmowy z botem",
    "signInFailure": "Wystąpił błąd podczas logowania. Upewnij się, że pliki cookie innych firm są włączone w przeglądarce",
    "getChatTokenFailure": "Wystąpił błąd podczas pobierania tokenu autoryzacji rozmowy. Odśwież i spróbuj ponownie.",
    "refreshSignInFailure": "Wystąpił błąd podczas odświeżania informacji logowania. Upewnij się, że w przeglądarce włączone są pliki cookie innych firm.",
    "xhrResponse_400": "Akcja lub podane wartości są nieprawidłowe.",
    "xhrResponse_403": "Nie można uzyskać dostępu do tego elementu albo go zmodyfikować.",
    "xhrResponse_404": "Nie można odnaleźć elementu.",
    "xhrResponse_500": "Wystąpił błąd wewnętrzny na serwerze.",
    "xhrResponse_501": "Ta operacja jest nieobsługiwana.",
    "xhrResponse_Message": "Błąd: %1",
    "xhrResponse_Unknown": "Wystąpił nieznany błąd.",
    "AddAFeaturedChannelTitle": "Dodaj polecany kanał",
    "ConnectToChannelsTitle": "Połącz z kanałami",
    "NoChannelsConfigured": "Nie połączono się jeszcze z żadnym kanałem. Wybierz kanał, aby się z nim połączyć.",
    "MoreChannelsTitle": "Więcej kanałów",
    "test": "Testuj",
    "startOver": "Zacznij od nowa",
    "retentionTitle": "Utrzymanie",
    "retentionDescription": "% użytkowników, którzy ponownie przesłali wiadomość (ostatnie 10 dni)",
    "retentionHeader": "Dni później",
    "retentionDate": "Data",
    "retentionUsers": "Użytkownicy",
    "undetermined": "Nieokreślone",
    "loading": "trwa ładowanie...",
    "noAnalyticsData": "brak danych",
    "timespanLastHour": "Ostatnia godzina",
    "timespanLastDay": "Ostatni dzień",
    "timespanLastWeek": "Ostatni tydzień",
    "timespanLastMonth": "Ostatni miesiąc",
    "timespanLast90Days": "Ostatnie 90 dni",
    "timespanUnknown": "Nieznany przedział czasu",
    "timelineCardUsersTitle": "Użytkownicy",
    "timelineCardMessagesTitle": "Działania",
    "totalsCardTitle": "Sumy końcowe",
    "analyticsNotConfigured": "Nie włączono jeszcze funkcji analiz za pośrednictwem usługi Azure Application Insights.",
    "analyticsNotConfiguredAction": "Podaj klucze i identyfikator usługi Application Insights dla tego bota na następującej stronie: ",
    "analyticsNotConfiguredActionIbiza": "Podaj klucze i identyfikator usługi Application Insights dla tego bota na stronie ustawień.",
    "learnMore": "Dowiedz się więcej",
    "cardTitleLoading": "%1 — %2",
    "cardTitleError": "%1 — błąd: %2",
    "timelineTableLabel": "Tabela osi czasu mapująca wykres %1 według godzin",
    "timelineChartLabel": "Wykres osi czasu mapujący wykres %1 według godzin",
    "published": "Opublikowano",
    "health": "Kondycja",
    "channelname": "Nazwa",
    "edit": "Edytuj",
    "running": "Uruchomiono",
    "issuesTemplate": "Problemy (<%= length %>)",
    "warningTemplate": "Ostrzeżenia (<%= length %>)",
    "channelPublished": "Opublikowano",
    "tryOnCortana": "Wypróbuj w kanale <%= Name %> — dowiedz się, jak",
    "tryOnChannel": "Wypróbuj w kanale <%= Name %>",
    "manageInCortana": "Zarządzaj na pulpicie nawigacyjnym Cortany",
    "channelRejected": "Odrzucono",
    "channelMoreDetails": "Więcej szczegółów",
    "channelResubmit": "Wyślij ponownie do przeglądu...",
    "channelGetEmbedCodes": "Pobierz kody osadzania bota",
    "channelConfigDeleteMessage": "Wykonanie tej akcji spowoduje usunięcie wszystkich informacji dotyczących konfiguracji kanału. Czy na pewno chcesz kontynuować?",
    "channelConfigDeleteHeader": "Usuń kanał",
    "channelConfigDeleteOk": "Tak, usuń go",
    "channelConfigDeleteCancel": "Nie, zachowaj go",
    "channelConfigLeaveMessage": "Masz niezapisane zmiany w tym dokumencie. Czy na pewno chcesz opuścić tę stronę?",
    "channelConfigLeaveHeader": "Odrzuć zmiany",
    "channelConfigLeaveOk": "Tak, opuść stronę",
    "channelConfigLeaveCancel": "Nie, zostań na stronie",
    "channelEdit": "Edytuj",
    "dialogPleaseWait": "Czekaj...",
    "embedPanelTitle": "Kod osadzania bota",
    "embedPanelDescription": "Wybierz kanał, aby pobrać dla niego kod osadzania. Skopiuj ten kod i wklej go w swojej witrynie internetowej.",
    "embedPanelFacebookFooter": "Aby używać tego osadzenia, musisz dołączyć zestaw JavaScript SDK Facebooka do swojej strony.",
    "embedPanelLearnMore": "Dowiedz się więcej.",
    "embedPanelChannelMovedHeader": "Kod osadzania dla kanału %1 został przeniesiony",
    "embedPanelChannelMovedInstructions": "Kliknij tutaj, aby otworzyć stronę konfiguracji kanału %1",
    "embedPanelEmbedcodeForChannelLabel": "Kod osadzania dla kanału %1",
    "embedPanelGettingCodes": "Trwa pobieranie kodów...",
    "embedPanelNoCodeAvailable": "Brak dostępnego kodu osadzania dla tego bota.",
    "channelIssuesPanelSubtitle": "Ostatnie problemy",
    "channelIssuesPanelClearall": "Wyczyść wszystko",
    "channelIssuesPanelTimeColumnLabel": "Godzina",
    "channelIssuesPanelMessageColumnLabel": "Wiadomość",
    "channelIssuesPanelCorrelationIdColumnLabel": "Identyfikator korelacji",
    "unsavedChangesWillBeLost": "Niezapisane zmiany zostaną utracone.",
    "altImageChannel": "Konfiguruj kanał %1",
    "Bing": "Bing",
    "Cortana": "Cortana",
    "MicrosoftSearch": "Microsoft Search",
    "DirectLine": "Direct Line",
    "Email": "Poczta e-mail",
    "FacebookMessenger": "Facebook Messenger",
    "GroupMe": "GroupMe",
    "Kaizala": "Kaizala",
    "Kik": "Kik",
    "MicrosoftTeams": "Microsoft Teams",
    "Skype": "Skype",
    "SkypeforBusiness": "Skype dla firm",
    "_SkypeforBusiness": "Marka Skype dla firm",
    "Slack": "Slack",
    "Telegram": "Telegram",
    "Twilio": "Twilio (SMS)",
    "migrationBannerCTAMigrateBot": "MIGRUJ TEGO BOTA",
    "migrationBannerCTAStartMigrating": "ROZPOCZNIJ MIGROWANIE",
    "migrationBannerBlurb1": "Z powodu uruchomienia nowej usługi Azure Bot Service będziemy migrować wszystkie boty do nowej usługi do 31 marca 2018.",
    "migrationBannerBlurb2": "o migracji.",
    "migrationBannerSuggestedBlurb": "W przypadku tego bota migracja do Azure Bot Service jest opcjonalna.",
    "migrationBannerPostDeadlineBlurb": "W celu uniknięcia przerwy w świadczeniu usług, konieczna jest teraz migracja botów, które tego wymagają do Azure Bot Service. ",
    "migrationBannerBlockedBlurb": "Zaległa migracja bota, dokonaj teraz migracji w celu uniknięcia przerwy w świadczeniu usługi.",
    "migrationWillBeRequiredDialogMessage": "Jeśli skonfigurujesz ten kanał, nastąpi konieczność migracji bota do Azure Bot Service najpóźniej do 3.31.2018 r. Czy na pewno chcesz konfigurować ten kanał?",
    "channelRequiresMigrationDialogMessage": "Ten kanał jest dostępny tylko w dla botów w Azure Bot Service. Czy chcesz dokonać migracji tego bota?",
    "channelRequiresABSBot": "Ten kanał jest dostępny tylko dla botów w usłudze Azure Bot Service.",
    "botRequiresMigrationDialogHeader": "Bot wymaga migracji",
    "botRequiresMigrationDialogMessage": "Zaległa migracja bota, dokonaj teraz migracji w celu uniknięcia przerwy w świadczeniu usługi.",
    "yesMigrateThisBot": "Tak, dokonaj migracji tego bota",
    "myBotsMigrationStatusMigrated": "Zmigrowano",
    "myBotsMigrationStatusNotMigrated": "Wymagane",
    "myBotsMigrationStatusOptionalMigration": "Niewymagane",
    "myBotsMigrationButtonMigrate": "Migruj",
    "myBotsMigrationButtonRollback": "Wycofaj migrację",
    "deleteBotDialogDeleteButtonText": "Usuń bota",
    "cancelButtonText": "Anuluj",
    "deleteBotDialogTitleText": "Zamierzasz usunąć tego bota",
    "deleteBotDialogBodyText": "Wykonanie tej akcji spowoduje wymazanie wszystkich danych skojarzonych z tym botem i nie będzie można jej cofnąć. Czy na pewno?",
    "deleteBotDialogStatusDeleting": "Trwa usuwanie bota...",
    "deleteBotDialogStatusDeleted": "Bot usunięty",
    "rollbackBotDialogRollbackButtonText": "Tak, wycofaj",
    "rollbackBotDialogTitleText": "Czy na pewno chcesz wykonać wycofywanie?",
    "rollbackBotDialogBodyText": "Ta akcja spowoduje całkowite wycofanie migracji i trzeba będzie rozpocząć proces migracji od początku. Czy na pewno chcesz kontynuować?",
    "rollbackBotDialogErrorInfo": "Błąd pobierania informacji dotyczących bota z serwera.",
    "rollbackBotDialogErrorNoEndpoint": "Nie można wykonać wycofywania. Nie znaleziono punktu końcowego wycofywania.",
    "rollbackBotDialogErrorNoAzureToken": "Nie można wykonać wycofywania. Nie można odnaleźć tokenu platformy Azure umożliwiającego kontaktowanie się z platformą Azure.",
    "rollbackBotDialogStatusGettingInfo": "Trwa zbieranie informacji dotyczących bota...",
    "rollbackBotDialogStatusPreparing": "Trwa przygotowywanie bota...",
    "rollbackBotDialogStatusReverting": "Trwa przywracanie bota...",
    "rollbackBotDialogStatusDeletingApp": "Trwa usuwanie uaktualnionej aplikacji...",
    "rollbackBotDialogStatusDeletingDeployment": "Trwa usuwanie rekordu wdrożenia...",
    "rollbackBotDialogConfirmationTitleText": "Wycofywanie zakończone",
    "rollbackBotDialogConfirmationBodyText": "została wycofana pomyślnie.",
    "okButtonText": "OK",
    "errorMessageErrorOccurred": "Wystąpił błąd",
    "migrationDialogStatusGettingBotInfo": "Trwa pobieranie informacji dotyczących bota...",
    "migrationDialogStatusGettingAzureInfo": "Trwa pobieranie informacji dotyczących platformy Azure...",
    "migrationDialogStatusGettingAppSettings": "Trwa pobieranie ustawień aplikacji bota...",
    "migrationDialogStatusDeployingMigrationBot": "Trwa inicjowanie zmigrowanego bota...",
    "migrationDialogStatusRegisteringWithAzure": "Trwa rejestrowanie usługi Bot Service na platformie Azure...",
    "migrationDialogStatusUpdatingBotRecord": "Trwa aktualizowanie rekordu bota...",
    "migrationDialogStatusCreatingRG": "Trwa tworzenie grupy zasobów...",
    "migrationDialogStatusMigratingFiles": "Trwa migrowanie plików do nowego bota...",
    "migrationDialogStatusWrappingUp": "Trwa tworzenie otoki wdrożenia...",
    "migrationDialogStatusDeployingStorage": "Trwa podłączanie bota do istniejącego magazynu...",
    "migrationDialogStatusDeployingSite": "Wdrażanie witryny internetowej",
    "migrationDialogStatusConfiguringSite": "Konfigurowanie witryny internetowej",
    "migrationDialogStatusDeploying": "Wdrażanie",
    "migrationDialogStatusFunctionCredentials": "Trwa pobieranie nowych poświadczeń aplikacji funkcji...",
    "migrationDialogErrorNoSubs": "Nie można odnaleźć subskrypcji platformy Azure dla bieżącego użytkownika.",
    "migrationDialogErrorNoAzureToken": "Nie można odnaleźć tokenu dostępu platformy Azure dla bieżącego użytkownika.",
    "migrationDialogErrorNoLocations": "Nie można odnaleźć lokalizacji dla wybranej subskrypcji platformy Azure.",
    "migrationDialogErrorNoAzureStorage": "Nie można znaleźć nazwy konta usługi Azure Storage w konfiguracji aplikacji.",
    "migrationDialogErrorAppNameUnavailable": "Nazwa aplikacji jest niedostępna.",
    "migrationDialogErrorAppNameInvalid": "Nieprawidłowa nazwa aplikacji.",
    "migrationDialogErrorNoBotType": "Bieżący bot nie ma prawidłowego typu.",
    "migrationDialogErrorBotInvalid": "Nie można zmigrować tego bota, ponieważ jest on nieprawidłowy.",
    "migrationDialogErrorEndpointMissing": "Nie można zmigrować tego bota z powodu braku punktu końcowego.",
    "migrationDialogErrorProvisionInfoMissing": "Nie można zmigrować tego bota z powodu braku informacji dotyczących inicjowania obsługi.",
    "migrationDialogErrorResourceGroupNameMissing": "Nie można zmigrować tego bota z powodu braku nazwy grupy zasobów.",
    "migrationDialogErrorSubscriptionIdMissing": "Nie można zmigrować tego bota z powodu braku identyfikatora subskrypcji platformy Azure.",
    "migrationDialogErrorSiteNameMissing": "Nie można zmigrować tego bota z powodu braku nazwy lokacji platformy Azure.",
    "migrationDialogABSv2TitleText": "Migracja niedostępna",
    "migrationDialogABSv2BodyText": "Migracja botów projektanta konwersacji (ABSv2) jest obecnie wyłączona.",
    "migrationDialogRegistrationBodyText": "Migracja botów „{0}” jest obecnie wyłączona.",
    "migrationDialogFailedTokenRefresh": "Token platformy Azure wygasł.",
    "migrationDialogRefreshPage": "Odśwież stronę i ponów próbę wykonania migracji.",
    "migrationSubscriptionDisabled": "Wybrana subskrypcja platformy Azure jest wyłączona. Włącz ją, aby kontynuować migrację.",
    "migrationTenantHasNoSubscriptions": "Ten katalog nie zawiera subskrypcji.",
    "migrationDialogFuncPackBotTitle": "Do wykonania migracji tego bota wymagany jest pakiet Azure Functions Pack",
    "migrationDialogFuncPackBotMessage": "Boty funkcji węzłów muszą zostać umieszczone w pakiecie z pakietem Azure Functions Pack, aby można było wykonać ich migrację.",
    "migrationDialogFuncPackBotLinkText": "Dowiedz się, jak uruchomić pakiet Azure Functions Pack w kodzie bota",
    "tosDialog_Header": "Warunki świadczenia usługi",
    "tosDialog_AgreeButton": "Zgadzam się",
    "tosDialog_MessageChannels": "Warunki opisane na stronie Online Services — warunki nie dotyczą publikowania w kanałach. Na przykład warunki publikowania w kanałach firmy Microsoft nie obejmują warunków przetwarzania danych.",
    "tosDialog_MessageMigration": "Przeczytaj i zaakceptuj poniższe warunki.",
    "tosDialog_AzureTermsCheckbox": "Zgadzam się, że korzystanie z witryny Bot Framework jest regulowane przez {0} i {1}.",
    "tosDialog_CortanaTermsCheckbox": "Akceptuję {0} i {1} odnośnie mojego wdrożenia w kanale Cortana.",
    "tosDialog_CombinedTermsCheckboxOneChannel": "Akceptuję {0} i {1} odnośnie mojego wdrożenia w kanale <%= channelslist %>.",
    "tosDialog_CombinedTermsCheckboxMultiChannels": "Akceptuję {0} i {1} odnośnie mojego wdrożenia w kanałach <%= channelslist %>.",
    "tosDialog_ABSTerms": "warunki mojej subskrypcji usługi Azure Bot Service",
    "tosDialog_MSKnowledgeGraphTerms": "Warunki publikacji w kanale Cortana",
    "tosDialog_MSPublicationTerms": "Warunki publikacji w kanałach firmy Microsoft",
    "tosDialog_MSPrivacyStatement": "Oświadczenie firmy Microsoft o ochronie prywatności",
    "notice": " POWIADOMIENIE: ",
    "listElem": "{0}, ",
    "andListEnd": "{0} i {1}",
    "analyticsChannelsDropdown": "Filtr kanałów",
    "analyticsPeriodDropdown": "Okres",
    "deprecatedChannel": "(przestarzały)",
    "openInComposer": "otwórz w kompozytorze",
    "downloadComposer": "Pobierz kompozytora",
}

const Resources_sv: IResources = {
    "unsupportedBrowser_Azure": "Azure Bot Service har inte stöd för din webbläsare än.",
    "unsupportedBrowser": "Botsystemet har inte stöd för din webbläsare än.",
    "botKindRegistration": "Bot Services Bot",
    "botKindSdk": "Web App Bot",
    "botKindFunctions": "Functions Bot",
    "botKindConversationDesigner": "Conversation Designer Bot",
    "loggingIn": "Loggar in",
    "loadingBot": "Läser in bot...",
    "botIsNotReady": "Väntar på bot",
    "analyticsNotReady": "Väntar på att Application Insights ska konfigureras",
    "authorizingWebChat": "Godkänner chatt med bot",
    "signInFailure": "Ett fel inträffade vid inloggningen. Kontrollera att cookies från tredje part är aktiverade i webbläsaren.",
    "getChatTokenFailure": "Det gick inte att få en autentiseringskod för chatt. Uppdatera och försök igen.",
    "refreshSignInFailure": "Ett fel inträffade när din inloggningsinformation uppdaterades. Kontrollera att cookies från tredje part är aktiverade i webbläsaren.",
    "xhrResponse_400": "Åtgärden eller de angivna värdena är ogiltiga.",
    "xhrResponse_403": "Objektet kan inte nås eller modifieras.",
    "xhrResponse_404": "Objektet hittades inte.",
    "xhrResponse_500": "Ett internt fel uppstod hos servern.",
    "xhrResponse_501": "Den här åtgärden stöds inte.",
    "xhrResponse_Message": "Fel: %1",
    "xhrResponse_Unknown": "Ett okänt fel har uppstått.",
    "AddAFeaturedChannelTitle": "Lägg till en aktuell kanal",
    "ConnectToChannelsTitle": "Anslut till kanaler",
    "NoChannelsConfigured": "Du har inte anslutit några kanaler ännu. Välj en kanal att ansluta.",
    "MoreChannelsTitle": "Fler kanaler",
    "test": "Test",
    "startOver": "Börja om",
    "retentionTitle": "Bibehållning",
    "retentionDescription": "% användare som skickade meddelande igen (senaste 10 dagarna)",
    "retentionHeader": "Dagar senare",
    "retentionDate": "Datum",
    "retentionUsers": "Användare",
    "undetermined": "Obestämt",
    "loading": "läser in…",
    "noAnalyticsData": "inga data",
    "timespanLastHour": "Senaste timmen",
    "timespanLastDay": "Senaste dagen",
    "timespanLastWeek": "Senaste veckan",
    "timespanLastMonth": "Senaste månaden",
    "timespanLast90Days": "Senaste 90 dagarna",
    "timespanUnknown": "Okänd tidsrymd",
    "timelineCardUsersTitle": "Användare",
    "timelineCardMessagesTitle": "Aktiviteter",
    "totalsCardTitle": "Totalsumma",
    "analyticsNotConfigured": "Du har inte aktiverat statistik via Azure Application Insights än.",
    "analyticsNotConfiguredAction": "Ange dina Application Insights-nycklar och id för denna bot på följande sida:",
    "analyticsNotConfiguredActionIbiza": "Ange dina Application Insights-nycklar och id för denna bot i inställningarna.",
    "learnMore": "Mer information",
    "cardTitleLoading": "%1 - %2",
    "cardTitleError": "%1 - fel: %2",
    "timelineTableLabel": "Mappning av tidslinjetabell %1 efter tid",
    "timelineChartLabel": "Mappning av tidslinjediagram %1 efter tid",
    "published": "Publicerad",
    "health": "Hälsa",
    "channelname": "Namn",
    "edit": "Redigera",
    "running": "Löpning",
    "issuesTemplate": "Problem (<%= length %>)",
    "warningTemplate": "Varningar (<%= length %>)",
    "channelPublished": "Publicerad",
    "tryOnCortana": "Prova i <%= Name %> – ta reda på hur",
    "tryOnChannel": "Prova i <%= Name %>",
    "manageInCortana": "Hantera i kontrollpanelen för Cortana",
    "channelRejected": "Avvisad",
    "channelMoreDetails": "Fler detaljer",
    "channelResubmit": "Skicka till granskning igen...",
    "channelGetEmbedCodes": "Skaffa inbäddade botkoder",
    "channelConfigDeleteMessage": "Den här åtgärden tar bort all information om kanalkonfigurationen. Vill du fortsätta?",
    "channelConfigDeleteHeader": "Ta bort kanal",
    "channelConfigDeleteOk": "Ja, ta bort den",
    "channelConfigDeleteCancel": "Nej, behåll",
    "channelConfigLeaveMessage": "Du har ändringar som inte sparats i detta dokument. Vill du lämna den här sidan?",
    "channelConfigLeaveHeader": "Ta bort ändringar",
    "channelConfigLeaveOk": "Ja, lämna sidan",
    "channelConfigLeaveCancel": "Nej, stanna kvar på sidan",
    "channelEdit": "Redigera",
    "dialogPleaseWait": "Vänta...",
    "embedPanelTitle": "Inbäddad botkod",
    "embedPanelDescription": "Välj en kanal so koden ska bäddas in i. Kopiera och klistra koden till din webbplats.",
    "embedPanelFacebookFooter": "Facebook kräver att du inkluderar deras JavaScript SDK på sidan för att använda inbäddningen.",
    "embedPanelLearnMore": "Mer information.",
    "embedPanelChannelMovedHeader": "Inbäddad kod för %1 har flyttats",
    "embedPanelChannelMovedInstructions": "Klicka här för att öppna konfigurationssidan för %1",
    "embedPanelEmbedcodeForChannelLabel": "Inbäddad kod för %1",
    "embedPanelGettingCodes": "Hämtar koder...",
    "embedPanelNoCodeAvailable": "Inga inbäddade koder är tillgängliga för boten.",
    "channelIssuesPanelSubtitle": "Senaste problemen",
    "channelIssuesPanelClearall": "Rensa alla",
    "channelIssuesPanelTimeColumnLabel": "Tid",
    "channelIssuesPanelMessageColumnLabel": "Meddelande",
    "channelIssuesPanelCorrelationIdColumnLabel": "Korrelations-ID",
    "unsavedChangesWillBeLost": "Ändringar som inte sparats går förlorade.",
    "altImageChannel": "Konfigurera kanalen %1",
    "Bing": "Bing",
    "Cortana": "Cortana",
    "MicrosoftSearch": "Microsoft Search",
    "DirectLine": "Direct Line",
    "Email": "E-postadress",
    "FacebookMessenger": "Facebook Messenger",
    "GroupMe": "GroupMe",
    "Kaizala": "Kaizala",
    "Kik": "Kik",
    "MicrosoftTeams": "Microsoft Teams",
    "Skype": "Skype",
    "SkypeforBusiness": "Skype för företag",
    "_SkypeforBusiness": "Skype för företag-märke",
    "Slack": "Slack",
    "Telegram": "Telegram",
    "Twilio": "Twilio (SMS)",
    "migrationBannerCTAMigrateBot": "MIGRERA BOT",
    "migrationBannerCTAStartMigrating": "BÖRJA MIGRERA",
    "migrationBannerBlurb1": "Vi lanserar en ny Azure Bot Service och migrerar alla bottar till den nya tjänsten senast 2018-03-31.",
    "migrationBannerBlurb2": "om migreringen.",
    "migrationBannerSuggestedBlurb": "Migrering till Azure Bot Service är valfri för den här roboten.",
    "migrationBannerPostDeadlineBlurb": "Robotar som måste migreras till Azure Bot Service måste migreras nu för att undvika avbrott i tjänsten.",
    "migrationBannerBlockedBlurb": "Robotmigrering är försenad. Migrera nu för att undvika avbrott i tjänsten.",
    "migrationWillBeRequiredDialogMessage": "Om du konfigurerar den här kanalen måste din robot migreras till Azure Bot Service senast 2018-03-31. Vill du konfigurera den här kanalen?",
    "channelRequiresMigrationDialogMessage": "Den här kanalen är bara tillgänglig för robotar i Azure Bot Service. Vill du migrera denna robot?",
    "channelRequiresABSBot": "Den här kanalen är bara tillgänglig för robotar i Azure Bot Service.",
    "botRequiresMigrationDialogHeader": "Migrering krävs för robot",
    "botRequiresMigrationDialogMessage": "Robotmigrering är försenad. Migrera nu för att undvika avbrott i tjänsten.",
    "yesMigrateThisBot": "Ja, migrera denna robot",
    "myBotsMigrationStatusMigrated": "Migrerad",
    "myBotsMigrationStatusNotMigrated": "Krävs",
    "myBotsMigrationStatusOptionalMigration": "Ej obligatoriskt",
    "myBotsMigrationButtonMigrate": "Migrera",
    "myBotsMigrationButtonRollback": "Återställ migrering",
    "deleteBotDialogDeleteButtonText": "Ta bort bot",
    "cancelButtonText": "Avbryt",
    "deleteBotDialogTitleText": "Botten tas bort om du fortsätter",
    "deleteBotDialogBodyText": "Den här åtgärden raderar all data som är associerad med botten och går inte att ångra. Är du säker?",
    "deleteBotDialogStatusDeleting": "Tar bort bot …",
    "deleteBotDialogStatusDeleted": "Botten har tagits bort",
    "rollbackBotDialogRollbackButtonText": "Ja, återställ",
    "rollbackBotDialogTitleText": "Vill du återställa?",
    "rollbackBotDialogBodyText": "Migreringen återställs helt och du måste börja om från början med migreringsprocessen. Vill du fortsätta?",
    "rollbackBotDialogErrorInfo": "Det gick inte att hämta botinformation från servern.",
    "rollbackBotDialogErrorNoEndpoint": "Det går inte att återställa. Det finns ingen slutpunkt för återställning.",
    "rollbackBotDialogErrorNoAzureToken": "Det går inte att återställa. Hittade ingen Azure-token att kontakta Azure med.",
    "rollbackBotDialogStatusGettingInfo": "Samlar botinfo …",
    "rollbackBotDialogStatusPreparing": "Förbereder bot …",
    "rollbackBotDialogStatusReverting": "Återställer bot …",
    "rollbackBotDialogStatusDeletingApp": "Tar bort uppgraderad app …",
    "rollbackBotDialogStatusDeletingDeployment": "Tar bort distributionsregister …",
    "rollbackBotDialogConfirmationTitleText": "Återställning klar",
    "rollbackBotDialogConfirmationBodyText": "har återställts.",
    "okButtonText": "OK",
    "errorMessageErrorOccurred": "Ett fel uppstod",
    "migrationDialogStatusGettingBotInfo": "Hämtar botinfo …",
    "migrationDialogStatusGettingAzureInfo": "Hämtar Azure-info …",
    "migrationDialogStatusGettingAppSettings": "Hämtar bottens appinställningar …",
    "migrationDialogStatusDeployingMigrationBot": "Initierar migrerad bot …",
    "migrationDialogStatusRegisteringWithAzure": "Registrerar Bot Service hos Azure …",
    "migrationDialogStatusUpdatingBotRecord": "Uppdaterar botregister …",
    "migrationDialogStatusCreatingRG": "Skapar resursgrupp …",
    "migrationDialogStatusMigratingFiles": "Migrerar filer till ny bot …",
    "migrationDialogStatusWrappingUp": "Avslutar distribuering …",
    "migrationDialogStatusDeployingStorage": "Ansluter bot till befintlig lagring …",
    "migrationDialogStatusDeployingSite": "Webbplatsen distribueras",
    "migrationDialogStatusConfiguringSite": "Konfigurerar webbplats",
    "migrationDialogStatusDeploying": "Distribuerar",
    "migrationDialogStatusFunctionCredentials": "Hämtar nya autentiseringsuppgifter för funktionsappen …",
    "migrationDialogErrorNoSubs": "Det gick inte att hitta några Azure-prenumerationer för användaren.",
    "migrationDialogErrorNoAzureToken": "Hittade ingen Azure-åtkomsttoken för användaren.",
    "migrationDialogErrorNoLocations": "Det gick inte att hitta några platser för den valda Azure-prenumerationen.",
    "migrationDialogErrorNoAzureStorage": "Hittade inget Azure Storage-kontonamn i appkonfigurationen.",
    "migrationDialogErrorAppNameUnavailable": "Appnamnet är inte tillgängligt.",
    "migrationDialogErrorAppNameInvalid": "Ogiltigt appnamn.",
    "migrationDialogErrorNoBotType": "Botten har ingen giltig typ.",
    "migrationDialogErrorBotInvalid": "Det går inte att migrera botten eftersom den är ogiltig.",
    "migrationDialogErrorEndpointMissing": "Det går inte att migrera botten eftersom slutpunkten saknas.",
    "migrationDialogErrorProvisionInfoMissing": "Det går inte att migrera botten eftersom etableringsinfo saknas.",
    "migrationDialogErrorResourceGroupNameMissing": "Det går inte att migrera botten eftersom resursgruppnamnet saknas.",
    "migrationDialogErrorSubscriptionIdMissing": "Det går inte att migrera botten eftersom Azure-prenumerations-id saknas.",
    "migrationDialogErrorSiteNameMissing": "Det går inte att migrera botten eftersom Azure-platsnamnet saknas.",
    "migrationDialogABSv2TitleText": "Migrering är inte tillgänglig",
    "migrationDialogABSv2BodyText": "Migrering är för närvarande inaktiverat för konversationsdesignbottar (ABSv2).",
    "migrationDialogRegistrationBodyText": "Migrering är inaktiverad för bottar av typen '{0}'.",
    "migrationDialogFailedTokenRefresh": "Azure-token har upphört.",
    "migrationDialogRefreshPage": "Uppdatera sidan och försök migrera igen.",
    "migrationSubscriptionDisabled": "Den valda Azure-prenumerationen är inaktiverad. Aktivera om du vill fortsätta migreringen.",
    "migrationTenantHasNoSubscriptions": "Den här katalogen innehåller inte någon prenumeration.",
    "migrationDialogFuncPackBotTitle": "Azure Functions Pack krävs för att den här boten ska kunna migreras",
    "migrationDialogFuncPackBotMessage": "Nodfunktionsbotar måste paketeras med Azure Functions Pack innan de kan migreras.",
    "migrationDialogFuncPackBotLinkText": "Läs mer om hur du kör Azure Functions Pack på din botkod",
    "tosDialog_Header": "Villkor för tjänsten",
    "tosDialog_AgreeButton": "Godkänn",
    "tosDialog_MessageChannels": "Villkoren för onlinetjänster gäller inte för publicering på kanaler. Villkoren för publicering på Microsoft-kanaler innehåller till exempel inte databehandlingsvillkor.",
    "tosDialog_MessageMigration": "Läs och godkänn följande villkor.",
    "tosDialog_AzureTermsCheckbox": "Jag samtycker till att användningen av Bot Framework-webbplatsen omfattas av {0} och {1}.",
    "tosDialog_CortanaTermsCheckbox": "Jag godkänner {0} och {1} för min distribuering på Cortana-kanalen.",
    "tosDialog_CombinedTermsCheckboxOneChannel": "Jag godkänner {0} och {1} för min distribuering på kanalen <%= channelslist %>.",
    "tosDialog_CombinedTermsCheckboxMultiChannels": "Jag godkänner {0} och {1} för min distribuering på kanalerna <%= channelslist %>.",
    "tosDialog_ABSTerms": "villkor för min Azure Bot Service-prenumeration",
    "tosDialog_MSKnowledgeGraphTerms": "Publiceringsvillkor för Cortana-kanal",
    "tosDialog_MSPublicationTerms": "Villkor för Microsoft Channel Publication",
    "tosDialog_MSPrivacyStatement": "Microsofts sekretesspolicyer",
    "notice": " OBS!",
    "listElem": "{0}, ",
    "andListEnd": "{0} och {1}",
    "analyticsChannelsDropdown": "Kanalfilter",
    "analyticsPeriodDropdown": "Tidsperiod",
    "deprecatedChannel": "(inaktuell)",
    "openInComposer": "öppna i Composer",
    "downloadComposer": "Hämta Composer",
}

const Resources_tr: IResources = {
    "unsupportedBrowser_Azure": "Azure Bot Hizmeti henüz tarayıcınızı desteklemiyor.",
    "unsupportedBrowser": "Bot Framework henüz tarayıcınızı desteklemiyor.",
    "botKindRegistration": "Bot Services Bot",
    "botKindSdk": "Web App Bot",
    "botKindFunctions": "Functions Bot",
    "botKindConversationDesigner": "Conversation Designer Bot",
    "loggingIn": "Oturum açılıyor",
    "loadingBot": "Bot yükleniyor...",
    "botIsNotReady": "Botun hazır olması bekleniyor",
    "analyticsNotReady": "Application Insights'ın yapılandırılması bekleniyor",
    "authorizingWebChat": "Bot ile Sohbet Yetkilendiriliyor",
    "signInFailure": "Oturumunuz açılırken bir hata oluştu. Tarayıcıda üçüncü taraf çerezlerin etkinleştirildiğinden emin olun.",
    "getChatTokenFailure": "Sohbet yetkilendirme belirteci alınırken bir hata oluştu. Yenileyin ve tekrar deneyin.",
    "refreshSignInFailure": "Oturum açma bilgilerinizi yenilerken bir hata oluştu. Tarayıcıda üçüncü taraf çerezlerin etkinleştirildiğinden emin olun.",
    "xhrResponse_400": "Eylem veya sağlanan değerler geçersiz.",
    "xhrResponse_403": "Bu öğeye erişilemiyor veya öğe değiştirilemiyor.",
    "xhrResponse_404": "Öğe bulunamadı.",
    "xhrResponse_500": "Sunucuda iç hata oluştu.",
    "xhrResponse_501": "Bu işlem desteklenmiyor.",
    "xhrResponse_Message": "Hata: %1",
    "xhrResponse_Unknown": "Bilinmeyen bir hata oluştu.",
    "AddAFeaturedChannelTitle": "Öne çıkan kanal ekleyin",
    "ConnectToChannelsTitle": "Kanallara bağlan",
    "NoChannelsConfigured": "Henüz kanal bağlamadınız. Bağlanacak bir kanal seçin.",
    "MoreChannelsTitle": "Daha fazla kanal",
    "test": "Test",
    "startOver": "Baştan başla",
    "retentionTitle": "Tutma",
    "retentionDescription": "% kullanıcı yeniden ileti gönderdi (son 10 gün)",
    "retentionHeader": "Geçen gün sayısı",
    "retentionDate": "Tarih",
    "retentionUsers": "Kullanıcılar",
    "undetermined": "Belirsiz",
    "loading": "yükleniyor...",
    "noAnalyticsData": "veri yok",
    "timespanLastHour": "Son Saat",
    "timespanLastDay": "Son Gün",
    "timespanLastWeek": "Geçen Hafta",
    "timespanLastMonth": "Geçen Ay",
    "timespanLast90Days": "Son 90 Gün",
    "timespanUnknown": "Bilinmeyen zaman aralığı",
    "timelineCardUsersTitle": "Kullanıcılar",
    "timelineCardMessagesTitle": "Etkinlikler",
    "totalsCardTitle": "Genel Toplamlar",
    "analyticsNotConfigured": "Henüz Azure Application Insights aracılığıyla Analiz'i etkinleştirmediniz.",
    "analyticsNotConfiguredAction": "Şu sayfada bu bot için Application Insights Anahtarlarınızı ve Kimliğinizi sağlayın: ",
    "analyticsNotConfiguredActionIbiza": "Ayarlar sayfasında bu bot için Application Insights Anahtarlarınızı ve Kimliğinizi sağlayın.",
    "learnMore": "Daha fazla bilgi edinin",
    "cardTitleLoading": "%1 - %2",
    "cardTitleError": "%1 - hata: %2",
    "timelineTableLabel": "Zamana göre zaman çizelgesi %1 tablosu eşleme",
    "timelineChartLabel": "Zamana göre zaman çizelgesi %1 grafiği eşleme",
    "published": "Yayımlandı",
    "health": "Sistem Durumu",
    "channelname": "Ad",
    "edit": "Düzenle",
    "running": "Çalışıyor",
    "issuesTemplate": "Sorunlar (<%= length %>)",
    "warningTemplate": "Uyarılar (<%= length %>)",
    "channelPublished": "Yayımlandı",
    "tryOnCortana": "<%= Name %> kanalında deneyin. Nasıl yapılacağını öğrenin",
    "tryOnChannel": "<%= Name %> kanalında deneyin",
    "manageInCortana": "Cortana panosunda yönet",
    "channelRejected": "Reddedildi",
    "channelMoreDetails": "Diğer ayrıntılar",
    "channelResubmit": "Gözden geçirme için yeniden gönder...",
    "channelGetEmbedCodes": "Bot ekleme kodlarını alın",
    "channelConfigDeleteMessage": "Bu eylem tüm kanal yapılandırması bilgilerini silecek. Devam etmek istediğinizden emin misiniz?",
    "channelConfigDeleteHeader": "Kanalı sil",
    "channelConfigDeleteOk": "Evet, sil",
    "channelConfigDeleteCancel": "Hayır, kalsın",
    "channelConfigLeaveMessage": "Bu belgede kaydedilmemiş değişiklikleriniz var. Bu sayfadan ayrılmak istediğinizden emin misiniz?",
    "channelConfigLeaveHeader": "Değişiklikleri at",
    "channelConfigLeaveOk": "Evet, sayfadan ayrıl",
    "channelConfigLeaveCancel": "Hayır, sayfada kal",
    "channelEdit": "Düzenle",
    "dialogPleaseWait": "Lütfen bekleyin...",
    "embedPanelTitle": "Bot ekleme kodu",
    "embedPanelDescription": "Bir kanalın ekleme kodunu almak için kanalı seçin. Kodu kopyalayıp web sitenize yapıştırın.",
    "embedPanelFacebookFooter": "Facebook, bu eklemeyi kullanabilmeniz için sayfanıza Facebook'un JavaScript SDK'sını eklemenizi gerektirir.",
    "embedPanelLearnMore": "Daha fazla bilgi edinin.",
    "embedPanelChannelMovedHeader": "%1 için ekleme kodu taşındı",
    "embedPanelChannelMovedInstructions": "%1 yapılandırma sayfasını açmak için buraya tıklayın",
    "embedPanelEmbedcodeForChannelLabel": "%1 için ekleme kodu",
    "embedPanelGettingCodes": "Kodlar alınıyor...",
    "embedPanelNoCodeAvailable": "Bu bot için kullanılabilir ekleme kodu yok.",
    "channelIssuesPanelSubtitle": "En son sorunlar",
    "channelIssuesPanelClearall": "Tümünü Temizle",
    "channelIssuesPanelTimeColumnLabel": "Saat",
    "channelIssuesPanelMessageColumnLabel": "İleti",
    "channelIssuesPanelCorrelationIdColumnLabel": "Bağıntı Kimliği",
    "unsavedChangesWillBeLost": "Kaydedilmeyen değişiklikler kaybolacak.",
    "altImageChannel": "%1 kanalını yapılandır",
    "Bing": "Bing",
    "Cortana": "Cortana",
    "MicrosoftSearch": "Microsoft Search",
    "DirectLine": "Doğrudan Hat",
    "Email": "E-posta",
    "FacebookMessenger": "Facebook Messenger",
    "GroupMe": "GroupMe",
    "Kaizala": "Kaizala",
    "Kik": "Kik",
    "MicrosoftTeams": "Microsoft Teams",
    "Skype": "Skype",
    "SkypeforBusiness": "Skype Kurumsal",
    "_SkypeforBusiness": "Skype Kurumsal markası",
    "Slack": "Slack",
    "Telegram": "Telegram",
    "Twilio": "Twilio (SMS)",
    "migrationBannerCTAMigrateBot": "BU BOTA GEÇİR",
    "migrationBannerCTAStartMigrating": "GEÇİŞİ BAŞLAT",
    "migrationBannerBlurb1": "Yeni Azure Bot Hizmeti'nin başlamasıyla, 31.03.2018 tarihi itibariyle tüm botları yeni hizmete geçiriyoruz.",
    "migrationBannerBlurb2": "geçiş hakkında.",
    "migrationBannerSuggestedBlurb": "Bu bot için Azure Bot Hizmeti'ne geçiş isteğe bağlıdır.",
    "migrationBannerPostDeadlineBlurb": "Azure Bot Hizmeti'ne taşıma gerektiren botlar hizmet kesintisi olmaması için şimdi taşınmalıdır.",
    "migrationBannerBlockedBlurb": "Bot taşıma işlemi gecikmiş. Hizmet kesintisi olmaması için lütfen şimdi taşıyın.",
    "migrationWillBeRequiredDialogMessage": "Bu kanalı yapılandırırsanız, botunuzun 31.03.2018 tarihine kadar Azure Bot Hizmeti'ne taşınması gerekir. Bu kanalı yapılandırmak istediğinizden emin misiniz?",
    "channelRequiresMigrationDialogMessage": "Bu kanal sadece Azure Bot Hizmeti'ndeki botların kullanımı içindir. Bu botu taşımak istiyor musunuz?",
    "channelRequiresABSBot": "Bu kanal sadece Azure Bot Hizmeti'ndeki botların kullanımına açıktır.",
    "botRequiresMigrationDialogHeader": "Botun taşınması gerekiyor",
    "botRequiresMigrationDialogMessage": "Bot taşıma işlemi gecikmiş. Hizmet kesintisi olmaması için lütfen şimdi taşıyın.",
    "yesMigrateThisBot": "Evet, bu botu taşı",
    "myBotsMigrationStatusMigrated": "Geçirildi",
    "myBotsMigrationStatusNotMigrated": "Gerekli",
    "myBotsMigrationStatusOptionalMigration": "Gerekli değil",
    "myBotsMigrationButtonMigrate": "Geçir",
    "myBotsMigrationButtonRollback": "Geçişi geri al",
    "deleteBotDialogDeleteButtonText": "Botu sil",
    "cancelButtonText": "İptal",
    "deleteBotDialogTitleText": "Bu botu silmek üzeresiniz",
    "deleteBotDialogBodyText": "Bu işlem, bu bot ile ilişkilendirilmiş tüm verileri siler ve geri alınamaz. Emin misiniz?",
    "deleteBotDialogStatusDeleting": "Bot siliniyor...",
    "deleteBotDialogStatusDeleted": "Bot silindi",
    "rollbackBotDialogRollbackButtonText": "Evet, geri al",
    "rollbackBotDialogTitleText": "Geri almak istediğinizden emin misiniz?",
    "rollbackBotDialogBodyText": "Bu işlem geçişi tamamen geri alır ve geçiş sürecini en baştan başlatmanız gerekir. Devam etmek istediğinizden emin misiniz?",
    "rollbackBotDialogErrorInfo": "Bot bilgileri sunucudan alınırken hata oluştu.",
    "rollbackBotDialogErrorNoEndpoint": "Geri alma gerçekleştirilemiyor. Hiçbir geri alma uç noktası bulunamadı.",
    "rollbackBotDialogErrorNoAzureToken": "Geri alma gerçekleştirilemiyor. Azure ile iletişime geçmek için Azure Belirteci bulunamadı.",
    "rollbackBotDialogStatusGettingInfo": "Bot bilgileri toplanıyor...",
    "rollbackBotDialogStatusPreparing": "Bot hazırlanıyor...",
    "rollbackBotDialogStatusReverting": "Bot önceki durumuna döndürülüyor...",
    "rollbackBotDialogStatusDeletingApp": "Yükseltilen uygulama siliniyor...",
    "rollbackBotDialogStatusDeletingDeployment": "Dağıtım kaydı siliniyor...",
    "rollbackBotDialogConfirmationTitleText": "Geri alma tamamlandı",
    "rollbackBotDialogConfirmationBodyText": "başarıyla geri alındı.",
    "okButtonText": "Tamam",
    "errorMessageErrorOccurred": "Bir hata oluştu",
    "migrationDialogStatusGettingBotInfo": "Bot bilgileri alınıyor...",
    "migrationDialogStatusGettingAzureInfo": "Azure bilgileri alınıyor...",
    "migrationDialogStatusGettingAppSettings": "Bot uygulaması ayarları alınıyor...",
    "migrationDialogStatusDeployingMigrationBot": "Geçirilen bot başlatılıyor...",
    "migrationDialogStatusRegisteringWithAzure": "Bot Hizmeti Azure'a kaydettiriliyor...",
    "migrationDialogStatusUpdatingBotRecord": "Bot kaydı güncelleniyor...",
    "migrationDialogStatusCreatingRG": "Kaynak grubu oluşturuluyor...",
    "migrationDialogStatusMigratingFiles": "Dosyalar yeni bota geçiriliyor...",
    "migrationDialogStatusWrappingUp": "Dağıtım tamamlanıyor...",
    "migrationDialogStatusDeployingStorage": "Bot, mevcut depolamaya bağlanıyor...",
    "migrationDialogStatusDeployingSite": "Web sitesi dağıtılıyor",
    "migrationDialogStatusConfiguringSite": "Web sitesi yapılandırılıyor",
    "migrationDialogStatusDeploying": "Dağıtılıyor",
    "migrationDialogStatusFunctionCredentials": "Yeni işlev uygulaması kimlik bilgileri alınıyor...",
    "migrationDialogErrorNoSubs": "Geçerli kullanıcı için hiçbir Azure aboneliği bulunamadı.",
    "migrationDialogErrorNoAzureToken": "Geçerli kullanıcı için Azure erişim belirteci bulunamadı.",
    "migrationDialogErrorNoLocations": "Seçili Azure aboneliği için hiçbir konum bulunamadı.",
    "migrationDialogErrorNoAzureStorage": "Uygulama yapılandırmasında Azure depolama hesabı adı bulunamadı.",
    "migrationDialogErrorAppNameUnavailable": "Uygulama adı kullanılamıyor.",
    "migrationDialogErrorAppNameInvalid": "Geçersiz uygulama adı.",
    "migrationDialogErrorNoBotType": "Geçerli bot geçerli bir türe sahip değil.",
    "migrationDialogErrorBotInvalid": "Bot geçersiz olduğu için bu bot geçirilemiyor.",
    "migrationDialogErrorEndpointMissing": "Uç noktası eksik olduğu için bu bot geçirilemiyor.",
    "migrationDialogErrorProvisionInfoMissing": "Sağlama bilgisi eksik olduğu için bu bot geçirilemiyor.",
    "migrationDialogErrorResourceGroupNameMissing": "Kaynak grubu adı eksik olduğu için bu bot geçirilemiyor.",
    "migrationDialogErrorSubscriptionIdMissing": "Azure abonelik kimliği eksik olduğu için bu bot geçirilemiyor.",
    "migrationDialogErrorSiteNameMissing": "Azure site adı eksik olduğu için bu bot geçirilemiyor.",
    "migrationDialogABSv2TitleText": "Geçiş kullanılamıyor",
    "migrationDialogABSv2BodyText": "Konuşma Tasarımcısı (ABSv2) botları için geçiş şu anda devre dışı.",
    "migrationDialogRegistrationBodyText": "\"{0}\" botları için geçiş şu anda devre dışı.",
    "migrationDialogFailedTokenRefresh": "Azure belirtecinin süresi doldu.",
    "migrationDialogRefreshPage": "Lütfen sayfayı yenileyin ve geçişi yeniden deneyin.",
    "migrationSubscriptionDisabled": "Seçili Azure aboneliği devre dışı. Lütfen geçişe devam etmek için etkinleştirin.",
    "migrationTenantHasNoSubscriptions": "Bu dizin hiçbir abonelik içermiyor.",
    "migrationDialogFuncPackBotTitle": "Bu botu taşımak için Azure İşlevleri Paketi gereklidir",
    "migrationDialogFuncPackBotMessage": "Düğüm İşlevleri botlarının taşınabilmesi için Azure İşlevleri Paketi ile paketlenmeleri gerekir.",
    "migrationDialogFuncPackBotLinkText": "Azure İşlevleri Paketini bot kodunuzda nasıl çalıştıracağınızı öğrenin",
    "tosDialog_Header": "Hizmet Şartları",
    "tosDialog_AgreeButton": "Kabul Et",
    "tosDialog_MessageChannels": "Çevrimiçi Hizmet Şartları, kanallardaki yayınlar için geçerli değildir. Örneğin Microsoft kanallarındaki yayınlara ilişkin şartlar, veri işleme şartları sunmamaktadır.",
    "tosDialog_MessageMigration": "Lütfen aşağıdaki şartları okuyun ve kabul edin.",
    "tosDialog_AzureTermsCheckbox": "Bot Framework sitesi kullanımımın {0} ve {1} hükümlerine tabi olduğunu kabul ederim.",
    "tosDialog_CortanaTermsCheckbox": "Cortana kanalına yönelik dağıtım işlemim için {0} ve {1} kabul ediyorum.",
    "tosDialog_CombinedTermsCheckboxOneChannel": "<%= channelslist %> kanalına yönelik dağıtım işlemim için {0} ve {1} kabul ediyorum.",
    "tosDialog_CombinedTermsCheckboxMultiChannels": "<%= channelslist %> kanallarına yönelik dağıtım işlemim için {0} ve {1} kabul ediyorum.",
    "tosDialog_ABSTerms": "Azure Bot Hizmeti için aboneliğimin şartları",
    "tosDialog_MSKnowledgeGraphTerms": "Cortana Kanalı Yayımlama Şartları",
    "tosDialog_MSPublicationTerms": "Microsoft Kanal Yayınlama Şartları",
    "tosDialog_MSPrivacyStatement": "Microsoft Gizlilik Bildirimlerini",
    "notice": " UYARI:",
    "listElem": "{0},",
    "andListEnd": "{0} ve {1}",
    "analyticsChannelsDropdown": "Kanal filtresi",
    "analyticsPeriodDropdown": "Zaman aralığı",
    "deprecatedChannel": "(kullanım dışı)",
    "openInComposer": "Composer'da aç",
    "downloadComposer": "Composer'ı indir",
}

const Resources_pt_br: IResources = {
    "unsupportedBrowser_Azure": "O Serviço de Bot do Azure ainda não oferece suporte ao seu navegador.",
    "unsupportedBrowser": "O Bot Framework ainda não dá suporte para seu navegador.",
    "botKindRegistration": "Bot Services Bot",
    "botKindSdk": "Web App Bot",
    "botKindFunctions": "Functions Bot",
    "botKindConversationDesigner": "Conversation Designer Bot",
    "loggingIn": "Fazendo login",
    "loadingBot": "Carregando bot...",
    "botIsNotReady": "Aguardando que o bot esteja pronto",
    "analyticsNotReady": "Aguardando que o Application Insights seja configurado",
    "authorizingWebChat": "Autorizando Chat com Bot",
    "signInFailure": "Ocorreu um erro na sua entrada. Verifique se cookies de terceiros estão habilitados no navegador.",
    "getChatTokenFailure": "Ocorreu um erro ao obter um token de autorização do Chat. Atualize e tente novamente.",
    "refreshSignInFailure": "Ocorreu um erro ao atualizar suas informações de entrada. Verifique se cookies de terceiros estão habilitados no navegador.",
    "xhrResponse_400": "A ação ou os valores fornecidos são inválidos.",
    "xhrResponse_403": "Este item não pode ser acessado ou modificado.",
    "xhrResponse_404": "O item não foi encontrado.",
    "xhrResponse_500": "Ocorreu um erro interno no servidor.",
    "xhrResponse_501": "Esta operação não tem suporte.",
    "xhrResponse_Message": "Erro: %1",
    "xhrResponse_Unknown": "Ocorreu um erro desconhecido.",
    "AddAFeaturedChannelTitle": "Adicionar um canal de destaque",
    "ConnectToChannelsTitle": "Conectar-se a canais",
    "NoChannelsConfigured": "Você ainda não se conectou a qualquer canal. Selecione um canal para se conectar.",
    "MoreChannelsTitle": "Mais canais",
    "test": "Exame",
    "startOver": "Recomeçar",
    "retentionTitle": "Retenção",
    "retentionDescription": "% usuários que enviaram a mensagem novamente (últimos 10 dias)",
    "retentionHeader": "Dias depois",
    "retentionDate": "Data",
    "retentionUsers": "Usuários",
    "undetermined": "Indeterminado",
    "loading": "carregando...",
    "noAnalyticsData": "sem dados",
    "timespanLastHour": "Última Hora",
    "timespanLastDay": "Último Dia",
    "timespanLastWeek": "Última Semana",
    "timespanLastMonth": "Último Mês",
    "timespanLast90Days": "Últimos 90 Dias",
    "timespanUnknown": "Período desconhecido",
    "timelineCardUsersTitle": "Usuários",
    "timelineCardMessagesTitle": "Atividades",
    "totalsCardTitle": "Totais Gerais",
    "analyticsNotConfigured": "Você ainda não habilitou Análises via Azure Application Insights.",
    "analyticsNotConfiguredAction": "Forneça as Chaves e ID do Application Insights para este bot na página a seguir: ",
    "analyticsNotConfiguredActionIbiza": "Forneça as Chaves e ID do Application Insights para este bot na página de configurações. ",
    "learnMore": "Saiba mais",
    "cardTitleLoading": "%1 - %2",
    "cardTitleError": "%1 - erro: %2",
    "timelineTableLabel": "Mapeamento de tabela de linha do tempo %1 por tempo",
    "timelineChartLabel": "Mapeamento de gráfico de linha do tempo %1 por tempo",
    "published": "Publicado",
    "health": "Integridade",
    "channelname": "Nome",
    "edit": "Editar",
    "running": "Corrida",
    "issuesTemplate": "Problemas (<%= length %>)",
    "warningTemplate": "Avisos (<%= length %>)",
    "channelPublished": "Publicado",
    "tryOnCortana": "Tente em <%= Name %> - saiba como",
    "tryOnChannel": "Tente em <%= Name %>",
    "manageInCortana": "Gerenciar no painel da Cortana",
    "channelRejected": "Rejeitado",
    "channelMoreDetails": "Mais detalhes",
    "channelResubmit": "Reenviar para análise...",
    "channelGetEmbedCodes": "Obter códigos de inserção de bot",
    "channelConfigDeleteMessage": "Esta ação excluirá todas as informações de configuração do canal. Tem certeza de que deseja continuar?",
    "channelConfigDeleteHeader": "Excluir canal",
    "channelConfigDeleteOk": "Sim, excluir",
    "channelConfigDeleteCancel": "Não, manter",
    "channelConfigLeaveMessage": "Não foram salvas alterações neste documento. Tem certeza de que deseja sair desta página?",
    "channelConfigLeaveHeader": "Descartar alterações",
    "channelConfigLeaveOk": "Sim, sair da página",
    "channelConfigLeaveCancel": "Não, permanecer na página",
    "channelEdit": "Editar",
    "dialogPleaseWait": "Aguarde...",
    "embedPanelTitle": "Código de inserção do bot",
    "embedPanelDescription": "Escolha um canal para obter o código de inserção para ele. Copie e cole o código em seu site.",
    "embedPanelFacebookFooter": "Para usar este código de inserção, o Facebook exige que você inclua o SDK do JavaScript dele em sua página.",
    "embedPanelLearnMore": "Saiba mais.",
    "embedPanelChannelMovedHeader": "O código de inserção para %1 foi movido",
    "embedPanelChannelMovedInstructions": "Clique aqui para abrir a página de configuração de %1",
    "embedPanelEmbedcodeForChannelLabel": "Código de inserção para %1",
    "embedPanelGettingCodes": "Obtendo códigos...",
    "embedPanelNoCodeAvailable": "Nenhum código de inserção disponível para este bot.",
    "channelIssuesPanelSubtitle": "Problemas recentes",
    "channelIssuesPanelClearall": "Limpar Tudo",
    "channelIssuesPanelTimeColumnLabel": "Hora",
    "channelIssuesPanelMessageColumnLabel": "Mensagem",
    "channelIssuesPanelCorrelationIdColumnLabel": "ID de Correlação",
    "unsavedChangesWillBeLost": "As alterações não salvas serão perdidas.",
    "altImageChannel": "Configurar canal %1",
    "Bing": "Bing",
    "Cortana": "Cortana",
    "MicrosoftSearch": "Microsoft Search",
    "DirectLine": "Direct Line",
    "Email": "Email",
    "FacebookMessenger": "Facebook Messenger",
    "GroupMe": "GroupMe",
    "Kaizala": "Kaizala",
    "Kik": "Kik",
    "MicrosoftTeams": "Microsoft Teams",
    "Skype": "Skype",
    "SkypeforBusiness": "Skype for Business",
    "_SkypeforBusiness": "Marca Skype for Business",
    "Slack": "Slack",
    "Telegram": "Telegram",
    "Twilio": "Twilio (SMS)",
    "migrationBannerCTAMigrateBot": "MIGRAR ESTE BOT",
    "migrationBannerCTAStartMigrating": "INICIAR MIGRAÇÃO",
    "migrationBannerBlurb1": "Com o lançamento do Serviço de Bot do Azure, estamos migrando todos os bots para o novo serviço até 31/03/2018.",
    "migrationBannerBlurb2": "sobre a migração.",
    "migrationBannerSuggestedBlurb": "A migração para o Serviço de Bot do Azure é opcional para este bot.",
    "migrationBannerPostDeadlineBlurb": "Os bots que requerem a migração para o Serviço de Bot do Azure devem migrar agora para evitar a interrupção do serviço.",
    "migrationBannerBlockedBlurb": "O prazo para a migração do bot venceu. Migre-o agora para evitar a interrupção do serviço.",
    "migrationWillBeRequiredDialogMessage": "Se você configurar este canal, seu bot deverá migrar para o Serviço de Bot do Azure até 31/3/2018. Tem certeza de que deseja configurar este canal?",
    "channelRequiresMigrationDialogMessage": "Este canal está disponível apenas para bots do Serviço de Bot do Azure. Deseja migrar este bot?",
    "channelRequiresABSBot": "Este canal está disponível apenas para bots do Serviço de Bot do Azure.",
    "botRequiresMigrationDialogHeader": "O bot requer migração",
    "botRequiresMigrationDialogMessage": "O prazo para a migração do bot venceu. Migre-o agora para evitar a interrupção do serviço.",
    "yesMigrateThisBot": "Sim, migrar este bot",
    "myBotsMigrationStatusMigrated": "Migração concluída",
    "myBotsMigrationStatusNotMigrated": "Obrigatório",
    "myBotsMigrationStatusOptionalMigration": "Não é obrigatório",
    "myBotsMigrationButtonMigrate": "Migrar",
    "myBotsMigrationButtonRollback": "Reverter migração",
    "deleteBotDialogDeleteButtonText": "Excluir bot",
    "cancelButtonText": "Cancelar",
    "deleteBotDialogTitleText": "Você está prestes a excluir este bot",
    "deleteBotDialogBodyText": "Este ação apagará todos os dados associados com este bot e não pode ser desfeita. Tem certeza?",
    "deleteBotDialogStatusDeleting": "Excluindo bot...",
    "deleteBotDialogStatusDeleted": "Bot excluído",
    "rollbackBotDialogRollbackButtonText": "Sim, reverter",
    "rollbackBotDialogTitleText": "Tem certeza de que deseja reverter?",
    "rollbackBotDialogBodyText": "Esta ação reverterá completamente a migração e você terá que iniciar o processo de migração novamente do início. Tem certeza de que deseja prosseguir?",
    "rollbackBotDialogErrorInfo": "Erro ao recuperar informações do bot do servidor.",
    "rollbackBotDialogErrorNoEndpoint": "Não é possível executar a reversão. Não foi encontrado nenhum ponto de extremidade de reversão.",
    "rollbackBotDialogErrorNoAzureToken": "Não é possível executar a reversão. Falha em localizar um Token do Azure para contatar o Azure.",
    "rollbackBotDialogStatusGettingInfo": "Reunindo informações do bot...",
    "rollbackBotDialogStatusPreparing": "Preparando bot...",
    "rollbackBotDialogStatusReverting": "Revertendo bot..",
    "rollbackBotDialogStatusDeletingApp": "Excluindo aplicativo com upgrade...",
    "rollbackBotDialogStatusDeletingDeployment": "Excluindo registro de implantação...",
    "rollbackBotDialogConfirmationTitleText": "Reversão concluída",
    "rollbackBotDialogConfirmationBodyText": "foi revertida com êxito.",
    "okButtonText": "Ok",
    "errorMessageErrorOccurred": "Ocorreu um erro",
    "migrationDialogStatusGettingBotInfo": "Obtendo as informações do bot...",
    "migrationDialogStatusGettingAzureInfo": "Obtendo as informações do Azure...",
    "migrationDialogStatusGettingAppSettings": "Obtendo as configurações de aplicativo do bot...",
    "migrationDialogStatusDeployingMigrationBot": "Inicializando o bot migrado...",
    "migrationDialogStatusRegisteringWithAzure": "Registrando o Serviço do Bot com o Azure...",
    "migrationDialogStatusUpdatingBotRecord": "Atualizando o registro do bot...",
    "migrationDialogStatusCreatingRG": "Criando um grupo de recursos...",
    "migrationDialogStatusMigratingFiles": "Migrando arquivos para o novo bot...",
    "migrationDialogStatusWrappingUp": "Finalizando implantação...",
    "migrationDialogStatusDeployingStorage": "Conectando o bot ao armazenamento...",
    "migrationDialogStatusDeployingSite": "Implantando o site",
    "migrationDialogStatusConfiguringSite": "Configurando o site",
    "migrationDialogStatusDeploying": "Implantando",
    "migrationDialogStatusFunctionCredentials": "Obtendo as novas credenciais de função do aplicativo...",
    "migrationDialogErrorNoSubs": "Falha em localizar as assinaturas do Azure para o usuário atual.",
    "migrationDialogErrorNoAzureToken": "Falha em localizar o token de acesso do Azure para o usuário atual.",
    "migrationDialogErrorNoLocations": "Falha em localizar os locais para a assinatura selecionada do Azure.",
    "migrationDialogErrorNoAzureStorage": "Falha em localizar o nome da conta de armazenamento do Azure na configuração do aplicativo.",
    "migrationDialogErrorAppNameUnavailable": "O nome do aplicativo não está disponível.",
    "migrationDialogErrorAppNameInvalid": "Nome de aplicativo inválido.",
    "migrationDialogErrorNoBotType": "O bot atual não tem um tipo válido.",
    "migrationDialogErrorBotInvalid": "Este bot não pode ser migrado porque ele é inválido.",
    "migrationDialogErrorEndpointMissing": "Este bot não pode ser migrado porque falta o ponto de extremidade.",
    "migrationDialogErrorProvisionInfoMissing": "Este bot não pode ser migrado porque não há informações de provisionamento.",
    "migrationDialogErrorResourceGroupNameMissing": "Este bot não pode ser migrado porque falta o nome do grupo de recursos.",
    "migrationDialogErrorSubscriptionIdMissing": "Este bot não pode ser migrado porque falta a ID da assinatura do Azure.",
    "migrationDialogErrorSiteNameMissing": "Este bot não pode ser migrado porque falta o nome do site do Azure.",
    "migrationDialogABSv2TitleText": "Migração indisponível",
    "migrationDialogABSv2BodyText": "A migração está desabilitada atualmente para os bots (ABSv2) do Designer de Conversa.",
    "migrationDialogRegistrationBodyText": "No momento, a migração está desabilitada para '{0}' bots.",
    "migrationDialogFailedTokenRefresh": "O token do Azure expirou.",
    "migrationDialogRefreshPage": "Atualize a página e tente a migração novamente.",
    "migrationSubscriptionDisabled": "A assinatura selecionada do Azure está desabilitada. Habilite-a para prosseguir com a migração.",
    "migrationTenantHasNoSubscriptions": "Este diretório não contém nenhuma assinatura.",
    "migrationDialogFuncPackBotTitle": "O Azure Functions Pack é necessário para a migração deste bot",
    "migrationDialogFuncPackBotMessage": "Os bots de Node Functions precisam ser empacotados com o Azure Functions Pack antes de poderem ser migrados.",
    "migrationDialogFuncPackBotLinkText": "Saiba como executar o Azure Functions Pack no código do seu bot",
    "tosDialog_Header": "Termos do Serviço",
    "tosDialog_AgreeButton": "Concordar",
    "tosDialog_MessageChannels": "Os Termos dos Serviços Online não se aplicam à publicação em canais. Por exemplo, os termos para a publicação em canais da Microsoft não oferecem termos de processamento de dados.",
    "tosDialog_MessageMigration": "Leia e concorde com os termos a seguir.",
    "tosDialog_AzureTermsCheckbox": "Concordo que o uso do site do Bot Framework está sujeito dos {0} e a {1}.",
    "tosDialog_CortanaTermsCheckbox": "Concordo com os {0} e a {1} para minha implantação do canal Cortana.",
    "tosDialog_CombinedTermsCheckboxOneChannel": "Concordo com os {0} e a {1} para minha implantação do canal <%= channelslist %>.",
    "tosDialog_CombinedTermsCheckboxMultiChannels": "Concordo com os {0} e a {1} para minha implantação dos canais <%= channelslist %>.",
    "tosDialog_ABSTerms": "termos da minha assinatura do Serviço de Bot do Azure",
    "tosDialog_MSKnowledgeGraphTerms": "Termos de Publicação de Canal da Cortana",
    "tosDialog_MSPublicationTerms": "Termos de Publicação dos Canais da Microsoft",
    "tosDialog_MSPrivacyStatement": "Políticas de Privacidade da Microsoft",
    "notice": " AVISO: ",
    "listElem": "{0},",
    "andListEnd": "{0} e {1}",
    "analyticsChannelsDropdown": "Filtro Canais",
    "analyticsPeriodDropdown": "Período de tempo",
    "deprecatedChannel": "(preterido)",
    "openInComposer": "abrir no Composer",
    "downloadComposer": "Baixar o Composer",
}

const Resources_pt_pt: IResources = {
    "unsupportedBrowser_Azure": "O Azure Bot Service ainda não suporta o seu browser.",
    "unsupportedBrowser": "O Bot Framework ainda não suporta o seu browser.",
    "botKindRegistration": "Bot Services Bot",
    "botKindSdk": "Web App Bot",
    "botKindFunctions": "Functions Bot",
    "botKindConversationDesigner": "Conversation Designer Bot",
    "loggingIn": "A iniciar sessão",
    "loadingBot": "A carregar o bot...",
    "botIsNotReady": "A aguardar que o bot esteja preparado",
    "analyticsNotReady": "A aguardar que o Application Insights seja configurado",
    "authorizingWebChat": "A Autorizar o Chat com o Bot",
    "signInFailure": "Ocorreu um erro ao iniciar a sua sessão. Certifique-se de que os cookies de terceiros estão ativados no browser.",
    "getChatTokenFailure": "Ocorreu um erro ao obter um token de autorização de Chat. Atualize e tente novamente.",
    "refreshSignInFailure": "Ocorreu um erro ao atualizar as suas informações de início de sessão. Certifique-se de que os cookies de terceiros estão ativados no browser.",
    "xhrResponse_400": "A ação ou os valores fornecidos são inválidos.",
    "xhrResponse_403": "Não é possível aceder ou modificar este item.",
    "xhrResponse_404": "Não é possível localizar o item.",
    "xhrResponse_500": "Ocorreu um erro interno no servidor.",
    "xhrResponse_501": "Esta operação não é suportada.",
    "xhrResponse_Message": "Erro: %1",
    "xhrResponse_Unknown": "Ocorreu um erro desconhecido.",
    "AddAFeaturedChannelTitle": "Adicionar um canal em destaque",
    "ConnectToChannelsTitle": "Ligar aos canais",
    "NoChannelsConfigured": "Ainda não ligou nenhum canal. Selecione um canal para ligar.",
    "MoreChannelsTitle": "Mais canais",
    "test": "Testar",
    "startOver": "Recomeçar",
    "retentionTitle": "Retenção",
    "retentionDescription": "% de utilizadores que enviaram mensagens novamente (últimos 10 dias)",
    "retentionHeader": "Dias mais tarde",
    "retentionDate": "Data",
    "retentionUsers": "Utilizadores",
    "undetermined": "Indeterminado",
    "loading": "a carregar...",
    "noAnalyticsData": "sem dados",
    "timespanLastHour": "Última Hora",
    "timespanLastDay": "Último Dia",
    "timespanLastWeek": "Última Semana",
    "timespanLastMonth": "Último Mês",
    "timespanLast90Days": "Últimos 90 Dias",
    "timespanUnknown": "Período de tempo desconhecido",
    "timelineCardUsersTitle": "Utilizadores",
    "timelineCardMessagesTitle": "Atividades",
    "totalsCardTitle": "Totais Gerais",
    "analyticsNotConfigured": "Ainda não ativou a Análise através do Azure Application Insights.",
    "analyticsNotConfiguredAction": "Forneça as Chaves e o ID do Application Insights para este bot na página seguinte: ",
    "analyticsNotConfiguredActionIbiza": "Forneça as Chaves e o ID do Application Insights para este bot na página de definições. ",
    "learnMore": "Mais informações",
    "cardTitleLoading": "%1 - %2",
    "cardTitleError": "%1 - erro: %2",
    "timelineTableLabel": "Mapeamento de tabelas de linha cronológica de %1 por hora",
    "timelineChartLabel": "Mapeamento de gráficos de linha cronológica de %1 por hora",
    "published": "Publicado",
    "health": "Estado de Funcionamento",
    "channelname": "Nome",
    "edit": "Editar",
    "running": "Em execução",
    "issuesTemplate": "Problemas (<%= length %>)",
    "warningTemplate": "Avisos (<%= length %>)",
    "channelPublished": "Publicado",
    "tryOnCortana": "Experimentar em <%= Name %> - saiba como",
    "tryOnChannel": "Experimentar em <%= Name %>",
    "manageInCortana": "Gerir no dashboard da Cortana",
    "channelRejected": "Rejeitado",
    "channelMoreDetails": "Mais detalhes",
    "channelResubmit": "Submeter novamente para revisão...",
    "channelGetEmbedCodes": "Obter códigos de incorporação do bot",
    "channelConfigDeleteMessage": "Esta ação irá eliminar todas as informações de configuração do canal. Tem a certeza de que pretende continuar?",
    "channelConfigDeleteHeader": "Eliminar canal",
    "channelConfigDeleteOk": "Sim, eliminar",
    "channelConfigDeleteCancel": "Não, manter",
    "channelConfigLeaveMessage": "Tem alterações não guardadas neste documento. Tem a certeza de que pretende sair desta página?",
    "channelConfigLeaveHeader": "Eliminar alterações",
    "channelConfigLeaveOk": "Sim, sair da página",
    "channelConfigLeaveCancel": "Não, ficar na página",
    "channelEdit": "Editar",
    "dialogPleaseWait": "Aguarde...",
    "embedPanelTitle": "Código de incorporação do bot",
    "embedPanelDescription": "Escolha um canal para obter o código de incorporação deste. Copie e cole o código no seu site.",
    "embedPanelFacebookFooter": "Para utilizar esta incorporação, o Facebook necessita que inclua o respetivo JavaScript SDK na sua página.",
    "embedPanelLearnMore": "Mais informações.",
    "embedPanelChannelMovedHeader": "O código de incorporação para %1 foi movido",
    "embedPanelChannelMovedInstructions": "Clique aqui para abrir a página de configuração de %1",
    "embedPanelEmbedcodeForChannelLabel": "Código de incorporação para %1",
    "embedPanelGettingCodes": "A obter os códigos...",
    "embedPanelNoCodeAvailable": "Não existe nenhum código de incorporação disponível para este bot.",
    "channelIssuesPanelSubtitle": "Problemas recentes",
    "channelIssuesPanelClearall": "Limpar Tudo",
    "channelIssuesPanelTimeColumnLabel": "Hora",
    "channelIssuesPanelMessageColumnLabel": "Mensagem",
    "channelIssuesPanelCorrelationIdColumnLabel": "ID de Correlação",
    "unsavedChangesWillBeLost": "As alterações não guardadas serão perdidas.",
    "altImageChannel": "Configurar o canal %1",
    "Bing": "Bing",
    "Cortana": "Cortana",
    "MicrosoftSearch": "Microsoft Search",
    "DirectLine": "Direct Line",
    "Email": "E-mail",
    "FacebookMessenger": "Facebook Messenger",
    "GroupMe": "GroupMe",
    "Kaizala": "Kaizala",
    "Kik": "Kik",
    "MicrosoftTeams": "Microsoft Teams",
    "Skype": "Skype",
    "SkypeforBusiness": "Skype para Empresas",
    "_SkypeforBusiness": "Marca Skype para Empresas",
    "Slack": "Slack",
    "Telegram": "Telegram",
    "Twilio": "Twilio (SMS)",
    "migrationBannerCTAMigrateBot": "MIGRAR ESTE BOT",
    "migrationBannerCTAStartMigrating": "INICIAR MIGRAÇÃO",
    "migrationBannerBlurb1": "Com o lançamento do novo Azure Bot Service, estamos a migrar todos os bots para o novo serviço até 31/03/2018.",
    "migrationBannerBlurb2": "acerca da migração.",
    "migrationBannerSuggestedBlurb": "A migração para o Azure Bot Service é opcional para este bot.",
    "migrationBannerPostDeadlineBlurb": "Os bots que necessitam de migração para o Azure Bot Service têm de ser migrados agora para evitar a interrupção do serviço.",
    "migrationBannerBlockedBlurb": "A migração do bot está em atraso. Migre-o agora para evitar a interrupção do serviço.",
    "migrationWillBeRequiredDialogMessage": "Se configurar este canal, o seu bot terá de ser migrado para o Azure Bot Service até 31/03/2018. Tem a certeza de que pretende configurar este canal?",
    "channelRequiresMigrationDialogMessage": "Esta canal só está disponível para bots no Azure Bot Service. Pretende migrar este bot?",
    "channelRequiresABSBot": "Esta canal só está disponível para bots no Azure Bot Service.",
    "botRequiresMigrationDialogHeader": "O bot necessita de migração",
    "botRequiresMigrationDialogMessage": "A migração do bot está em atraso. Migre-o agora para evitar a interrupção do serviço.",
    "yesMigrateThisBot": "Sim, migrar este bot",
    "myBotsMigrationStatusMigrated": "Migrado",
    "myBotsMigrationStatusNotMigrated": "Obrigatório",
    "myBotsMigrationStatusOptionalMigration": "Não necessário",
    "myBotsMigrationButtonMigrate": "Migrar",
    "myBotsMigrationButtonRollback": "Reverter migração",
    "deleteBotDialogDeleteButtonText": "Eliminar bot",
    "cancelButtonText": "Cancelar",
    "deleteBotDialogTitleText": "Está prestes a eliminar este bot",
    "deleteBotDialogBodyText": "Esta ação irá apagar todos os dados associados a este bot e não pode ser anulada. Tem a certeza?",
    "deleteBotDialogStatusDeleting": "A eliminar o bot...",
    "deleteBotDialogStatusDeleted": "Bot eliminado",
    "rollbackBotDialogRollbackButtonText": "Sim, reverter",
    "rollbackBotDialogTitleText": "Tem a certeza de que pretende reverter?",
    "rollbackBotDialogBodyText": "Esta ação irá reverter totalmente a migração e terá de iniciar o processo de migração a partir do princípio. Tem a certeza de que pretende continuar?",
    "rollbackBotDialogErrorInfo": "Erro ao obter informações do bot a partir do servidor.",
    "rollbackBotDialogErrorNoEndpoint": "Não é possível efetuar a reversão. Não foi encontrado nenhum ponto final de reversão.",
    "rollbackBotDialogErrorNoAzureToken": "Não é possível efetuar a reversão. Falha ao localizar um Token do Azure para contactar o Azure.",
    "rollbackBotDialogStatusGettingInfo": "A recolher informações do bot...",
    "rollbackBotDialogStatusPreparing": "A preparar o bot...",
    "rollbackBotDialogStatusReverting": "A reverter o bot...",
    "rollbackBotDialogStatusDeletingApp": "A eliminar a aplicação atualizada...",
    "rollbackBotDialogStatusDeletingDeployment": "A eliminar o registo de implementação...",
    "rollbackBotDialogConfirmationTitleText": "Reversão concluída",
    "rollbackBotDialogConfirmationBodyText": "foi revertido com êxito.",
    "okButtonText": "OK",
    "errorMessageErrorOccurred": "Ocorreu um erro",
    "migrationDialogStatusGettingBotInfo": "A obter informações do bot...",
    "migrationDialogStatusGettingAzureInfo": "A obter informações do Azure...",
    "migrationDialogStatusGettingAppSettings": "A obter as definições da aplicação de bot...",
    "migrationDialogStatusDeployingMigrationBot": "A inicializar o bot migrado...",
    "migrationDialogStatusRegisteringWithAzure": "A registar o Bot Service no Azure...",
    "migrationDialogStatusUpdatingBotRecord": "A atualizar o registo do bot...",
    "migrationDialogStatusCreatingRG": "A criar o grupo de recursos...",
    "migrationDialogStatusMigratingFiles": "A migrar os ficheiros para o novo bot...",
    "migrationDialogStatusWrappingUp": "A concluir a implementação...",
    "migrationDialogStatusDeployingStorage": "A ligar o bot ao armazenamento existente...",
    "migrationDialogStatusDeployingSite": "A implementar o site",
    "migrationDialogStatusConfiguringSite": "A configurar o site",
    "migrationDialogStatusDeploying": "A implementar",
    "migrationDialogStatusFunctionCredentials": "A obter as novas credenciais da aplicação de funções...",
    "migrationDialogErrorNoSubs": "Falha ao localizar quaisquer subscrições do Azure para o utilizador atual.",
    "migrationDialogErrorNoAzureToken": "Falha ao localizar o token de acesso do Azure para o utilizador atual.",
    "migrationDialogErrorNoLocations": "Falha ao localizar quaisquer localizações para a subscrição do Azure selecionada.",
    "migrationDialogErrorNoAzureStorage": "Falha ao localizar o nome de uma conta de armazenamento do Azure na configuração da aplicação.",
    "migrationDialogErrorAppNameUnavailable": "O nome da aplicação não está disponível.",
    "migrationDialogErrorAppNameInvalid": "Nome de aplicação inválido.",
    "migrationDialogErrorNoBotType": "O bot atual não tem um tipo válido.",
    "migrationDialogErrorBotInvalid": "Não é possível migrar este bot porque o mesmo é inválido.",
    "migrationDialogErrorEndpointMissing": "Não é possível migrar este bot porque o ponto final está em falta.",
    "migrationDialogErrorProvisionInfoMissing": "Não é possível migrar este bot porque as informações de aprovisionamento estão em falta.",
    "migrationDialogErrorResourceGroupNameMissing": "Não é possível migrar este bot porque o nome do grupo de recursos está em falta.",
    "migrationDialogErrorSubscriptionIdMissing": "Não é possível migrar este bot porque o ID da subscrição do Azure está em falta.",
    "migrationDialogErrorSiteNameMissing": "Não é possível migrar este bot porque o nome do site do Azure está em falta.",
    "migrationDialogABSv2TitleText": "Migração indisponível",
    "migrationDialogABSv2BodyText": "A migração está atualmente desativada para bots do Estruturador de Conversações (ABSv2).",
    "migrationDialogRegistrationBodyText": "A migração está atualmente desativada para bots de \"{0}\".",
    "migrationDialogFailedTokenRefresh": "O token do Azure expirou.",
    "migrationDialogRefreshPage": "Atualize a página e tente efetuar a migração novamente.",
    "migrationSubscriptionDisabled": "A subscrição do Azure selecionada está desativada. Ative-a para continuar a migração.",
    "migrationTenantHasNoSubscriptions": "Este diretório não contém nenhuma subscrição.",
    "migrationDialogFuncPackBotTitle": "O Pack de Funções do Azure é necessário para migrar este bot",
    "migrationDialogFuncPackBotMessage": "Os bots de Funções de Nó tem de ser empacotados com o Pack de Funções do Azure antes de poderem ser migrados.",
    "migrationDialogFuncPackBotLinkText": "Obter informações sobre como executar o Pack de Funções do Azure no código do seu bot",
    "tosDialog_Header": "Termos de Serviço",
    "tosDialog_AgreeButton": "Aceito",
    "tosDialog_MessageChannels": "Os Termos dos Serviços Online não se aplicam à publicação em canais. Por exemplo, os termos de publicação em canais da Microsoft não oferecem termos de processamento de dados.",
    "tosDialog_MessageMigration": "Leia e aceite os termos seguintes.",
    "tosDialog_AzureTermsCheckbox": "Aceito que a utilização do site do Bot Framework esteja sujeita aos {0} e às {1}.",
    "tosDialog_CortanaTermsCheckbox": "Aceito os {0} e as {1} para a minha implementação no canal da Cortana.",
    "tosDialog_CombinedTermsCheckboxOneChannel": "Aceito os {0} e as {1} para a minha implementação no canal <%= channelslist %>.",
    "tosDialog_CombinedTermsCheckboxMultiChannels": "Aceito os {0} e as {1} para a minha implementação nos canais <%= channelslist %>.",
    "tosDialog_ABSTerms": "termos da minha subscrição do Azure Bot Service",
    "tosDialog_MSKnowledgeGraphTerms": "Termos de Publicação de Canais da Cortana",
    "tosDialog_MSPublicationTerms": "Termos de Publicação de Canais da Microsoft",
    "tosDialog_MSPrivacyStatement": "Declarações de Privacidade da Microsoft",
    "notice": " AVISO: ",
    "listElem": "{0}, ",
    "andListEnd": "{0} e {1}",
    "analyticsChannelsDropdown": "Filtro de canais",
    "analyticsPeriodDropdown": "Período de tempo",
    "deprecatedChannel": "(preterido)",
    "openInComposer": "abrir no Composer",
    "downloadComposer": "Transferir Composer",
}

const Resources_zh_hans: IResources = {
    "unsupportedBrowser_Azure": "Azure 机器人服务尚不支持你的浏览器。",
    "unsupportedBrowser": "Bot Framework 尚不支持你的浏览器。",
    "botKindRegistration": "Bot Services Bot",
    "botKindSdk": "Web App Bot",
    "botKindFunctions": "Functions Bot",
    "botKindConversationDesigner": "Conversation Designer Bot",
    "loggingIn": "正在登录",
    "loadingBot": "正在加载机器人...",
    "botIsNotReady": "等待机器人准备就绪",
    "analyticsNotReady": "正在等待配置 Application Insights",
    "authorizingWebChat": "正在授权与机器人聊天",
    "signInFailure": "登录时出错。请确保浏览器中启用了第三方 Cookie。",
    "getChatTokenFailure": "获取聊天授权令牌时出错。请刷新并重试。",
    "refreshSignInFailure": "刷新你的登录信息时出错。请确保浏览器中启用了第三方 Cookie。",
    "xhrResponse_400": "该操作或提供的值无效。",
    "xhrResponse_403": "无法访问或修改此项。",
    "xhrResponse_404": "找不到该项。",
    "xhrResponse_500": "服务器发生内部错误。",
    "xhrResponse_501": "不支持此操作。",
    "xhrResponse_Message": "错误: %1",
    "xhrResponse_Unknown": "发生未知错误。",
    "AddAFeaturedChannelTitle": "添加一个特色信道",
    "ConnectToChannelsTitle": "连接至信道",
    "NoChannelsConfigured": "你尚未连接任何信道。请选择一个信道进行连接。",
    "MoreChannelsTitle": "更多信道",
    "test": "测试",
    "startOver": "重新开始",
    "retentionTitle": "保留",
    "retentionDescription": "重发消息联系的用户百分比(%)(过去 10 天)",
    "retentionHeader": "几天后",
    "retentionDate": "日期",
    "retentionUsers": "用户",
    "undetermined": "未决定",
    "loading": "正在加载...",
    "noAnalyticsData": "无数据",
    "timespanLastHour": "前一个小时",
    "timespanLastDay": "昨天",
    "timespanLastWeek": "上周",
    "timespanLastMonth": "上个月",
    "timespanLast90Days": "过去 90 天",
    "timespanUnknown": "未知时间跨度",
    "timelineCardUsersTitle": "用户",
    "timelineCardMessagesTitle": "活动",
    "totalsCardTitle": "总计",
    "analyticsNotConfigured": "你尚未通过 Azure Application Insights 启用分析。",
    "analyticsNotConfiguredAction": "在以下页面中为此机器人提供 Application Insights 密钥和 ID: ",
    "analyticsNotConfiguredActionIbiza": "在设置页面中为此机器人提供 Application Insights 密钥和 ID。",
    "learnMore": "了解更多",
    "cardTitleLoading": "%1 - %2",
    "cardTitleError": "%1 - 错误: %2",
    "timelineTableLabel": "时间表映射%1(按时间)",
    "timelineChartLabel": "时间图表映射%1(按时间)",
    "published": "已发布",
    "health": "运行状况",
    "channelname": "名称",
    "edit": "编辑",
    "running": "正在运行",
    "issuesTemplate": "问题(<%= length %>)",
    "warningTemplate": "警告(<%= length %>)",
    "channelPublished": "已发布",
    "tryOnCortana": "尝试 <%= Name %> - 了解操作方法",
    "tryOnChannel": "尝试 <%= Name %>",
    "manageInCortana": "在 Cortana 仪表板中管理",
    "channelRejected": "已拒绝",
    "channelMoreDetails": "更多详细信息",
    "channelResubmit": "重新提交以供审查...",
    "channelGetEmbedCodes": "获取机器人嵌入代码",
    "channelConfigDeleteMessage": "此操作将删除所有信道配置信息。是否确定要继续?",
    "channelConfigDeleteHeader": "删除信道",
    "channelConfigDeleteOk": "是，删除它",
    "channelConfigDeleteCancel": "否，继续保留",
    "channelConfigLeaveMessage": "该文档中有未保存的更改。是否确定要离开此页面?",
    "channelConfigLeaveHeader": "放弃更改",
    "channelConfigLeaveOk": "是，离开页面",
    "channelConfigLeaveCancel": "否，留在该页面",
    "channelEdit": "编辑",
    "dialogPleaseWait": "请稍候...",
    "embedPanelTitle": "机器人嵌入代码",
    "embedPanelDescription": "选择一个信道以获取其嵌入代码。将该代码复制并粘贴到你的网站。",
    "embedPanelFacebookFooter": "要使用该嵌入，Facebook 要求你的页面中包含他们的 JavaScript SDK。",
    "embedPanelLearnMore": "了解更多。",
    "embedPanelChannelMovedHeader": "%1 的嵌入代码已移动",
    "embedPanelChannelMovedInstructions": "单击此处以打开 %1 配置页面",
    "embedPanelEmbedcodeForChannelLabel": "%1 的嵌入代码",
    "embedPanelGettingCodes": "正在获取代码...",
    "embedPanelNoCodeAvailable": "无可用于此机器人的嵌入代码。",
    "channelIssuesPanelSubtitle": "最新问题",
    "channelIssuesPanelClearall": "全部清除",
    "channelIssuesPanelTimeColumnLabel": "时间",
    "channelIssuesPanelMessageColumnLabel": "消息",
    "channelIssuesPanelCorrelationIdColumnLabel": "相关 ID",
    "unsavedChangesWillBeLost": "未保存的更改将丢失。",
    "altImageChannel": "配置 %1 信道",
    "Bing": "必应",
    "Cortana": "Cortana",
    "MicrosoftSearch": "Microsoft Search",
    "DirectLine": "Direct Line",
    "Email": "电子邮件",
    "FacebookMessenger": "Facebook Messenger",
    "GroupMe": "GroupMe",
    "Kaizala": "Kaizala",
    "Kik": "Kik",
    "MicrosoftTeams": "Microsoft Teams",
    "Skype": "Skype",
    "SkypeforBusiness": "Skype for Business",
    "_SkypeforBusiness": "Skype for Business 品牌",
    "Slack": "Slack",
    "Telegram": "Telegram",
    "Twilio": "Twilio (短信)",
    "migrationBannerCTAMigrateBot": "迁移此机器人",
    "migrationBannerCTAStartMigrating": "开始迁移",
    "migrationBannerBlurb1": "随着新的 Azure 机器人服务的发布，我们将在 2018 年 3 月 31 日之前将所有机器人迁移到新服务。",
    "migrationBannerBlurb2": "关于迁移。",
    "migrationBannerSuggestedBlurb": "对于此机器人，迁移到 Azure 机器人服务为可选操作。",
    "migrationBannerPostDeadlineBlurb": "为了避免服务中断，必须立即迁移需要迁移到 Azure 机器人服务的机器人。",
    "migrationBannerBlockedBlurb": "机器人迁移已过期，请立即迁移机器人以避免服务中断。",
    "migrationWillBeRequiredDialogMessage": "如果你配置此信道，则你的机器人将需要在 2018 年 3 月 31 日之前迁移到 Azure 机器人服务。是否确定要配置此信道?",
    "channelRequiresMigrationDialogMessage": "此信道仅适用于 Azure 机器人服务中的机器人。是否要迁移此机器人?",
    "channelRequiresABSBot": "此频道仅适用于 Azure 机器人服务中的机器人。",
    "botRequiresMigrationDialogHeader": "机器人需要迁移",
    "botRequiresMigrationDialogMessage": "机器人迁移已过期，请立即迁移机器人以避免服务中断。",
    "yesMigrateThisBot": "是，迁移此机器人",
    "myBotsMigrationStatusMigrated": "已迁移",
    "myBotsMigrationStatusNotMigrated": "必需",
    "myBotsMigrationStatusOptionalMigration": "不需要",
    "myBotsMigrationButtonMigrate": "迁移",
    "myBotsMigrationButtonRollback": "回滚迁移",
    "deleteBotDialogDeleteButtonText": "删除机器人",
    "cancelButtonText": "取消",
    "deleteBotDialogTitleText": "你将要删除此机器人",
    "deleteBotDialogBodyText": "此操作将擦除与此机器人关联的所有数据且无法撤销。是否确定?",
    "deleteBotDialogStatusDeleting": "正在删除机器人...",
    "deleteBotDialogStatusDeleted": "机器人已删除",
    "rollbackBotDialogRollbackButtonText": "是，回滚",
    "rollbackBotDialogTitleText": "是否确实要回滚?",
    "rollbackBotDialogBodyText": "此操作将完全回滚迁移，你将不得不从头开始迁移过程。是否确实要继续?",
    "rollbackBotDialogErrorInfo": "从服务器检索机器人信息时出错。",
    "rollbackBotDialogErrorNoEndpoint": "无法执行回滚。找不到回滚终结点。",
    "rollbackBotDialogErrorNoAzureToken": "无法执行回滚。未能找到用于联系 Azure 的 Azure 令牌。",
    "rollbackBotDialogStatusGettingInfo": "正在收集机器人信息...",
    "rollbackBotDialogStatusPreparing": "正在准备机器人...",
    "rollbackBotDialogStatusReverting": "正在恢复机器人..",
    "rollbackBotDialogStatusDeletingApp": "正在删除已升级的应用...",
    "rollbackBotDialogStatusDeletingDeployment": "正在删除部署记录...",
    "rollbackBotDialogConfirmationTitleText": "回滚已完成",
    "rollbackBotDialogConfirmationBodyText": "已成功回滚。",
    "okButtonText": "确定",
    "errorMessageErrorOccurred": "出现错误",
    "migrationDialogStatusGettingBotInfo": "正在获取机器人信息...",
    "migrationDialogStatusGettingAzureInfo": "正在获取 Azure 信息…",
    "migrationDialogStatusGettingAppSettings": "正在获取机器人应用设置...",
    "migrationDialogStatusDeployingMigrationBot": "正在初始化已迁移的机器人...",
    "migrationDialogStatusRegisteringWithAzure": "正在向 Azure 注册机器人服务...",
    "migrationDialogStatusUpdatingBotRecord": "正在更新机器人记录...",
    "migrationDialogStatusCreatingRG": "正在创建资源组…",
    "migrationDialogStatusMigratingFiles": "正在将文件迁移到新的机器人...",
    "migrationDialogStatusWrappingUp": "正在完成部署...",
    "migrationDialogStatusDeployingStorage": "正在将机器人连接到现有存储...",
    "migrationDialogStatusDeployingSite": "正在部署网站",
    "migrationDialogStatusConfiguringSite": "正在配置网站",
    "migrationDialogStatusDeploying": "正在部署",
    "migrationDialogStatusFunctionCredentials": "正在获取新的功能应用凭据...",
    "migrationDialogErrorNoSubs": "未能找到当前用户的任何 Azure 订阅。",
    "migrationDialogErrorNoAzureToken": "未能找到当前用户的 Azure 访问令牌。",
    "migrationDialogErrorNoLocations": "未能找到所选 Azure 订阅的任何位置。",
    "migrationDialogErrorNoAzureStorage": "未能在应用程序配置中找到 Azure 存储帐户名称。",
    "migrationDialogErrorAppNameUnavailable": "应用名称不可用。",
    "migrationDialogErrorAppNameInvalid": "应用名称无效。",
    "migrationDialogErrorNoBotType": "当前机器人没有有效类型。",
    "migrationDialogErrorBotInvalid": "由于机器人无效，无法迁移此机器人。",
    "migrationDialogErrorEndpointMissing": "由于终结点缺失，无法迁移此机器人。",
    "migrationDialogErrorProvisionInfoMissing": "由于预配信息缺失，无法迁移此机器人。",
    "migrationDialogErrorResourceGroupNameMissing": "由于资源组名称缺失，无法迁移此机器人。",
    "migrationDialogErrorSubscriptionIdMissing": "由于 Azure 订阅 ID 缺失，无法迁移此机器人。",
    "migrationDialogErrorSiteNameMissing": "由于 Azure 站点名称缺失，无法迁移此机器人。",
    "migrationDialogABSv2TitleText": "迁移不可用",
    "migrationDialogABSv2BodyText": "目前已对对话设计器(ABSv2)机器人禁用迁移。",
    "migrationDialogRegistrationBodyText": "目前已对“{0}”机器人禁用迁移。",
    "migrationDialogFailedTokenRefresh": "Azure 令牌已过期。",
    "migrationDialogRefreshPage": "请刷新页面并重新尝试迁移。",
    "migrationSubscriptionDisabled": "所选 Azure 订阅已禁用。请启用以继续迁移。",
    "migrationTenantHasNoSubscriptions": "该目录不包含任何订阅。",
    "migrationDialogFuncPackBotTitle": "若要迁移此机器人，需要 Azure Functions 包",
    "migrationDialogFuncPackBotMessage": "节点功能机器人需要与 Azure Functions 包一起打包，才能进行迁移。",
    "migrationDialogFuncPackBotLinkText": "了解如何在你的机器人代码上运行 Azure Functions 包",
    "tosDialog_Header": "服务条款",
    "tosDialog_AgreeButton": "同意",
    "tosDialog_MessageChannels": "Online Services 条款不适用于有关信道的发布。例如，有关 Microsoft 信道发布的条款不提供数据处理条款。",
    "tosDialog_MessageMigration": "请阅读并同意以下条款。",
    "tosDialog_AzureTermsCheckbox": "我同意 Bot Framework 站点的使用受 {0} 和 {1} 的约束。",
    "tosDialog_CortanaTermsCheckbox": "对 Cortana 信道的部署，我同意 {0} 和 {1}。",
    "tosDialog_CombinedTermsCheckboxOneChannel": "对 <%= channelslist %> 信道的部署，我同意 {0} 和 {1}。",
    "tosDialog_CombinedTermsCheckboxMultiChannels": "对 <%= channelslist %> 信道的部署，我同意 {0} 和 {1}。",
    "tosDialog_ABSTerms": "我的 Azure 机器人服务订阅的条款",
    "tosDialog_MSKnowledgeGraphTerms": "Cortana 信道发布条款",
    "tosDialog_MSPublicationTerms": "Microsoft 信道发布条款",
    "tosDialog_MSPrivacyStatement": "Microsoft 隐私声明",
    "notice": " 通知: ",
    "listElem": "{0}、",
    "andListEnd": "{0} 和 {1}",
    "analyticsChannelsDropdown": "信道筛选器",
    "analyticsPeriodDropdown": "时间段",
    "deprecatedChannel": "(已弃用)",
    "openInComposer": "在编辑器中打开",
    "downloadComposer": "下载编辑器",
}

const Resources_zh_hant: IResources = {
    "unsupportedBrowser_Azure": "Azure Bot 服務尚未支援您的瀏覽器。",
    "unsupportedBrowser": "Bot Framework 尚未支援您的瀏覽器。",
    "botKindRegistration": "Bot Services Bot",
    "botKindSdk": "Web App Bot",
    "botKindFunctions": "Functions Bot",
    "botKindConversationDesigner": "Conversation Designer Bot",
    "loggingIn": "正在登入...",
    "loadingBot": "載入機器人...",
    "botIsNotReady": "等待機器人設定完成",
    "analyticsNotReady": "等候 Application Insights 設定完成",
    "authorizingWebChat": "授權與機器人交談",
    "signInFailure": "當您登入時發生錯誤。請確定已在瀏覽器中啟用第三方 cookie。",
    "getChatTokenFailure": "獲得交談授權權杖時發生錯誤。重新整理並再次嘗試。",
    "refreshSignInFailure": "重新整理您的登入資訊時發生錯誤。請確定已在瀏覽器中啟用第三方 cookie。",
    "xhrResponse_400": "此動作或提供的值無效。",
    "xhrResponse_403": "此項目無法存取或修改。",
    "xhrResponse_404": "找不到此項目。",
    "xhrResponse_500": "伺服器發生內部錯誤。",
    "xhrResponse_501": "不支援這項作業。",
    "xhrResponse_Message": "錯誤: %1",
    "xhrResponse_Unknown": "發生未知的錯誤。",
    "AddAFeaturedChannelTitle": "新增熱門頻道",
    "ConnectToChannelsTitle": "連線至頻道",
    "NoChannelsConfigured": "您尚未連線至任何頻道。選取頻道以連線。",
    "MoreChannelsTitle": "更多頻道",
    "test": "測試",
    "startOver": "重新開始",
    "retentionTitle": "保留期",
    "retentionDescription": "% 再次傳送訊息的的使用者 (近10天)",
    "retentionHeader": "天後",
    "retentionDate": "日期",
    "retentionUsers": "使用者",
    "undetermined": "未定",
    "loading": "正在載入...",
    "noAnalyticsData": "無資料",
    "timespanLastHour": "過去一小時",
    "timespanLastDay": "過去一天",
    "timespanLastWeek": "過去一週",
    "timespanLastMonth": "過去一個月",
    "timespanLast90Days": "過去 90 天",
    "timespanUnknown": "未知的時間跨度",
    "timelineCardUsersTitle": "使用者",
    "timelineCardMessagesTitle": "活動",
    "totalsCardTitle": "總計",
    "analyticsNotConfigured": "您尚未透過 Azure Application Insights 啟用分析。",
    "analyticsNotConfiguredAction": "在下列頁面中為此機器人提供您的 Application Insights 金鑰與識別碼: ",
    "analyticsNotConfiguredActionIbiza": "在設定頁面上為此機器人提供您的 Application Insights 金鑰與識別碼。",
    "learnMore": "深入了解",
    "cardTitleLoading": "%1 - %2",
    "cardTitleError": "%1 - 錯誤: %2",
    "timelineTableLabel": "依時間的時間軸表格對應%1",
    "timelineChartLabel": "依時間的時間軸圖表對應%1",
    "published": "已發佈",
    "health": "健康",
    "channelname": "名稱",
    "edit": "編輯",
    "running": "跑步",
    "issuesTemplate": "問題 (<%= length %>)",
    "warningTemplate": "警告 (<%= length %>)",
    "channelPublished": "已發佈",
    "tryOnCortana": "嘗試 <%= Name %> - 學習方法",
    "tryOnChannel": "嘗試 <%= Name %>",
    "manageInCortana": "在 Cortana 儀表板中管理",
    "channelRejected": "已拒絕",
    "channelMoreDetails": "更多細節",
    "channelResubmit": "重新提交供檢閱...",
    "channelGetEmbedCodes": "取得機器人內嵌程式碼",
    "channelConfigDeleteMessage": "此動作將會刪除所有頻道的設定資訊. 您是否確定要繼續?",
    "channelConfigDeleteHeader": "刪除頻道",
    "channelConfigDeleteOk": "是，刪除它",
    "channelConfigDeleteCancel": "否，保留它",
    "channelConfigLeaveMessage": "您在此文件中有未儲存的變更. 您是否確定要離開此頁面?",
    "channelConfigLeaveHeader": "捨棄變更",
    "channelConfigLeaveOk": "是，離開頁面",
    "channelConfigLeaveCancel": "不，留在此頁面",
    "channelEdit": "編輯",
    "dialogPleaseWait": "請稍候...",
    "embedPanelTitle": "機器人內嵌程式碼",
    "embedPanelDescription": "選擇一個頻道，並取得其內嵌程式碼。複製並將程式碼貼至您的網站上。",
    "embedPanelFacebookFooter": "為了使用此 Facebook 內嵌，您的頁面上必須包含他們的 JavaScript SDK。",
    "embedPanelLearnMore": "深入了解。",
    "embedPanelChannelMovedHeader": "%1 的內嵌程式碼已移除",
    "embedPanelChannelMovedInstructions": "按這裡開啟 %1 設定頁",
    "embedPanelEmbedcodeForChannelLabel": "%1 的內嵌程式碼",
    "embedPanelGettingCodes": "取得代碼...",
    "embedPanelNoCodeAvailable": "此機器人沒有可用的內嵌程式碼。",
    "channelIssuesPanelSubtitle": "最近的問題",
    "channelIssuesPanelClearall": "全部清除",
    "channelIssuesPanelTimeColumnLabel": "時間",
    "channelIssuesPanelMessageColumnLabel": "訊息",
    "channelIssuesPanelCorrelationIdColumnLabel": "相互關聯識別碼",
    "unsavedChangesWillBeLost": "未儲存的變更將會遺失。",
    "altImageChannel": "設定 %1 頻道",
    "Bing": "Bing",
    "Cortana": "Cortana",
    "MicrosoftSearch": "Microsoft Search",
    "DirectLine": "Direct Line",
    "Email": "電子郵件",
    "FacebookMessenger": "Facebook Messenger",
    "GroupMe": "GroupMe",
    "Kaizala": "Kaizala",
    "Kik": "Kik",
    "MicrosoftTeams": "Microsoft Teams",
    "Skype": "Skype",
    "SkypeforBusiness": "商務用 Skype",
    "_SkypeforBusiness": "商務用 Skype 商標",
    "Slack": "Slack",
    "Telegram": "Telegram",
    "Twilio": "Twilio (SMS)",
    "migrationBannerCTAMigrateBot": "移轉此機器人",
    "migrationBannerCTAStartMigrating": "開始移轉",
    "migrationBannerBlurb1": "隨著新 Azure 機器人服務的啟用，我們會在 2018 年 3 月 31 號前將所有機器人移轉至新服務。",
    "migrationBannerBlurb2": "關於移轉。",
    "migrationBannerSuggestedBlurb": "此機器人可自由選擇是否要轉移至 Azure 機器人服務。",
    "migrationBannerPostDeadlineBlurb": "需要轉移至 Azure 機器人服務的機器人必須立即轉移，避免服務中斷。",
    "migrationBannerBlockedBlurb": "機器人轉移已經過期，請立即轉移以避免服務中斷。",
    "migrationWillBeRequiredDialogMessage": "如果您設定這個頻道, 您的機器人會被要求在 2018 年 3 月 31 日前轉移至 Azure 機器人服務. 您確定要設定此頻道嗎?",
    "channelRequiresMigrationDialogMessage": "只有這個頻道適用有 Azure 機器人服務的機器人. 您要轉移這個機器人嗎?",
    "channelRequiresABSBot": "這個頻道只適用Azure Bot 服務的 Bot。",
    "botRequiresMigrationDialogHeader": "機器人需要轉移",
    "botRequiresMigrationDialogMessage": "機器人轉移已經過期，請立即轉移以避免服務中斷。",
    "yesMigrateThisBot": "是，轉移此機器人",
    "myBotsMigrationStatusMigrated": "已移轉",
    "myBotsMigrationStatusNotMigrated": "必要項目",
    "myBotsMigrationStatusOptionalMigration": "非必填",
    "myBotsMigrationButtonMigrate": "移轉",
    "myBotsMigrationButtonRollback": "復原移轉",
    "deleteBotDialogDeleteButtonText": "刪除機器人",
    "cancelButtonText": "取消",
    "deleteBotDialogTitleText": "您即將刪除此機器人",
    "deleteBotDialogBodyText": "這動作會清除此機器人的所有相關資料, 且無法復原. 是否確定要清除?",
    "deleteBotDialogStatusDeleting": "正在刪除機器人...",
    "deleteBotDialogStatusDeleted": "機器人已刪除",
    "rollbackBotDialogRollbackButtonText": "確定復原",
    "rollbackBotDialogTitleText": "您確定要復原?",
    "rollbackBotDialogBodyText": "此動作將會完全復原移轉, 您必須從頭開始移轉程序. 是否確定要繼續?",
    "rollbackBotDialogErrorInfo": "從伺服器擷取機器人資訊時發生錯誤。",
    "rollbackBotDialogErrorNoEndpoint": "無法執行復原。找不到復原端點。",
    "rollbackBotDialogErrorNoAzureToken": "無法執行復原。找不到 Azure權杖以連絡 Azure。",
    "rollbackBotDialogStatusGettingInfo": "正在收集機器人資訊...",
    "rollbackBotDialogStatusPreparing": "正在準備機器人...",
    "rollbackBotDialogStatusReverting": "正在還原機器人...",
    "rollbackBotDialogStatusDeletingApp": "正在刪除已升級的應用程式...",
    "rollbackBotDialogStatusDeletingDeployment": "正在刪除部署記錄...",
    "rollbackBotDialogConfirmationTitleText": "復原完成",
    "rollbackBotDialogConfirmationBodyText": "已成功地復原移轉。",
    "okButtonText": "確定",
    "errorMessageErrorOccurred": "發生錯誤",
    "migrationDialogStatusGettingBotInfo": "正在取得機器人資訊...",
    "migrationDialogStatusGettingAzureInfo": "正在取得 Azure 資訊...",
    "migrationDialogStatusGettingAppSettings": "正在取得機器人應用程式設定...",
    "migrationDialogStatusDeployingMigrationBot": "正在初始化已移轉的機器人...",
    "migrationDialogStatusRegisteringWithAzure": "正在向 Azure 註冊機器人服務...",
    "migrationDialogStatusUpdatingBotRecord": "正在更新機器人記錄...",
    "migrationDialogStatusCreatingRG": "正在建立資源群組...",
    "migrationDialogStatusMigratingFiles": "正在將檔案移轉到新的機器人...",
    "migrationDialogStatusWrappingUp": "正在完成部署...",
    "migrationDialogStatusDeployingStorage": "正在將機器人連線到現有的儲存體...",
    "migrationDialogStatusDeployingSite": "部署網站",
    "migrationDialogStatusConfiguringSite": "設定網站",
    "migrationDialogStatusDeploying": "部署",
    "migrationDialogStatusFunctionCredentials": "正在取得新的函數應用程式認證...",
    "migrationDialogErrorNoSubs": "找不到任何目前使用者的 Azure 訂用帳戶。",
    "migrationDialogErrorNoAzureToken": "找不到目前使用者的 Azure 存取權杖。",
    "migrationDialogErrorNoLocations": "找不到任何已選取的 Azure 訂用帳戶的位置。",
    "migrationDialogErrorNoAzureStorage": "無法在應用程式設定中找到 Azure 儲存體帳戶。",
    "migrationDialogErrorAppNameUnavailable": "應用程式名稱無法使用。",
    "migrationDialogErrorAppNameInvalid": "無效的應用程式名稱。",
    "migrationDialogErrorNoBotType": "目前的機器人並沒有有效的類別。",
    "migrationDialogErrorBotInvalid": "由於此機器人無效，無法移轉此機器人。",
    "migrationDialogErrorEndpointMissing": "由於端點遺失，無法移轉此機器人。",
    "migrationDialogErrorProvisionInfoMissing": "由於佈建資訊遺失，無法移轉此機器人。",
    "migrationDialogErrorResourceGroupNameMissing": "由於資源群組的名稱遺失，無法移轉此機器人。",
    "migrationDialogErrorSubscriptionIdMissing": "由於 Azure 訂訂用帳戶的名稱遺失，無法移轉此機器人。",
    "migrationDialogErrorSiteNameMissing": "由於 Azure 站點的名稱遺失，無法移轉此機器人。",
    "migrationDialogABSv2TitleText": "無法使用的移轉",
    "migrationDialogABSv2BodyText": "移轉功能目前因對話設計 (ABSv2) 機器人而停用。",
    "migrationDialogRegistrationBodyText": "'{0}' 機器人目前無法移轉。",
    "migrationDialogFailedTokenRefresh": "Azure 權杖已經過期。",
    "migrationDialogRefreshPage": "請重新整理頁面，再次嘗試移轉。",
    "migrationSubscriptionDisabled": "選取的 Azure 訂用帳戶已停用。請啟用以繼續移轉。",
    "migrationTenantHasNoSubscriptions": "此目錄未包含任何訂閱。",
    "migrationDialogFuncPackBotTitle": "需要 Azure Functions 套件才能移轉此 Bot",
    "migrationDialogFuncPackBotMessage": "節點函數 Bot 必須在可以被移轉前，隨附在 Azure Functions 套件上。",
    "migrationDialogFuncPackBotLinkText": "了解如何在您 Bot 程式碼上執行 Azure Functions 套件",
    "tosDialog_Header": "服務條款",
    "tosDialog_AgreeButton": "同意",
    "tosDialog_MessageChannels": "線上服務條款並不適用於通道上的發行。例如，Microsoft 通道上發佈的條款並不包括資料處理條款。",
    "tosDialog_MessageMigration": "請閱讀並同意以下條款。",
    "tosDialog_AzureTermsCheckbox": "我同意 Bot Framework 的用途主要是 {0} 和 {1}。",
    "tosDialog_CortanaTermsCheckbox": "我同意將 {0} 和 {1} 部署至 Cortana 通道。",
    "tosDialog_CombinedTermsCheckboxOneChannel": "我同意將 {0} 和 {1} 部署至 <%= channelslist %> 通道。",
    "tosDialog_CombinedTermsCheckboxMultiChannels": "我同意將 {0} 和 {1} 部署至 <%= channelslist %> 通道。",
    "tosDialog_ABSTerms": "我的 Azure 機器人服務訂用帳戶條款",
    "tosDialog_MSKnowledgeGraphTerms": "Cortana 頻道發佈條款",
    "tosDialog_MSPublicationTerms": "Microsoft 通道公開條款",
    "tosDialog_MSPrivacyStatement": "Microsoft 隱私權聲明",
    "notice": "注意: ",
    "listElem": "{0}，",
    "andListEnd": "{0} 和 {1}",
    "analyticsChannelsDropdown": "通道篩選器",
    "analyticsPeriodDropdown": "時間週期",
    "deprecatedChannel": "(已過時)",
    "openInComposer": "在 Composer 中開啟",
    "downloadComposer": "下載 Composer",
}

const Resources_id: IResources = {
    "unsupportedBrowser_Azure": "Azure Bot Service belum mendukung browser Anda.",
    "unsupportedBrowser": "Kerangkat kerja bot belum mendukung browser Anda.",
    "botKindRegistration": "Bot Services Bot",
    "botKindSdk": "Web App Bot",
    "botKindFunctions": "Functions Bot",
    "botKindConversationDesigner": "Conversation Designer Bot",
    "loggingIn": "Masuk",
    "loadingBot": "Memuat bot...",
    "botIsNotReady": "Menunggu agar bot siap",
    "analyticsNotReady": "Menunggu Application Insights untuk dikonfigurasi",
    "authorizingWebChat": "Mengotorisasi Chat dengan Bot",
    "signInFailure": "Terjadi kesalahan saat memproses Anda masuk. Pastikan cookie pihak ketiga diaktifkan di browser.",
    "getChatTokenFailure": "Terjadi kesalahan saat mendapatkan token otorisasi Obrolan. Segarkan dan coba lagi.",
    "refreshSignInFailure": "Terjadi kesalahan saat menyegarkan informasi masuk. Pastikan cookie pihak ketiga diaktifkan di browser.",
    "xhrResponse_400": "Tindakan atau nilai yang diberikan tidak valid.",
    "xhrResponse_403": "Item ini tidak dapat diakses atau diubah.",
    "xhrResponse_404": "Item tidak dapat ditemukan.",
    "xhrResponse_500": "Terjadi kesalahan internal di server.",
    "xhrResponse_501": "Operasi ini tidak didukung.",
    "xhrResponse_Message": "Kesalahan: %1",
    "xhrResponse_Unknown": "Terjadi kesalahan yang tidak dikenal.",
    "AddAFeaturedChannelTitle": "Tambahkan saluran unggulan",
    "ConnectToChannelsTitle": "Sambungkan ke saluran",
    "NoChannelsConfigured": "Anda belum memiliki saluran yang terhubung. Pilih saluran yang akan dihubungkan.",
    "MoreChannelsTitle": "Lebih banyak saluran",
    "test": "Uji",
    "startOver": "Mulai dari awal",
    "retentionTitle": "Retensi",
    "retentionDescription": "% pengguna yang mengirim pesan lagi (10 hari terakhir)",
    "retentionHeader": "Hari kemudian",
    "retentionDate": "Tanggal",
    "retentionUsers": "Pengguna",
    "undetermined": "Tidak ditentukan",
    "loading": "memuat...",
    "noAnalyticsData": "tidak ada data",
    "timespanLastHour": "Jam Terakhir",
    "timespanLastDay": "Hari Terakhir",
    "timespanLastWeek": "Minggu Lalu",
    "timespanLastMonth": "Bulan Lalu",
    "timespanLast90Days": "90 Hari Terakhir",
    "timespanUnknown": "Timespan tidak diketahui",
    "timelineCardUsersTitle": "Pengguna",
    "timelineCardMessagesTitle": "Aktivitas",
    "totalsCardTitle": "Total Akhir",
    "analyticsNotConfigured": "Anda belum mengaktifkan Analytics melalui Azure Application Insights.",
    "analyticsNotConfiguredAction": "Berikan Kunci dan ID Application Insights Anda untuk bot ini di halaman berikut: ",
    "analyticsNotConfiguredActionIbiza": "Berikan Kunci dan ID Application Insights Anda untuk bot ini pada halaman pengaturan.",
    "learnMore": "Pelajari lebih lanjut",
    "cardTitleLoading": "%1 - %2",
    "cardTitleError": "%1 - kesalahan: %2",
    "timelineTableLabel": "Pemetaan tabel garis waktu %1 berdasarkan waktu",
    "timelineChartLabel": "Pemetaan diagram garis waktu %1",
    "published": "Diterbitkan",
    "health": "Kesehatan",
    "actions": "Tindakan",
    "channelname": "Nama",
    "edit": "Edit",
    "running": "Berjalan",
    "issuesTemplate": "Masalah (<%= length %>)",
    "warningTemplate": "Peringatan (<%= length %>)",
    "channelPublished": "Diterbitkan",
    "tryOnCortana": "Coba di <%= Name %> - pelajari caranya",
    "tryOnChannel": "Coba di <%= Name %>",
    "manageInCortana": "Kelola di dasbor Cortana",
    "channelRejected": "Ditolak",
    "channelMoreDetails": "Detail selengkapnya",
    "channelResubmit": "Kirim ulang untuk ditinjau...",
    "channelGetEmbedCodes": "Dapatkan kode semat bot",
    "channelConfigDeleteMessage": "Tindakan ini akan menghapus semua informasi konfigurasi saluran. Yakin ingin melanjutkan?",
    "channelConfigDeleteHeader": "Hapus saluran",
    "channelConfigDeleteOk": "Ya, hapus",
    "channelConfigDeleteCancel": "Tidak, pertahankan",
    "channelConfigLeaveMessage": "Anda memiliki perubahan yang belum disimpan dalam dokumen ini. Yakin ingin beralih dari halaman ini?",
    "channelConfigLeaveHeader": "Batalkan perubahan",
    "channelConfigLeaveOk": "Ya, keluar dari halaman",
    "channelConfigLeaveCancel": "Tidak, tetap di halaman",
    "channelEdit": "Edit",
    "dialogPleaseWait": "Tunggu...",
    "embedPanelTitle": "Kode semat bot",
    "embedPanelDescription": "Pilih saluran untuk mendapatkan kode semat. Salin dan tempelkan kode ke situs web Anda.",
    "embedPanelFacebookFooter": "Agar dapat menggunakan Facebook semat ini, Anda harus menyertakan SDK JavaScript-nya di halaman Anda.",
    "embedPanelLearnMore": "Pelajari selengkapnya.",
    "embedPanelChannelMovedHeader": "Kode semat untuk %1 telah dipindahkan",
    "embedPanelChannelMovedInstructions": "Klik di sini untuk membuka halaman konfigurasi %1",
    "embedPanelEmbedcodeForChannelLabel": "Kode semat untuk %1",
    "embedPanelGettingCodes": "Mengambil kode...",
    "embedPanelNoCodeAvailable": "Tidak ada kode semat yang tersedia untuk bot ini.",
    "channelIssuesPanelSubtitle": "Masalah terbaru",
    "channelIssuesPanelClearall": "Hapus Semua",
    "channelIssuesPanelTimeColumnLabel": "Waktu",
    "channelIssuesPanelMessageColumnLabel": "Pesan",
    "channelIssuesPanelCorrelationIdColumnLabel": "ID Korelasi",
    "unsavedChangesWillBeLost": "Perubahan yang belum disimpan akan hilang.",
    "altImageChannel": "Konfigurasikan saluran %1",
    "Bing": "Bing",
    "Cortana": "Cortana",
    "MicrosoftSearch": "Microsoft Search",
    "DirectLine": "Saluran Langsung",
    "Email": "Email",
    "FacebookMessenger": "Facebook Messenger",
    "GroupMe": "GroupMe",
    "Kaizala": "Kaizala",
    "Kik": "Kik",
    "MicrosoftTeams": "Microsoft Teams",
    "Skype": "Skype",
    "SkypeforBusiness": "Skype for Business",
    "_SkypeforBusiness": "Merek Skype for Business",
    "Slack": "Slack",
    "Telegram": "Telegram",
    "Twilio": "Twilio (SMS)",
    "migrationBannerCTAMigrateBot": "MIGRASIKAN BOT INI",
    "migrationBannerCTAStartMigrating": "MULAI MIGRASI",
    "migrationBannerBlurb1": "Dengan peluncuran Azure Bot Service baru, kami memigrasikan semua bot ke layanan baru ini paling lambat pada 31/3/2018.",
    "migrationBannerBlurb2": "tentang migrasi.",
    "migrationBannerSuggestedBlurb": "Migrasi ke Azure Bot Service bersifat opsional untuk bot ini.",
    "migrationBannerPostDeadlineBlurb": "Bot yang memerlukan migrasi ke Azure Bot Service harus dimigrasikan sekarang untuk menghindari gangguan layanan.",
    "migrationBannerBlockedBlurb": "Migrasi bot sudah lewat jatuh tempo, harap migrasikan sekarang untuk menghindari gangguan layanan.",
    "migrationWillBeRequiredDialogMessage": "Jika Anda mengonfigurasi saluran ini, bot Anda akan diperlukan untuk bermigrasi ke layanan Azure bot paling lambat pada 31/3/2018. Yakin ingin mengonfigurasi saluran ini?",
    "channelRequiresMigrationDialogMessage": "Saluran ini hanya tersedia untuk bot di Azure Bot Service. Ingin memigrasikan bot ini?",
    "channelRequiresABSBot": "Saluran ini hanya tersedia untuk bot di Azure Bot Service.",
    "botRequiresMigrationDialogHeader": "Bot memerlukan migrasi",
    "botRequiresMigrationDialogMessage": "Migrasi bot sudah lewat jatuh tempo, harap migrasikan sekarang untuk menghindari gangguan layanan.",
    "yesMigrateThisBot": "Ya, migrasikan bot ini",
    "myBotsMigrationStatusMigrated": "Dimigrasikan",
    "myBotsMigrationStatusNotMigrated": "Diperlukan",
    "myBotsMigrationStatusOptionalMigration": "Tidak diperlukan",
    "myBotsMigrationButtonMigrate": "Migrasi",
    "myBotsMigrationButtonRollback": "Gulung balik migrasi",
    "deleteBotDialogDeleteButtonText": "Hapus bot",
    "cancelButtonText": "Batal",
    "deleteBotDialogTitleText": "Anda akan menghapus bot ini",
    "deleteBotDialogBodyText": "Tindakan ini akan menghapus semua data yang terkait dengan bot ini dan tidak dapat diurungkan. Anda yakin?",
    "deleteBotDialogStatusDeleting": "Menghapus bot...",
    "deleteBotDialogStatusDeleted": "Bot dihapus",
    "rollbackBotDialogRollbackButtonText": "Ya, gulung balik",
    "rollbackBotDialogTitleText": "Yakin ingin menggulung balik?",
    "rollbackBotDialogBodyText": "Tindakan ini akan mengembalikan sepenuhnya migrasi dan Anda harus memulai proses migrasi dari awal. Anda yakin ingin melanjutkan?",
    "rollbackBotDialogErrorInfo": "Terjadi kesalahan saat mengambil informasi bot dari server.",
    "rollbackBotDialogErrorNoEndpoint": "Tidak dapat menggulung balik. Tidak ada titik akhir gulung balik yang ditemukan.",
    "rollbackBotDialogErrorNoAzureToken": "Tidak dapat menggulung balik. Gagal menemukan token Azure untuk menghubungi Azure.",
    "rollbackBotDialogStatusGettingInfo": "Mengumpulkan info bot...",
    "rollbackBotDialogStatusPreparing": "Menyiapkan bot...",
    "rollbackBotDialogStatusReverting": "Mengembalikan bot..",
    "rollbackBotDialogStatusDeletingApp": "Menghapus aplikasi yang ditingkatkan...",
    "rollbackBotDialogStatusDeletingDeployment": "Menghapus data penyebaran...",
    "rollbackBotDialogConfirmationTitleText": "Penggulungan kembali selesai",
    "rollbackBotDialogConfirmationBodyText": "berhasil digulung kembali.",
    "okButtonText": "Oke",
    "errorMessageErrorOccurred": "Terjadi kesalahan",
    "migrationDialogStatusGettingBotInfo": "Mengambil info bot...",
    "migrationDialogStatusGettingAzureInfo": "Mendapatkan info Azure...",
    "migrationDialogStatusGettingAppSettings": "Mendapatkan pengaturan aplikasi bot...",
    "migrationDialogStatusDeployingMigrationBot": "Menginisialisasi bot yang dimigrasikan...",
    "migrationDialogStatusRegisteringWithAzure": "Mendaftarkan Layanan Bot dengan Azure...",
    "migrationDialogStatusUpdatingBotRecord": "Memperbarui catatan bot...",
    "migrationDialogStatusCreatingRG": "Membuat grup sumber daya...",
    "migrationDialogStatusMigratingFiles": "Memigrasi file ke bot baru...",
    "migrationDialogStatusWrappingUp": "Membungkus penyebaran...",
    "migrationDialogStatusDeployingStorage": "Menyambungkan bot ke penyimpanan yang ada...",
    "migrationDialogStatusDeployingSite": "Menyebarkan situs web",
    "migrationDialogStatusConfiguringSite": "Mengonfigurasi situs web",
    "migrationDialogStatusDeploying": "Menyebarkan",
    "migrationDialogStatusFunctionCredentials": "Mendapatkan kredensial aplikasi fungsi baru...",
    "migrationDialogErrorNoSubs": "Gagal menemukan langganan Azure untuk pengguna saat ini.",
    "migrationDialogErrorNoAzureToken": "Gagal menemukan token akses Azure untuk pengguna saat ini.",
    "migrationDialogErrorNoLocations": "Gagal menemukan lokasi apa pun untuk langganan Azure yang dipilih.",
    "migrationDialogErrorNoAzureStorage": "Gagal menemukan nama akun penyimpanan Azure di konfigurasi aplikasi.",
    "migrationDialogErrorAppNameUnavailable": "Nama domain tidak tersedia.",
    "migrationDialogErrorAppNameInvalid": "Nama aplikasi tidak valid.",
    "migrationDialogErrorNoBotType": "Bot saat ini tidak memiliki tipe yang valid.",
    "migrationDialogErrorBotInvalid": "Bot ini tidak dapat dimigrasikan karena bot tidak valid.",
    "migrationDialogErrorEndpointMissing": "Bot ini tidak dapat dimigrasikan karena titik akhir tidak ada.",
    "migrationDialogErrorProvisionInfoMissing": "Bot ini tidak dapat dimigrasikan karena info penyediaan tidak ada.",
    "migrationDialogErrorResourceGroupNameMissing": "Bot ini tidak dapat dimigrasikan karena nama grup sumber daya tidak ada.",
    "migrationDialogErrorSubscriptionIdMissing": "Bot ini tidak dapat dimigrasikan karena id langganan Azure tidak ada.",
    "migrationDialogErrorSiteNameMissing": "Bot ini tidak dapat dimigrasikan karena nama situs Azure tidak ada.",
    "migrationDialogABSv2TitleText": "Migrasi tidak tersedia",
    "migrationDialogABSv2BodyText": "Migrasi saat ini dinonaktifkan untuk bot Desainer Percakapan (ABSv2).",
    "migrationDialogRegistrationBodyText": "Migrasi saat ini dinonaktifkan untuk bot '{0}'.",
    "migrationDialogFailedTokenRefresh": "Token Azure telah kedaluwarsa.",
    "migrationDialogRefreshPage": "Segarkan halaman dan coba lagi migrasi.",
    "migrationSubscriptionDisabled": "Langganan Azure yang dipilih dinonaktifkan. Aktifkan untuk melanjutkan migrasi.",
    "migrationTenantHasNoSubscriptions": "Direktori ini tidak berisi langganan apa pun.",
    "migrationDialogFuncPackBotTitle": "Paket Azure Functions diperlukan untuk memigrasikan bot ini",
    "migrationDialogFuncPackBotMessage": "Bot fungsi node harus dikemas dengan paket Azure Functions sebelum dapat dimigrasikan.",
    "migrationDialogFuncPackBotLinkText": "Pelajari cara menjalankan Azure Functions Pack pada kode bot Anda",
    "tosDialog_Header": "Ketentuan Layanan",
    "tosDialog_AgreeButton": "Setuju",
    "tosDialog_MessageChannels": "Ketentuan Layanan Online tidak berlaku untuk publikasi di saluran. Misalnya, persyaratan untuk publikasi di saluran Microsoft tidak menawarkan persyaratan pemrosesan data.",
    "tosDialog_MessageMigration": "Harap baca dan setujui persyaratan berikut.",
    "tosDialog_AzureTermsCheckbox": "Saya setuju bahwa penggunaan situs kerangka bot tunduk pada {0} dan {1}.",
    "tosDialog_CortanaTermsCheckbox": "Saya menyetujui {0} dan {1} untuk penyebaran saya ke saluran Cortana.",
    "tosDialog_CombinedTermsCheckboxOneChannel": "Saya menyetujui {0} dan {1} untuk penyebaran saya ke saluran <%= channelslist %>.",
    "tosDialog_CombinedTermsCheckboxMultiChannels": "Saya menyetujui {0} dan {1} untuk penyebaran saya ke saluran <%= channelslist %>.",
    "tosDialog_ABSTerms": "ketentuan langganan saya untuk Azure Bot Service",
    "tosDialog_MSKnowledgeGraphTerms": "Ketentuan Publikasi Saluran Cortana",
    "tosDialog_MSPublicationTerms": "Ketentuan Publikasi Saluran Microsoft",
    "tosDialog_MSPrivacyStatement": "Pernyataan Privasi Microsoft",
    "notice": " PEMBERITAHUAN: ",
    "listElem": "{0}, ",
    "andListEnd": "{0} dan {1}",
    "analyticsChannelsDropdown": "Filter saluran",
    "analyticsPeriodDropdown": "Periode waktu",
    "deprecatedChannel": "(tidak digunakan lagi)",
    "openInComposer": "buka di penyusun",
    "downloadComposer": "Unduh penyusun"
}

const ResourcesMap: { [key: string]: IResources } = {
    "de": Resources_de,
    "es": Resources_es,
    "fr": Resources_fr,
    "it": Resources_it,
    "id": Resources_id,
    "ja": Resources_ja,
    "ko": Resources_ko,
    "ru": Resources_ru,
    "cs": Resources_cs,
    "nl": Resources_nl,
    "hu": Resources_hu,
    "pl": Resources_pl,
    "sv": Resources_sv,
    "tr": Resources_tr,
    "pt-br": Resources_pt_br,
    "pt-pt": Resources_pt_pt,
    "zh-hans": Resources_zh_hans,
    "zh-hant": Resources_zh_hant,
}




// WEBPACK FOOTER //
// ./Client/Resources/Intercom.Resources.DevPortal.ts